/*jshint esversion: 6 */
window.theme = window.theme || {};
/* ================ SLATE ================ */

var gvariant;
var lastVariantSelected = false;
var loadingOnSelectChange = false;
var updateDiscountVariant = false;
var loadingFreeShippingText  = false;
let shippingPriceFree = {
  total:0,
  freePrice:0
};
// To check if we are in Product Tile Template
const isTileTemplate = function(){
  return $('#shopify-section-product-template-tile').length > 0;
};
const isGridTemplate = function(){
  return $('#shopify-section-product-template-grid').length > 0;
};
const isWallTemplate = function(){
  return $('#shopify-section-product-template-wall').length > 0;
};
const isCoolEdgeTemplate = function(){
  return $('#shopify-section-product-template-cooledge').length > 0;
};
const isSpaceKitTemplate = function(){
  return $('#shopify-section-product-template-spacekit').length > 0;
};
const isDecorativeTemplate = function(){
  return $('#shopify-section-product-template-decorative').length > 0;
};
const isBundleTemplate = function(){
  return $('#shopify-section-product-template-bundle').length > 0;
};
const isDefaultTemplate = function(){
  return $('#shopify-section-product-template').length > 0;
};
const isQuickViewGrid = function() {
  return $('#quickView.layout-grid ').length > 0;
};
const isQuickViewTile = function() {
  return $('#quickView.layout-tile ').length > 0;
};
const isQuickViewWall = function() {
  return $('#quickView.layout-wall ').length > 0;
};
const isQuickViewSpacekit = function() {
  return $('#quickView.layout-spacekit ').length > 0;
};
const isQuickViewDecorative = function() {
  return $('#quickView.layout-decorative ').length > 0;
};
const isQuickViewBundle = function() {
  return $('#quickView.layout-bundle ').length > 0;
};
const isQuickViewDefault = function() {
  return $('#quickView.layout-default').length > 0;
};
const roundOffTo = (num, factor = 100) => {
  const res = Math.ceil(num / factor) * factor
  return res;
};
//To check if is IOS Safari
const isSafariMobile = function(){
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);
  return iOS && webkit && !ua.match(/CriOS/i);
};

//To check if exist discount inputs
const regular_dsc_input = $(".dsc_btn.classic");
const regular_volume_dsc_input = $(".volume_dsc_btn.classic");
const regular_bulk_dsc_input = $(".bulk_dsc_btn.classic");
const pattern_dsc_input = $(".dsc_btn.patternLibrary");
const upsell_dsc_input = $(".dsc_btn.upsell");
const is_ltl_input = $(".ltl_items.classic");
window.theme = window.theme || {};

//To check if current day is in discounts date range
const checkDateRange = (dsc_attr = 'enable_dsc') => {
  const dsc_start_date = $('body').attr('start_date');
  const dsc_end_date = $('body').attr('end_date');
  const enable_dsc = $('body').attr(dsc_attr);
  let apply_discounts = false;
    if(dsc_start_date.length > 0 && dsc_end_date.length > 0 && enable_dsc == "false") {
      const now = new Date();
      const start_date = new Date(dsc_start_date * 1000);
      const end_date = new Date(dsc_end_date * 1000);
      if(now > start_date && now <= end_date) {
        apply_discounts = true;
      }
    }
  return apply_discounts; 
};
//Check if the volume discount message should be displayed on the PDP and include the class on elements
const checkVolumeDiscount = (displayMessage = false) => {
  const checkDates = checkDateRange('enable_vol_dsc');
  if(checkDates === true && localStorage.getItem('applyDiscount') == "true") {
    if(displayMessage) {
      const volume_discount_wrapper = $('.volume_promotion_msg');
      volume_discount_wrapper.each(function() {
        $(this).addClass('d-flex');        
      });
    }
    return true;
  }
  return false;
}

async function clearCart() {
  let result
  try {
    result = await $.ajax({
      url: '/cart/clear.js',
      type: 'POST',
      data: {},
    })
    return result
  } catch (error) {
    console.error(error)
  }
}
const updateDiscountLS = (type, value, needsRefresh) =>{
  JSON.parse(localStorage.getItem('discount_' + type));
  localStorage.setItem('discount_' + type, JSON.stringify(value));
  if(needsRefresh) {
    updateDiscounts().then(()=>{
      // works!
    });
  }
}
const getDiscountLS = (type) =>{
  let discount_before = JSON.parse(localStorage.getItem('discount_' + type));
      return discount_before;
}
$(()=>{
  checkDiscount();
})
const equalsIgnoreOrder = (a, b) => {
  if (a.length !== b.length) return false;
  const uniqueValues = new Set([...a, ...b]);
  for (const v of uniqueValues) {
    const aCount = a.filter(e => e.id === v.id  && e.value === v.value ).length;
    const bCount = b.filter(e => e.id === v.id  && e.value === v.value).length;
    if (aCount !== bCount) return false;
  }
  return true;
}

const compareBulkObjects = (a, b) => {
  if (a.length !== b.length) return false;
  const count = a.filter(e => {
    const data = e.id === b.id  && e.value === b.value && e.category === b.category ? true : false;
    const aValues = e.bulkData ? e.bulkData.filter(i => i.category === e.category) : '';
    const bValues = b.bulkData ? b.bulkData.filter(i => i.category === b.category) : '';
    const sameValues = JSON.stringify(aValues) === JSON.stringify(bValues) ? true : false;
    return sameValues && data ? true : false;
  }).length;
  return count;
}
const hasBulkChanges = (a, b) => {
  const a_without_new_items = a.filter(item => b.some(oldItem => oldItem.id === item.id));
  return equalsIgnoreOrderBulk (a_without_new_items, b);
}
const equalsIgnoreOrderBulk = (a, b) => {
  if (a.length !== b.length) return false;
  const uniqueValues = new Set([...a, ...b]);
  for (const v of uniqueValues) {
    const aCount = compareBulkObjects(a, v);
    const bCount = compareBulkObjects(b, v);
    if (aCount !== bCount) return false;
  }
  return true;
}
const setApplyDiscountBeforeLs = (applyDiscount, lsName, lsNewValue) => {
  let updateStore = false;
  const parsedOldValue = applyDiscount === 'true' ? true : false;
  
  if(!applyDiscount) {
    localStorage.setItem(lsName, applyDiscount, lsNewValue);
  }else if(parsedOldValue !== lsNewValue) {
    localStorage.setItem(lsName, lsNewValue);
    updateStore = true;
  }
  return updateStore;
}

const requireRefresh = (a, b) => {
  if (b.length === 0) return false;
  let apply_discounts_before = localStorage.getItem('applyDiscount_before');
  let apply_discounts_before_vol = localStorage.getItem('applyDiscount_before_vol');
  let apply_discounts_before_bulk = localStorage.getItem('applyDiscount_before_bulk');
  let apply_discounts = JSON.parse(localStorage.getItem('discount_before'));
  let apply_discounts_vol = apply_discounts?.apply_vol ? apply_discounts.apply_vol : false;
  let apply_discounts_bulk = apply_discounts?.apply_bulk ? apply_discounts.apply_bulk : false;
  apply_discounts = apply_discounts?.apply ? apply_discounts.apply : false;
  
  const updateStoreDiscounts =
  setApplyDiscountBeforeLs(
    apply_discounts_before,
    'applyDiscount_before',
    apply_discounts
  ) ||
  setApplyDiscountBeforeLs(
    apply_discounts_before_vol,
    'applyDiscount_before_vol',
    apply_discounts_vol
  ) ||
  setApplyDiscountBeforeLs(
    apply_discounts_before_bulk,
    'applyDiscount_before_bulk',
    apply_discounts_bulk
  )
    ? true
    : false;
  
  const differentProducts = a.filter(item =>  b.some(oldItem => {
    const isNewProduct = oldItem.id === item.id ? false : true;
    let hasChanges = false;
    if(!isNewProduct) {
      hasChanges = oldItem.value !== item.value ? true : false;
    }
    return !isNewProduct && hasChanges ? true : false;
  }));
  return differentProducts.length > 0 || updateStoreDiscounts ? true : false;
}
const checkDiscount = () => {
  const apply_discounts = checkDateRange();
  const apply_discounts_vol = checkVolumeDiscount();
  const applyDiscountsBulk = document.querySelector('body').getAttribute('enable_bulk_dsc') === 'false' ? true : false;
  const discountAplicableZipcode = localStorage.getItem('applyDiscount') == 'true';
  let previous = getDiscountLS('before');
  let previousitemsProducts = previous ? previous.itemsProducts: [];
  let previousitemsVariants = previous ? previous.itemsVariants: [];
  let previousitemsPercent = previous ? previous.discountPercent: [];
  let previousBulkDiscount = previous && previous.hasOwnProperty("bulkDiscountVariants") ? previous.bulkDiscountVariants : [];
  let itemsProductsFlag = equalsIgnoreOrder(itemsProducts, previousitemsProducts);
  let itemsVariantsFlag = equalsIgnoreOrder(itemsVariants, previousitemsVariants);
  let itemsPercentFlag = equalsIgnoreOrder(discountPercent, previousitemsPercent);
  let itemsVariantBulk = equalsIgnoreOrderBulk(bulkDiscountVariants, previousBulkDiscount);
  const requireBulkRefresh = hasBulkChanges(bulkDiscountVariants, previousBulkDiscount);
  const needsRefresh = requireRefresh(discountPercent, previousitemsPercent) || !requireBulkRefresh;
  const hasDiscount = apply_discounts && discountAplicableZipcode;
  const hasDiscount_vol = apply_discounts_vol && discountAplicableZipcode;
  const hasDiscountBulk = applyDiscountsBulk && discountAplicableZipcode ;
  const millis = previous ? (Date.now() - previous.time):0 ;
  const seconds = Math.floor(millis / 1000);
  
  if(previous && previous.time && 
    seconds > 2 &&  
    (previous.apply != hasDiscount || 
      previous.apply_vol != hasDiscount_vol ||
      previous.apply_bulk != hasDiscountBulk ||
      !itemsProductsFlag ||
      !itemsVariantsFlag || 
      !itemsPercentFlag ||
      !itemsVariantBulk ||
      needsRefresh
    )
  ){// 2 seg
    updateDiscountLS('before',{
      apply_vol:hasDiscount_vol,
      apply: hasDiscount,
      apply_bulk: hasDiscountBulk,
      time: Date.now(),
      itemsProducts,
      itemsVariants,
      discountPercent,
      bulkDiscountVariants
    },needsRefresh)
  }
  
  if (previous==null){
    updateDiscountLS('before',{
      apply_vol:hasDiscount_vol,
      apply: hasDiscount,
      apply_bulk: hasDiscountBulk,
      time: Date.now(),
      itemsProducts,
      itemsVariants,
      discountPercent,
      bulkDiscountVariants
    }, needsRefresh);
  }
  let discount_before = JSON.parse(localStorage.getItem('discount_before'));
      localStorage.setItem('discount_before', JSON.stringify(discount_before));
}

function getVolumeDiscount(variant_id, dsc_input) {
  const dsc_input_val  = dsc_input.val();
  const apply_discounts = checkDateRange('enable_vol_dsc');
  if(dsc_input_val.length > 0 && apply_discounts) {
    const variants = dsc_input_val.split(',');
    for (let variant of variants) {
      const [varId, discount = 0] = variant.split(':');
      if(varId == variant_id) return ["Buy "+variants[0]+" cartons or more, save "+discount+"%.",variants[0],discount];
    }
  }
  return false;
}

const deleteDiscountProperties = (properties, delVolProps = false, delRegProps = false, delBulkProps = false) => {
  if(delVolProps) {
    delete properties?._volumeMsg;
    delete properties?._volumeDiscount;
    delete properties?._volumeQuantity;
    delete properties?._volumeDiscountApplied;
  }
  if(delRegProps) {
    delete properties?._discount;
  }
  if(delBulkProps) {
    delete properties?._bulkDiscount;
    delete properties?._bulkDiscountData;
    delete properties?._bulkDiscountApplied;
  }
  return properties;
}

const updateDiscounts = async (removeCartCookies = false)=>{
  const itemsCart = CartJS.cart.items;
  if (itemsCart.length === 0) return;
  const itemsInCart = itemsCart.reduce(
    (previousValue, currentValue) => previousValue + currentValue.quantity,0);
  const cartQuantity = $('#CartCount');
  cartQuantity.addClass('d-none');
  if (removeCartCookies) {
    let daysToExpire = 365;
    let daysCalculated = -(1000*60*60*24*daysToExpire)
    let expires = new Date((new Date()).valueOf() + daysCalculated);
    document.cookie = 'cart=;expires=' + expires.toUTCString();
    document.cookie = 'cart=;max-age=-1;';
    console.log(`🍪 ~ CART COOKIE DELETED`);
  }
  await clearCart();
  for (let index = 0; index < itemsCart.length; index++) {
    $('#ajax_discount').html('');
    const element = itemsCart[index];
    let data = await $.get( `/products/${element.handle}?view=product_discount`);
    cartQuantity.html(itemsInCart);
    $('#ajax_discount').append(data);
    cartQuantity.removeClass('hide d-none');
    const obj = $('.dsc_btn.ajax');
    const obtVol = $('.volume_dsc_btn.ajax');
    const objBulk = $('.bulk_dsc_btn.ajax');
    let v_discount = getDiscountBase(element.variant_id, $(obj));
    const enableVolumeDiscount = checkVolumeDiscount();
    const volume_value_discount = getVolumeDiscount(element.variant_id, $(obtVol));
    let payload = {id: element.variant_id, quantity: element.quantity};
    const newProperties = deleteDiscountProperties(element.properties, true, true, true);
    
    if (enableVolumeDiscount && volume_value_discount) {
        payload.properties = {...newProperties, '_discount': v_discount,'_volumeMsg': volume_value_discount!= false?volume_value_discount[0]:null,'_volumeQuantity':volume_value_discount[1],'_volumeDiscount':volume_value_discount[2]};
    } else if (v_discount) {
      const newProperties = deleteDiscountProperties(element.properties, true, true, true);
      payload.properties = {...newProperties, '_discount': v_discount }; 
    } else if(hasBulkDiscount(element.variant_id, objBulk)) {
      const bulkProperties = checkBulkDiscount(newProperties, element.variant_id, objBulk);
      payload.properties = {...bulkProperties}; 
    }else {
      payload.properties = {...newProperties}; 
    }
    
    await jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: payload,
      dataType: 'json',
      success: function() {
        if(removeCartCookies) {
          console.log(`🍪 ~ All items RE-ADDED`);
        }
        if (index === itemsCart.length - 1) {
          location.reload();
        }
      }
    })
  }
};
const getDiscountBase = (variant_id,regular_dsc_input) => {
  const dsc_input_val  = regular_dsc_input.val();
  const apply_discounts = checkDateRange();
  const discountAplicableZipcode = localStorage.getItem('applyDiscount')=='true'
  if(dsc_input_val.length > 0 && apply_discounts && discountAplicableZipcode ) {
    const variants = dsc_input_val.split(',');
    const discount = variants[0];
    for (let variant in variants) {
      if(variant == 0) continue;
      if(variants[variant] == variant_id) return discount;
    }
  }
  return false;
};
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function () {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function () {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/*** Image Helper Functions ** A collection of functions that help with basic image operations. **/
theme.Images = (function () {

  /** Preloads an image in memory and uses the browsers cache to store it until needed.
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /*** Loads and caches an image in the browsers cache.
   * @param {string} path - An image url */
  function loadImage(path) {
    if(path != undefined && path != ''){
      new Image().src = path;
    }
  }

  /*** Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image * @param element * @param callback */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /** +++ Useful * Find the Shopify image attribute size
   ** @param {string} src * @returns {null} */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /** +++ Useful * Adds a Shopify size attribute to a URL
   * @param src * @param size * @returns {*} */
  function getSizedImageUrl(src, size) {
    if (size == null) { return src; }
    if (size === 'master') { return this.removeProtocol(src); }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }
    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/** Currency Helpers
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/ **/
theme.Currency = (function () {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 * @namespace variants */
slate.Variants = (function () {
  /*** Variant constructor * @param {object} options - Settings from `product.js` */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    /*  Update variant prices for bundle to the discounted price.
        bundle_discount_price is an array created on discount-price-bundle.liquid that contains the discounted prices for bundle variants
    */
    if(isBundleTemplate() && checkDateRange() && bundle_discount_price ) {
      this.product.variants.forEach(variant => {
        const bundlePrice = bundle_discount_price[variant.id]?.toFixed(2);
        const sqft = Shopify.productMeta[variant.id]?.sqftPerCarton;
        const discountedPrice = parseInt(bundlePrice * 100);
        variant.price_per_sqft = (bundlePrice / sqft)?.toFixed(2);
        variant.price = discountedPrice;
      });
      const sqftText = $('.product-price__tilesqft');
      const priceText = $('#ProductPrice-product-template-bundle');
      const price = theme.Currency.formatMoney(this.currentVariant.price, theme.moneyFormat);
      priceText.html(price);
      sqftText.html(`$${this.currentVariant.price_per_sqft}`);
    }
    //Validate if volume discount should be visible on page load
    checkVolumeDiscount(true);
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    this._handleSaleFlag(this.currentVariant);
    // Discount detection on Variants initialization.
//    if((typeof variant !== 'undefined') && $('.tile-accordion-pdp, .wall-accordion-pdp, .decorative-accordion-pdp').length>0){
//      this._calculateDiscount(this.currentVariant);
//    }
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /*** Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     * @return {array} options - Values of currently selected variants */
    _getCurrentOptions: function () {
      var that = this;
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};
        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          var slvaraint = currentOption.value.replace(/'/g, "\\'");
          $("." + currentOption.index, that.$container).find(".swatchInput[value='" + slvaraint + "']").prop("checked", true);
          $("." + currentOption.index, that.$container).find(".slVariant").text(currentOption.value);
          return currentOption;
        }
      });
      
      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /*** Find variant based on selected values.
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants*/
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });
      if (found) {
        found = Object.assign(found, { productDescription: this.product.description });
      }

      return found;
    },

    /*** Event handler for when a variant input changes. */
    _onSelectChange: function () {
      if(typeof isWsgCustomer !== 'undefined' && isWsgCustomer){
        $('.tile_pdp_price.product-price__price_wholesale').children(":last-child").find('.product-price__carton').css('opacity','0');
        $('.tile_pdp_price.product-price__price_wholesale').children(":first").css('opacity','0');
        $('.perAmountSqFtBlock').css('opacity','0');
        
      }
      // Update shipping times based on the variant selected
      var variant = this._getVariantFromOptions();
    
      // Prevent to execute all the process when the variant to update is the same that the current variant
      if(variant.id === this.currentVariant.id) {
        return;
      }
      $('.shipping-time').css('display', 'none');
      $('#gridSystemSectionCart').css('display', 'none');
      if (variant) {
        $('#shipping_time_' + variant.id).css('display', 'block');
        $('#gridSystemSectionCart').css('display', 'block');
      }

      // Show the upsell module based on the variant selected
      var bundle = undefined;
      $('.pdpCompatibleGridSystems').hide();
      
      
      if (variant) {
        bundle = $('.bundle-map-' + variant.id).data('bundle');
        $('#added-to-cart #compatibleGridSystemModal').removeAttr('style');
      }else{
        $('#added-to-cart #compatibleGridSystemModal').css('display','none');//Grid pdp system section in added to cart modal 
      }
      
      if (bundle) {
        var bundleContainer = $('.pdpCompatibleGridSystems.'+bundle);

        // Set variant name
        bundleContainer.find('.variant_name').html(variant.option1 +', '+ variant.option2 +', '+ variant.option3);
        // update image bundle
        if(variant.featured_image) {
          bundleContainer.find('.grid-system-image-container').html("<img src='"+variant.featured_image.src+"'>");
        }
        // Show bundle module
        bundleContainer.show();
        $('#added-to-cart #compatibleGridSystemModal').removeAttr('style');
        
      } else {
        // // Hide all bundles
        $('.pdpCompatibleGridSystems').hide();
        $('#added-to-cart #compatibleGridSystemModal').css('display','none');//Grid pdp system section in added to cart modal 
      }
      
      $('.tile-pdp .specs-blocks').hide();
      $('.details-returns-blocks').hide();
      $('#accordion-details-returns').hide();
      if(variant){
        $("#details_specifications_"+variant.id).show();
        if($("#details_returns_"+variant.id).text().length > 0){
          $('#accordion-details-returns').show();
          $("#details_returns_"+variant.id).show();
        }
      }
      this.$container.trigger({type: 'variantChange',variant: variant});

      var that = this;
   
      if (!variant) {
        return;
      }
      // Load sections via ajax once validated with loadingOnSelectChange
        let quantity = parseInt($('#quantity').val(),0);
        let path = `${location.protocol}//${location.host}${location.pathname}/?variant=${variant.id}&qty=${quantity}&sections=stock-info-banner,product-shipping-time,specs-block`;
        const upsellHolder = $('#product-upsell-holder');
        const volumenDiscountsWrapper = $('.vol-discounts-msg-wrapper');
        if (upsellHolder.length > 0) path += `,section-upsell-component`;
        if (volumenDiscountsWrapper.length > 0) path += `,pdp-volume-discount-promo`;
        updateSections(path);
      if(!isCoolEdgeTemplate())$('.tile-pdp .specs-blocks').show();
      if(!isSpaceKitTemplate())$('.tile-pdp .specs-blocks').show();
      renderCharacteristicsDetailsCommon(variant.id);
      updateFreeShippingMsg();
      if($('.tile-accordion-pdp, .wall-accordion-pdp, .decorative-accordion-pdp, .spacekit-accordion-pdp').length>0) this._calculateDiscount(variant);
      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      reloadShippingEstimates();
      if (this.enableHistoryState) this._updateHistoryState(variant);
      this.currentVariant = variant;
      this._handleSaleFlag(variant);
      const initialSlideFlag = document.querySelector('.product-single__photo.initial-flag-position:not(.on-sale-flag)');
      const flags = document.querySelectorAll('.ribbon.custom-flag.pdp-flag');
      if(initialSlideFlag && initialSlideFlag.classList.contains('slick-active')) {
        if(variant.id != initialSlideFlag.getAttribute('initial-variant-id')) {
          flags.forEach(flag => flag.classList.remove('active'));
        }else {
          flags.forEach(flag => flag.classList.add('active'));
        }
      }
    },
    _handleSaleFlag: function (variant) {
      if(typeof discountedVariants != 'undefined' && discountedVariants.length) {
        this._removeSaleFlag();
        const flags = document.querySelectorAll('.ribbon.custom-flag.pdp-flag');
        const firstFlag = flags.length ? flags[0] : false;
        const hasMultipleStyles = firstFlag && firstFlag.hasAttribute('sale-styles') && firstFlag.hasAttribute('custom-flag-styles') ? true : false;
        if(discountedVariants.includes(`${variant.id}`)) {
          if(hasMultipleStyles && firstFlag.classList.contains('custom-flag-styles')) {
            const saleStyles = JSON.parse(firstFlag.getAttribute('sale-styles'));
            flags.forEach((flag) => {
              addFlagStyles(flag, saleStyles);
              flag.classList.toggle('custom-flag-styles');
              flag.classList.toggle('sale-styles');
            });
          }
          const featuredImgId = variant.featured_media?.id;
          const slideImg = document.querySelector(`.product-single__photo[id="${featuredImgId}"]`);
          if (slideImg) {
            document.querySelector('.ribbon.custom-flag.pdp-flag.desktop')?.classList.add('active');
            slideImg.classList.add('on-sale-flag');
          }  
        }else if(hasMultipleStyles && firstFlag.classList.contains('sale-styles')) {
          const customFlagStyles = JSON.parse(firstFlag.getAttribute('custom-flag-styles'));
          flags.forEach((flag) => {
            addFlagStyles(flag, customFlagStyles);
            flag.classList.toggle('custom-flag-styles');
            flag.classList.toggle('sale-styles');
          });
        }
      }
    },
    _removeSaleFlag: function() {
      document.querySelector('.ribbon.custom-flag.pdp-flag.desktop')?.classList.remove('active');
      document.querySelector('.on-sale-flag')?.classList.remove('on-sale-flag');
    },

    /**
     * Trigger event when variant image changes
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }
      this.$container.trigger({
        type: 'variantImageChange', variant: variant
      });
    },

    /*** Trigger event when variant price changes. *  @param  {object} variant - Currently selected variant * @return {event} variantPriceChange */
    _updatePrice: function (variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }
      this.$container.trigger({
        type: 'variantPriceChange', variant: variant
      });
    },

    /*** Trigger event when variant sku changes. *  @param  {object} variant - Currently selected variant *  @return {event} variantSKUChange */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }
      this.$container.trigger({
        type: 'variantSKUChange', variant: variant
      });
    },

    /** Update history state for product deeplinking
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description] */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /*** Update hidden master select of variant change
     * @param  {variant} variant - Currently selected variant */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },
    _getDiscount: function(variant_id) {
      const dsc_input_val  = regular_dsc_input.val();
      const apply_discounts = checkDateRange();
      const discountAplicableZipcode = localStorage.getItem('applyDiscount')=='true'
      if(dsc_input_val.length > 0 && apply_discounts && discountAplicableZipcode ) {
        const variants = dsc_input_val.split(',');
        const discount = variants[0];
        for (let variant in variants) {
          if(variant == 0) continue;
          if(variants[variant] == variant_id) return discount;
        }
      }
      return false;
    },
    _calculateDiscount:function(v) {
      $('.originalPriceRegular').html(`(${theme.Currency.formatMoney(v.price, theme.moneyFormat)}`);
      const d = this._getDiscount(v.id);
      const pm = Shopify.productMeta[v.id];
      if( d > 0 && pm.pricePerSqft) { // apply discount
        const ppsqft = pm.pricePerSqft.substring(1); //Remove $ from price before using it to calculate new price
        const discountedPrice = v.price-v.price*d/100
        if(discountedPrice>0) {
          $('.product-price__dualholder .price-holder').html(theme.Currency.formatMoney(discountedPrice, theme.moneyFormat))
          if(pm.sqftPerCarton!=""&&pm.sqftPerCarton>0){
            const discountedPricePersqft = ppsqft*(100-d)
            $('.leftPriceRate .price span').html(theme.Currency.formatMoney(discountedPricePersqft, theme.moneyFormat))
          }
          const percentageDiscount = pm.discount
          $('.savePersntage span').html(Math.round(percentageDiscount))
          $('.tile_pdp_price.product-price__price').addClass('d-none');
          $('.perAmountSqFtBlock').addClass('d-block');
        }else{
          $('.tile_pdp_price.product-price__price').removeClass('d-none');
          $('.perAmountSqFtBlock').removeClass('d-block');
        }
      }else{
        $('.tile_pdp_price.product-price__price').removeClass('d-none');
        $('.perAmountSqFtBlock').removeClass('d-block');
      }
    }
  });

  return Variants;
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};
theme.Header = (function () {
  var selectors = {
    body: 'body',
    sitenav: '#siteNav',
    navLinks: '#siteNav .lvl1 > a',
    mobilenav: '.mobile-nav-wrapper',
    menuLinks: '#MobileNav a'
  };

  function init() {

    $(".header-cart,.close-cart").on('click', function (i) {
      i.preventDefault(); i.stopPropagation();
      if(window.location.pathname != "/cart") {
        $("body").addClass("preventScrolling");
        $("#cart-drawer, .cart-container").toggleClass("active");
      } else {
        $('body').removeClass("showOverly")
      }
    });
    
    $(".header-cart").on('click', function () {
      if(window.location.pathname != "/cart") {
        if ($(window).width() > 767) {
          $('.drift-frame-controller').hide();
        }
      }
    });
    
    $(".close-cart").on('click', function () {
      $('.drift-frame-controller').show();
    });
    

    $(".site-settings").on('click', function () {
      // Only desktop display the #settingsBox
      if(!$(this).hasClass('mobile_account')){
        $("#settingsBox").toggleClass("active");  
      }
    });

    $(selectors.navLinks).each(function () {
      if ($(this).attr('href') == window.location.pathname) $(this).addClass('active');
    });
    function openMobileNav(selectors){
      if ($(window).width() < 767) {
          $(selectors.mobilenav).addClass("active");
          $(selectors.mobilenav+', .active').css({"right": "0px", "left": "auto"});
          $(selectors.body).addClass("menuOn");
          $(selectors.body+', .menuOn').css({"left": "-100%", "right": "auto"});
          $('.js-mobile-nav-toggle').toggleClass('open close');
         }else{
          $(selectors.mobilenav).removeAttr("style");
          $(selectors.body).removeAttr("style");
          $(selectors.mobilenav).toggleClass("active");
          $(selectors.body).toggleClass("menuOn");
          $('.js-mobile-nav-toggle').toggleClass('open close');
       }
     };
    function closeMobileNav(selectors){
      if ($(window).width() < 767) { 
        if($(selectors.body).hasClass('menuOn'))
            {
              $(selectors.mobilenav+', .active').css({"left": "auto","right": "0px"});
            }
        $(selectors.body).css({"right": "0px", "left": "auto"});
        $(selectors.body+', .menuOn').css({"left": "0px", "right": "auto"});
        $(selectors.body).removeClass("menuOn");
        if($(selectors.mobilenav+', .active').css("left")=="0px"){
        $(selectors.mobilenav+', .active').css({"right": "-270px", "left": "auto"});
        }
        $(selectors.mobilenav).removeClass("active");
        $('.js-mobile-nav-toggle').toggleClass('open close');
      }else{
        $(selectors.body).css({"right": "auto", "left": "0px"});
        $(selectors.body+', .menuOn').css({"right": "auto", "left": "0px"});
        $(selectors.body).removeClass("menuOn");
        $(selectors.mobilenav).css({"right": "auto", "left": "-270px"});
        $(selectors.mobilenav+', .active').css({"right": "auto", "left": "-270px"});
        $(selectors.mobilenav).removeClass("active");
        $(selectors.mobilenav).removeAttr("style");
        $(selectors.body).removeAttr("style");
        $('.js-mobile-nav-toggle').toggleClass('open close');
      }
    };
    $(window).on('resize', function(){
      if ($(window).width() < 767) {
            if($(selectors.body).hasClass('menuOn'))
            {
              $(selectors.body).css({"left": "-100%", "right": "auto"});
              $(selectors.mobilenav).css({"left": "0px","right": "auto"});
            } else{
              $(selectors.mobilenav).css({"left": "auto","right": "-270px"});
            }
          $('.js-mobile-nav-toggle').off('click').on("click", function () {
            body: 'body',
            openMobileNav(selectors); 
          });
          $('.closemobileMenu').off('click').on("click", function () {
            body: 'body',
            closeMobileNav(selectors);
          });
       }else{
          $(selectors.mobilenav).removeAttr("style");
          $(selectors.body).removeAttr("style");
            $('.js-mobile-nav-toggle').off('click').on("click", function () {
              body: 'body',
              openMobileNav(selectors);
            });
            $('.closemobileMenu').off('click').on("click", function () {
              body: 'body',
              closeMobileNav(selectors);
            });
        }
      });
    function clickMobileMenu(selectors){
       if ($(window).width() < 767) {
          $(selectors.mobilenav).css({"left": "auto","right": "-270px"});
          $('.js-mobile-nav-toggle').off('click').on("click", function () {
            body: 'body',
            openMobileNav(selectors); 
          });
          $('.closemobileMenu').off('click').on("click", function () {
            body: 'body',
            closeMobileNav(selectors);
          });
        }else{
          $('.js-mobile-nav-toggle').off('click').on("click", function () {
            body: 'body',
            openMobileNav(selectors);
          });
          $('.closemobileMenu').off('click').on("click", function () {
            body: 'body',
            closeMobileNav(selectors);
          });
        }
      };
      clickMobileMenu(selectors);
    $("body").click(function (event) {
      var $target = $(event.target);
      if (!$target.parents().is(selectors.mobilenav) && !$target.parents().is('.js-mobile-nav-toggle') && !$target.is('.js-mobile-nav-toggle')) {
        $(selectors.mobilenav).removeClass("active");
        $(selectors.body).removeClass("menuOn");
        $('.js-mobile-nav-toggle').removeClass('close').addClass('open');
        if ($(window).width() < 767) {
        $(selectors.body).css({"left": "0px", "right": "auto"});
        }
      }
      // Hide cart drawer
      if (!$target.parents().is("#cart-drawer") && !$target.is("#cart-drawer") && !$target.parents().is(".header-cart") && !$target.is(".header-cart")) {
        $("#cart-drawer, .cart-container").removeClass("active");
        $('.Check_cart_flyout').hide();
        if ($(window).width() > 767) {
          $('.drift-frame-controller').show();
        }
        //$('body').removeClass("showOverly");
      }
      // Hide settingsBox on document click
      if (!$target.parents().is("#settingsBox") && !$target.parents().is(".site-settings") && !$target.is(".site-settings")) {
        $("#settingsBox").removeClass("active");
      }
    });

    $(selectors.menuLinks).on('click', function (e) {
      if ($(this).siblings('ul').length) {
        e.preventDefault();
        const tagA = $(this);
        const arrow = tagA.find('.ad');
        const li = tagA.parent();
        if(tagA.hasClass('main-title')){// means first in mobile
          const liSiblings = $(li).siblings();
          liSiblings.removeClass('open').find('ul').hide(); 
          liSiblings.find('a').removeClass('mobile-orange');
          liSiblings.find('.ad-chevron-up').toggleClass('ad-chevron-down ad-chevron-up');
          tagA.addClass('mobile-orange');
        }
        li.toggleClass('open');
        arrow.toggleClass('ad-chevron-down ad-chevron-up');
        tagA.next().slideToggle();
      }
    });

    $(selectors.sitenav).hover(function (e) {
      e.preventDefault();
    });
  }
  return { init: init };
})();


window.theme = window.theme || {};
theme.Wizard = (function () {
  var selectors = {
    launcherCta: '.kanopi-cw-launcher',
    wizardID: 'wizard-launcher'
  };

  function init() {
    $(document).on('click', selectors.launcherCta, function (e) {
      window.location.href = '/pages/ceiling-selector';
      event.preventDefault();
    });
  }

  return { init: init };
})();


(function () {
  var selectors = { backButton: '.return-link' };
  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function (evt) {
    evt.preventDefault();
    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);
    if (shopDomain === referrerDomain) { history.back(); }
    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;
    return anchor.hostname;
  }
})();

theme.Slideshow = (function () {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: this.$slideshow.data('arrow'),
      dots: this.$slideshow.data('dots'),
      fade: true,
      rtl: theme.rtl,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function (evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function () {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

/* ================ TEMPLATES ================ */

window.theme = theme || {};
theme.customerTemplates = (function () {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /****  Show/Hide recover password form **/
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /****  Show reset password success message **/
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /****  Show/hide customer address forms **/
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function () {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function () {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function () {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function () {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
      }
    });
  }

  /****  Check URL for reset password hash **/
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function () {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

/*================ SECTIONS ================*/

window.theme = window.theme || {};

theme.tilePDPNav = (function() {
  if($('#accordion-system .header-accordion a').length > 0) {
    $('#accordion-system .header-accordion').each(function(index, item) {
      $(item).trigger("click");
    });
  }
  const sectionDetails = document.querySelector('.container-details');
  const sectionInstallation = document.querySelector('.container-help-installing');
  const sectionFaq = document.querySelector('.container.container-faq');
  const sectionGallery = document.querySelector('.prod-gallery');

  function isInViewport(el) {
    if(el !== null) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    } 
  }

  document.addEventListener("scroll", colorScroll);

  function colorScroll() {
    var removeSelected = false;
    if (isInViewport(sectionDetails)) {
      $('a.menu').removeClass('scrolled');
      $("#nav1").toggleClass('scrolled');
      removeSelected = !$("#nav1").hasClass('selected');
    } else if (isInViewport(sectionInstallation)) {
      $('a.menu').removeClass('scrolled');
      $("#nav2").toggleClass('scrolled');
      removeSelected = !$("#nav2").hasClass('selected');
    } else if (isInViewport(sectionFaq)) {
      $('a.menu').removeClass('scrolled');
      $("#nav3").toggleClass('scrolled');
      removeSelected = !$("#nav3").hasClass('selected');
    } else if (isInViewport(sectionGallery)) {
      $('a.menu').removeClass('scrolled');
      $("#nav4").toggleClass('scrolled');
      removeSelected = !$("#nav4").hasClass('selected');
    } else {
      $('div.banner-wrapper').addClass('banner-desk');
      $('button.banner-btn').removeClass('banner-btn-scroll-cart');
      $('a.menu').removeClass('scrolled');
      removeSelected = true;
    }
    
    if (removeSelected) {
      $('a.menu').removeClass('selected');
    }
  }
  
  $(document).on('click', '.sidenav a.menu', function(e) {
    document.removeEventListener("scroll", colorScroll);
    $('a.menu').removeClass('scrolled selected');
    $(e.target).addClass('selected');
    setTimeout(function() {
      document.addEventListener("scroll", colorScroll);
    }, 1000);
  });
  
});

theme.gridPDPNav = (function () {
  
  //** Accordeon for responsive navbar
  var lastClick = [];
  var accordianActions = document.querySelectorAll('[data-accordian-action-sticky]');
  var accordianTargets = document.querySelectorAll('[data-accordian-target-sticky]');

  var hideTargets = function io(target) {
    if (target) {
      var target = document.querySelector(target);
      target.style.display = 'none';
    } else {
      for (var i = 0; i < accordianTargets.length; i++) {
        var accordianTarget = accordianTargets[i];
        accordianTarget.style.display = 'none';
      }
    }
  };

  var showTarget = function (targetSelector) {
    var target = document.querySelector(targetSelector);
    if (target) {
      target.style.display = 'block';
    }
  };

  var changeImage = function (targetSelect) {
    var target = document.querySelector('[data-image="' + targetSelect + '"]');

    if (target.src) {
      var image = target.src.substring(target.src.lastIndexOf('/') + 1, target.src.lastIndexOf('?'));
      if (image == 'dropdown-stickys.svg') {
        target.src = target.src.replace(image, 'dropup-images.svg');
      } else {
        target.src = target.src.replace(image, 'dropdown-stickys.svg');
      }
    }
  };

  var addItem = function (targetHref) {
    lastClick = [...lastClick, targetHref];
  };

  var removeItem = function (targetHref) {
    lastClick = lastClick.filter(element => element !== targetHref);
  };

  var isItem = function (targetHref) {
    return lastClick.findIndex(element => element === targetHref) !== -1;
  };

  hideTargets(null);

  for (var i = 0; i < accordianActions.length; i++) {
    var accordianAction = accordianActions[i];
    accordianAction.addEventListener('click', function (e) {
      e.preventDefault();
      const hrefTarget = e.currentTarget.getAttribute('href');
      changeImage(hrefTarget);
      if (!isItem(hrefTarget)) {
        showTarget(hrefTarget);
        addItem(hrefTarget);
      } else {
        hideTargets(hrefTarget);
        removeItem(hrefTarget);
      }
    });
  }

  var editQuantities = document.querySelector(".edit-quantities");
  editQuantities.addEventListener('click', function (e) {
    window.location = '#accordion-system';
  }); 
  

  //** Accordeon for responsive navbar


  const sectionDetails = document.querySelector('.container-details');
  const sectionInstallation = document.querySelector('.container-help-installing');
  const sectionFaq = document.querySelector('.container.container-faq');
  const sectionGallery = document.querySelector('.prod-gallery');

  function isInViewport(el) {
    if(typeof(el) !== 'undefined') {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  }

  document.addEventListener("scroll", colorScroll);

  function colorScroll() {
    var removeSelected = false;
    if (isInViewport(sectionDetails)) {
      $('a.menu').removeClass('scrolled');
      $("#nav1").toggleClass('scrolled');
      removeSelected = !$("#nav1").hasClass('selected');
    } else if (isInViewport(sectionInstallation)) {
      $('a.menu').removeClass('scrolled');
      $("#nav2").toggleClass('scrolled');
      removeSelected = !$("#nav2").hasClass('selected');
    } else if (isInViewport(sectionFaq)) {
      $('a.menu').removeClass('scrolled');
      $("#nav3").toggleClass('scrolled');
      removeSelected = !$("#nav3").hasClass('selected');
    } else if (isInViewport(sectionGallery)) {
      $('a.menu').removeClass('scrolled');
      $("#nav4").toggleClass('scrolled');
      removeSelected = !$("#nav4").hasClass('selected');
    } else {
      $('div.banner-wrapper').addClass('banner-desk');
      $('button.banner-btn').removeClass('banner-btn-scroll-cart');
      $('a.menu').removeClass('scrolled');
      removeSelected = true;
    }
    
    if (removeSelected) {
      $('a.menu').removeClass('selected');
    }
  }
  
  $(document).on('click', '.sidenav a.menu', function(e) {
    document.removeEventListener("scroll", colorScroll);
    $('a.menu').removeClass('scrolled selected');
    $(e.target).addClass('selected');
    setTimeout(function() {
      document.addEventListener("scroll", colorScroll);
    }, 1000);
  });

  var acc = document.getElementsByClassName("accordion-grid");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      /* Toggle between adding and removing the "active" class,
      to highlight the button that controls the panel */
      this.classList.toggle("active");

      /* Toggle between hiding and showing the active panel */
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
});

theme.gridPDPCompatibleCeilings = (function () {

  const compatibleCeilingContainer = $('#pdpCompatibleCeilings');

  if (compatibleCeilingContainer.length) {
    // pdp related product KPD-739 - compatible ceiling tiles
    // duration of scroll animation
    var scrollDuration = 300;
    // paddles
    var leftPaddle = document.getElementsByClassName("left-scroll-button");
    var rightPaddle = document.getElementsByClassName("right-scroll-button");
    // get items dimensions
    var cardsNumber = $('.ceiling-container').length;
    var card = document.querySelector('.ceiling-container');

    // show based on the screen size
    if (card) {
      var cardStyle = getComputedStyle(card);
      var cardMargin = parseInt(cardStyle.marginRight);
      var cardWidth = card.offsetWidth + cardMargin;
      var cardContainerSize = cardWidth * cardsNumber;
      $(window).on('resize', function () {
        if (cardContainerSize - 30 < window.screen.width) {
          $(rightPaddle).addClass('hidden');
        } else if (cardContainerSize > window.screen.width) {
          $(rightPaddle).removeClass('hidden');
        }
      });
    }

    var itemsLength = $('.ceiling-container').length;
    var itemSize = cardWidth;//$('.item').outerWidth(true);

    // get some relevant size for the paddle triggering point
    var paddleMargin = 30;
    // get wrapper width
    var getMenuWrapperSize = function () {
      return $('.ceiling-wrapper').outerWidth();
    };
    var menuWrapperSize = getMenuWrapperSize();
    // the wrapper is responsive
    $(window).on('resize', function () {
      menuWrapperSize = getMenuWrapperSize();

      if ($(window).width() <= 375) {
        paddleMargin = 60;
      } else {
        paddleMargin = 30;
      }
    });

    // size of the visible part of the menu is equal as the wrapper size 
    var menuVisibleSize = menuWrapperSize;

    // get total width of all menu items
    var getMenuSize = function () {
      return itemsLength * itemSize;
    };
    var menuSize = getMenuSize();
    // get how much of menu is invisible
    var menuInvisibleSize = menuSize - menuWrapperSize;

    // get how much have we scrolled to the left
    var getMenuPosition = function () {
      return $('.parent-ceiling-container').scrollLeft();
    };

    // finally, what happens when we are actually scrolling the menu
    $('.parent-ceiling-container').on('scroll', function () {

      // get how much of menu is invisible
      menuInvisibleSize = menuSize - menuWrapperSize;
      // get how much have we scrolled so far
      var menuPosition = getMenuPosition();

      var menuEndOffset = menuInvisibleSize - paddleMargin;
      // show & hide the paddles 
      // depending on scroll position
      if (menuPosition <= paddleMargin) {
        $(leftPaddle).addClass('d-none');
        $(rightPaddle).removeClass('d-none');
      } else if (menuPosition < menuEndOffset) {
        // show both paddles in the middle
        $(leftPaddle).removeClass('d-none');
        $(rightPaddle).removeClass('d-none');
      } else if (menuPosition >= menuEndOffset) {
        $(leftPaddle).removeClass('d-none');
        $(rightPaddle).addClass('d-none');
      }
    });

    //for inital state
    if (cardContainerSize - 30 <= $(window).width()) {
      $(rightPaddle).addClass('hidden');
    } else if (cardContainerSize >= $(window).width()) {
      $(rightPaddle).removeClass('hidden');
    }
   
    //Re calculate the scrollSize if the device is tablet
    var scrollSize = cardWidth;
    if($(window).width() >= 768 && $(window).width() <= 1023)
    {
      scrollSize *=  cardsNumber/2;
    }

    // scroll to left
    $(rightPaddle).on('click', function () {
      $('.parent-ceiling-container').animate({ scrollLeft: '+=' + scrollSize }, scrollDuration);
    });

    // scroll to right
    $(leftPaddle).on('click', function () {
      $('.parent-ceiling-container').animate({ scrollLeft: '-=' + scrollSize }, scrollDuration);
    });
  }
});

theme.Filters = (function () {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '.filters-toolbar__input--filter',
    sortSelection: '.filters-toolbar__input--sort',
    defaultSort: '.collection-header__default-sort'
  };

  function Filters(container) {
    var $container = this.$container = $(container);

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function (evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(window.location.search, '');
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function (evt) {
      window.location.href = this.$filterSelect.val() + window.location.search;
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function () {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function () {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function () {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};
theme.HeaderSection = (function () {

  function Header() {
    theme.Header.init();
  }
  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function () {
      theme.Header.unload();
    }
  });

  return Header;
})();


theme.WizardSection = (function () {
  function Wizard() {
    theme.Wizard.init();
  }
  Wizard.prototype = _.assignIn({}, Wizard.prototype, {
    onUnload: function () {
      theme.Wizard.unload();
    }
  });
  return Wizard;
})();

theme.CompareSection = (function () {
  function Compare() {
    theme.Compare.init();
  }
  Compare.prototype = _.assignIn({}, Compare.prototype, {
    onUnload: function () {
      theme.Compare.unload();
    }
  });
  return Compare;
})();


theme.Maps = (function () {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function () {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function (results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize');
        }.bind(this))
        .fail(function () {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }
          $map.parent().addClass('page-width map-section--load-error').html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },
    onUnload: function () { google.maps.event.clearListeners(this.map, 'resize'); }
  });
  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}
let controllerSections;
const updateSections = async (path, key) => {
  loadingOnSelectChange = true;
  try {
    if (controllerSections) {
      controllerSections.abort();
    }
    controllerSections = new AbortController();
    const { signal } = controllerSections;
    const response = await fetch(path,{ signal });
    if (response.status === 200) {
      const sections = await response.json();
      const upsellHolder = $('#product-upsell-holder');
      const volumenDiscountsWrapper = $('.vol-discounts-msg-wrapper');
      if (sections.hasOwnProperty('stock-info-banner')) {
        $('#stock_banner_holder').html(sections['stock-info-banner']);
      }
      if (sections.hasOwnProperty('product-shipping-time')) {
        $('.product-general-shipping').html(sections['product-shipping-time']);
      }
      if (sections.hasOwnProperty('specs-block')) {
        $('#specficiations_holder').html(sections['specs-block']);
      }
      if (upsellHolder.length > 0 && sections.hasOwnProperty('section-upsell-component')) {
        upsellHolder.html(sections['section-upsell-component']);
      } 
      if (volumenDiscountsWrapper.length > 0 && sections.hasOwnProperty('pdp-volume-discount-promo')) {
        volumenDiscountsWrapper.html(sections['pdp-volume-discount-promo']);
        checkVolumeDiscount(true);
      }
      if (sections.hasOwnProperty('cart-template')) {
        let scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
        let html = sections['cart-template'].replace(scriptRegex, "");
        let contentLeftTable = $(html).find(`#cartItemsId tbody`);
        if(contentLeftTable) {
          let yourCartText = $(html).find(`#pageTitleCartId`);
          $(`#pageTitleCartId`).text( yourCartText.text() );
          $(`#cart-sticky-header .page-title-cart`).text( yourCartText.text() );
          $(`#cartItemsId tbody`).replaceWith(contentLeftTable);
          $(`#asm-discount-title`).replaceWith($(html).find(`#asm-discount-title`));
          $(`#asm-discount-rate`).replaceWith($(html).find(`#asm-discount-rate`));
          $(`#pdp-shipedy-by-container-cart`).replaceWith($(html).find(`#pdp-shipedy-by-container-cart`));
          $(`.cmp-installation`).replaceWith($(html).find(`.cmp-installation`));
          $(`.klarna_cart_box`).replaceWith($(html).find(`.klarna_cart_box`));
          forcetoUpdateASMwoZIP();
          updateCartStickyPosition();
        }
      }
    } 
  } catch(error){
    if (error.name !== 'AbortError') {
      console.error(error);
    }
  } finally {
    loadingOnSelectChange = false;
  }
}
const renderCharacteristicsDetailsCommon = function (variantId) {
  const tplRowFeature = `
      <span class="characteristic-title" char="%title%">
        <img width="30" src="%img%" alt="%title%" ><span> %title%</span>
      </span>
    `;
  const tplRowFeatureModal = `
  <div class="accordion-features">
    <div class="header-accordion-features">
      <a href="javascript:void(0);" class="link-feature">
        <span class="characteristic-title">
          <img width="30" src="%img%" alt="%title%"> %title%
        </span>
        <i class="ad ad-angle-down-l"></i>
      </a>
    </div>
    <div class="body-accordion-features">%description%</div>
  </div>`;
  
  $('.char-tile-graph > div.char-tile-graph-first').hide();
  $('.char-tile-graph, .triggerModal, .nrc-up-to, .char-tile-rows').hide();
  var productMeta = Shopify.productMeta && Shopify.productMeta[variantId];
  var feature_desc = Shopify.feature_meta.feature_descriptions.array_characteristics_description;
  if (!productMeta || !productMeta.characteristics) {
    return;
  }
  var listHtml = [];
  var listHtmlModal = [];
  let hasCharts = false;
  Object.keys(productMeta.characteristics).forEach(function (key) {
    var item = productMeta.characteristics[key];
    if (item.finalValue.toString() !== 'false') {
      let itemDesc = feature_desc.find(i => i.name.includes(key));
      if (isCoolEdgeTemplate()) {
        tmpItemDesc = feature_desc.find(i => i.name.includes(key+'_cooledge'));
        if (tmpItemDesc) {
          itemDesc = tmpItemDesc;
        }
      }
      if (isSpaceKitTemplate()) {
        tmpItemDesc = feature_desc.find(i => i.name.includes(key+'_spacekit'));
        if (tmpItemDesc) {
          itemDesc = tmpItemDesc;
        }
      }
      let description = itemDesc? itemDesc.description:'';
      let titleKey = key;
      switch(key.trim()){
        case 'Sound Absorption':
          if(item.value > 0){
            $('#char-tile-absorption').parent().show();
            $('.nrc-up-to').show()
            hasCharts = true;
          }
          $('#char-tile-absorption .title-percent').html(parseFloat(item.value).toFixed(2));
          let percent = parseInt(item.value*100,0);
          $('#char-tile-absorption').attr('class', `c100 small blue p${percent}`);
          break;
        case 'Sound Blocking':
          if(item.value > 0){
            $('#char-tile-blocking').parent().show();
            hasCharts = true;
          }
          $('#char-tile-blocking .title-percent').html(item.value);
          let percent2 = parseInt(((item.value*100)/50),0);
          $('#char-tile-blocking').attr('class', `c100 small blue p${percent2}`);
          break;
        default:
          if(key == "Fire Guard"){
            titleKey = titleKey.trim().replace('Fire Guard', "FIRE GUARD");
          }
          if(isCoolEdgeTemplate()){
            item.value = item.value.replaceAll('"','');
            let titleKeyExrta = '';
            if(key === 'Light Output'){
              item.value = item.value.replace(' lumens','').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              titleKeyExrta=' lumens';
            }
            if(key === 'CCTs'){
              switch (parseInt(item.value,0)) {
                case 3000: titleKeyExrta = ', warm white color'; break;
                case 3500: titleKeyExrta = ', neutral white color'; break;
                case 4000: titleKeyExrta = ', cool white color'; break;
              }
            }
            if(key === 'CRI'){
              titleKey = `${ key }: ><b>${ item.value.replace('>','') }</b>`;
            } else {
              titleKey = `${ key }: <b>${ item.value }${ titleKeyExrta }</b>`;
            }
          }

          listHtml.push(
            tplRowFeature.replace(/%title%/ig, titleKey)
            .replace('%img%', item.iconUrl)
          );
        break;
      }
      listHtmlModal.push(
        tplRowFeatureModal.replace(/%title%/ig, titleKey)
        .replace('%description%', description)
        .replace('%img%', item.iconUrl)
      );
    }
  });
  if(hasCharts) {
    $('.char-tile-graph').show();
  }
  const sound_blocking = $('#char-tile-blocking');
  if(sound_blocking.length){
    Number(sound_blocking.find('.title-percent').text())==0 ? sound_blocking.parent().hide(): '';
  }
  if(listHtml.length){
    $('.triggerModal').show();
    $('.char-tile-rows').show();
  } else {
    if($('.fDatacenterBlock').length) {
      $('.container-details-special').css('margin-top','18px');
      $('.triggerModal').show();
      $('#hr-modal-feature-extra').hide();
    }
  }
  let listHtmlCE = [...listHtml];
  let half = Math.ceil(listHtml.length/2);
  let col1 = listHtml.splice(0,half).join('');
  let col2 = listHtml.splice(0,listHtml.length).join('');
  
  if(isCoolEdgeTemplate() || ['acoustical-accents-square','acoustical-accent-tear-drop'].includes(product.handle)){
    col1 = listHtmlCE.join('');
    col2 = '';
    $('#char-tile-col-1').removeClass('col-lg-6');
    $('#char-tile-col-2').remove();
  }
  $('#char-tile-col-1').html(col1);
  if(col2.length){
    $('#char-tile-col-2').html(col2);
  }
  
  let half_modal = Math.ceil(listHtmlModal.length/2);
  let col1_modal = listHtmlModal.splice(0,half_modal).join('');
  let col2_modal = listHtmlModal.splice(0,listHtmlModal.length).join('');
  $('#modal-features-col-1').html(col1_modal);
  $('#modal-features-col-2').html(col2_modal);
  $('.triggerModal').click(function(){JQ('#modal-features').modal('show');});
  
  $('.link-feature').click(function(){
    $('.link-feature i').addClass('ad-angle-down-l').removeClass('ad-angle-up-l');
    $('.feature-open').find(".body-accordion-features").slideUp(500);
      if(!$(this).parent().parent().hasClass("feature-open")){
        $(this).parent().parent().find(".body-accordion-features").slideDown(500);
        if(!isTileTemplate() && !isWallTemplate()){
          $(".container-features").find(".feature-open").removeClass('feature-open');
        }
        $(this).parent().parent().addClass('feature-open');
        $(this).find('i').addClass('ad-angle-up-l').removeClass('ad-angle-down-l');
      }else { 
        $(this).parent().parent().removeClass('feature-open');
      }
  });
};

/* eslint-disable no-new */
theme.Product = (function () {
  function Product(container) {
    var $container = this.$container = $(container),
      sectionId = $container.attr('data-section-id');
    var currentVariantId = $container.attr('data-current-variant');

    this.slideshow = sectionId ? '#Slideshow-' + sectionId : '#Slideshow-product-template-tile';

    this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      imageSize: null,
      imageZoomSize: null,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      originalPriceSticky: '#ProductPrice-sticky',
      originalPriceStickyM: '#ProductPrice-stickyM',
      priceUnitsSticky: '#PriceUnits-sticky',
      priceUnitsStickyM: '#PriceUnits-stickyM',
      saveAmount: '#SaveAmount-' + sectionId,
      discountBadge: '.discount-badge',
      SKU: '.variant-sku',
      description_tag: '.description_tag',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productFeaturedImage: '.FeaturedImage-' + sectionId,
      productImageWrap: '.FeaturedImageZoom-' + sectionId,
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      h2LabelSelector: 'h2.product-single__title',
      priceUnitsSelector: '.product-price__price-' + sectionId + ' .product-price__units',
      specialApplicationsSelector: '.product-meta_special-applications .slVariant',
      characteristicsSelector: '.tab-content.performance',
      shippingTextSelector: '.product-shipping-time',
      edgeSwatchModalSelector: '.swatch .edge .ad-question-cil .contact-us',
      qtyEstimatorLinkSelector: '.product-qty-estimator-link',
      modalSliderSelector: '#product-swatch-modal',
      qtyEstimatorSelector: '#product-qty-estimator-modal',
      pdpTileFaqSwatchModalSelector: '#pdp-tile-faq-modal-switch',
      pdpTileSqftCoverageSelector: '.product-price__dualholder .coverageinfo__sqft',
      pdpTilePricePerSqftSelector: '.product-price__tilesqft',
      patternModalImageWrap: '.patternModalZoom'
    };

    // Orders Message
    var orderLimit = $(".orderMsg").attr('data-user'),
      orderTime = $(".orderMsg").attr('data-time');
    $(".orderMsg .items").text(Math.floor((Math.random() * orderLimit) + 1));
    $(".orderMsg .time").text(Math.floor((Math.random() * orderTime) + 1));

    // Visotore Message
    var userLimit = $(".userViewMsg").attr('data-user'),
      userTime = $(".userViewMsg").attr('data-time');
    $(".uersView").text(Math.floor((Math.random() * userLimit)));
    setInterval(function () {
      $(".uersView").text(Math.floor((Math.random() * userLimit)));
    }, userTime);

    // Magnific Popup
    $('.mfp-link').magnificPopup({
      delegate: '.mfp',
      removalDelay: 300,
      callbacks: {
        beforeOpen: function () {
          $('.stickyHeader').addClass('popup');
          this.st.mainClass = this.st.el.attr('data-effect');
        },
        close: function () { $('.stickyHeader').removeClass('popup'); }
      },
      midClick: true
    });

    // Product tabs
    var tabs = $('.tab-container .tablink');
    $(tabs).on('click', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass("active");
      var tab = $(this).attr("href");

      $(".tab-content").each(function () {
        // pause video if any tab collapse
        // make sure to add `<script src="https://player.vimeo.com/api/player.js"></script>` in the page after the iframe Vimeo video markup
        var playerNode = $(this).find('iframe.video-player');
        try {
          var videoPlayer = playerNode.length > 0 && new Vimeo.Player(playerNode.get(0));
          if (videoPlayer) {
            videoPlayer.pause();
          }
        } catch (err) {
          console.error(err);
        }
      });

      $(tab).slideToggle();

      if ($(window).width() < 767) {
        var tabposition = $(this).offset();
        $("html, body").animate({ scrollTop: tabposition.top - 60 }, 500);
      }

    });

    $('.product-tabs li:first-child').addClass("active");
    $('.tab-container h3:first-child').addClass("active");
    $('.tab-container h3:first-child + .tab-content').show();

    $(".reviewLink").on('click', function (e) {
      e.preventDefault();
      var tab = $(this).attr("href");
      $(".product-tabs li").removeClass("active");
      $(".tablink[href='" + tab + "']").parent().addClass("active");
      $(".tab-content").not(tab).css("display", "none");
      $(tab).fadeIn();
      var tabposition = $(tab).offset();
      if ($(window).width() < 767) {
        $("html, body").animate({ scrollTop: tabposition.top - 50 }, 700);
      } else {
        $("html, body").animate({ scrollTop: tabposition.top - 100 }, 700);
      }
    });

    $(".stickyOptions .selectedOpt").on('click', function () {
      $(".stickyOptions ul").slideToggle("fast");
    });
    $(".stickyOptions .vrOpt").on('click', function (e) {
      var value = $(this).attr('data-val'),
        number = $(this).attr('data-no'),
        text = $(this).text();
      $(".selectedOpt").text(text);
      $(".stickyCart .selectbox").val(value).trigger('change');
      $(".stickyOptions ul").slideUp("fast");
      this.productvariants = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
      $(".stickyCart .product-featured-img").attr('src', this.productvariants.variants[number].featured_image.src.replace(/(\.[^\.]*$|$)/, '_60x60' + '$&'));
    });

    // change variant on image sections
    // canceled functionality in KPD-1730
    /*
    thumbnails = $('.product-single__thumbnail-image');
    if (thumbnails.length) {
      thumbnails.bind('click', function () {
        var arrImage = $(this).attr('src').split('?')[0].split('.');
        var strExtention = arrImage.pop();
        var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '');
        var strNewImage = arrImage.join('.') + "." + strRemaining + "." + strExtention;
        if (typeof variantImages[strNewImage] !== 'undefined') {
          productOptions.forEach(function (value, i) {
            optionValue = variantImages[strNewImage]['option-' + i];
            if (optionValue !== null && $('.single-option-selector:eq(' + i + ') option').filter(function () { return $(this).text() === optionValue; }).length) {
              $(".swatch-" + i).find('.swatchInput[value="' + optionValue + '"]').prop("checked", true);
              $('.single-option-selector:eq(' + i + ')').val(optionValue).trigger('change');
            }
          });
        }
      });
    }
    */

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);

    this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass('js-zoom-enabled');
    this.settings.imageSize = theme.Images.imageSize($(this.selectors.productFeaturedImage).attr('src'));

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initmainimageSlider();
    this._initThumbnailSlider();
    this._setActiveThumbnail();
    this._setCurrentProductMeta(currentVariantId);
    this._initSwatchModal();
    this._initQuantityEstimator();
    this._initPatternLibrary();
    this._renderCharacteristics(currentVariantId);
    if(isTileTemplate() || isWallTemplate() || isCoolEdgeTemplate() || isDecorativeTemplate() || isBundleTemplate() || isDefaultTemplate() || isSpaceKitTemplate()){
      this._renderCharacteristicsDetails(currentVariantId);
    }
    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    theme.Images.preload(this.productSingleObject.images, this.settings.imageSize);
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function () {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function () {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function () {
          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            _destroyZoom($(self.selectors.productImageWrap));
          }
          self.settings.bpSmall = true;
        },
        unmatch: function () {
          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function () {
          if (self.settings.zoomEnabled) {
            _enableZoom($(self.selectors.productImageWrap));
          }
        }
      });
    },

    _initVariants: function () {

      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };
      const tileCalculatorForm = $('.estimation-input-list form');
      const tileCalculatorWrapper = $('.qty-estimator-toggle');
      const triggerCalculator = () => {
        tileCalculatorWrapper.hasClass('active') && tileCalculatorForm.trigger('submit');
      }
      this.variants = new slate.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCart.bind(this));
      this.$container.on('variantChange' + this.settings.namespace, this._updateVariantMeta.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
      this.$container.on('variantSKUChange' + this.settings.namespace, this._updateSKU.bind(this));
      
      if(isTileTemplate() && tileCalculatorForm.length && tileCalculatorWrapper.length) this.$container.on('variantChange', triggerCalculator);
      gvariant = this.variants.currentVariant;
      displayInitialDiscount()
    },

    _initImageSwitch: function () {
      
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }
      $(document).ready(function(){
        $('.prod-img-slider .slick-slider .slick-prev').on("click",function(){
          var lastActive = $(".active-thumb");
          var nextActive = $(lastActive).parent().prev();
          $(lastActive).removeClass('active-thumb');
          $(nextActive).children().addClass('active-thumb');
        });
        $('.prod-img-slider .slick-slider .slick-next').on("click",function(){
          var lastActive = $(".active-thumb");
          var nextActive = $(lastActive).parent().next();
          $(lastActive).removeClass('active-thumb');
          $(nextActive).children().addClass('active-thumb');
        });
      });
      var self = this;
      
      $(this.selectors.productThumbImages).on('click', function (evt) {
        evt.preventDefault();
        var $el = $(this),
          imageSrc = $el.attr('href'),
          zoomSrc = $el.data('zoom');
        self._setActiveThumbnail(imageSrc);
        self._switchImage(imageSrc, zoomSrc);
      });
    },

    _switchImage: function (image, zoomImage) {
      if ($(".index-section--featured-product").length) {
        var $image = $(this.selectors.productImageWrap + '[data-zoom="' + zoomImage + '"]').data('slide');
        $(this.selectors.productFeaturedImage).attr('src', image);

        // destroy image zooming if enabled
        if (this.settings.zoomEnabled) {
          _destroyZoom($(this.selectors.productImageWrap));
        }

        if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {
          $(this.selectors.productImageWrap).data('zoom', zoomImage);
          _enableZoom($(this.selectors.productImageWrap));
        }
      }
    },

    _setActiveThumbnail: function (src) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof src === 'undefined') {
        src = $(this.selectors.productThumbImages + '.activeSlide').attr('href');
      }

      // Set active thumbnails (incl. slick cloned thumbs) with matching 'href'
      var $thumbnail = $(this.selectors.productThumbImages + '[href="' + src + '"]');
      $(this.selectors.productThumbImages).removeClass(activeClass);
      $thumbnail.addClass(activeClass);
      var slideno = $thumbnail.parent().data('slide');
      if (theme.productStrings.prStyle == "style4" || theme.productStrings.prStyle == "style5") {
        var imgposition = $(".product-single__photo[data-slide='" + slideno + "']").offset();
        if ($(window).width() > 767) {
          $("html, body").animate({ scrollTop: imgposition.top - 70 }, 700);
        } else {
          $('.primgSlider').slick('slickGoTo', slideno);
        }
      } else {
        $('.primgSlider').slick('slickGoTo', slideno);
      }
      const intialFlagSlider =  document.querySelector(`.product-single__photo.initial-flag-position`);
      const hasAvailableFlag = document.querySelector('.available-custom-flag');
      if(!intialFlagSlider && typeof gvariant !== 'undefined' && hasAvailableFlag) {
        const initialFlagSlide = document.querySelector(`.product-single__photo.slick-current.slick-active`);
          if(initialFlagSlide) {
            initialFlagSlide.classList.add('initial-flag-position');
            initialFlagSlide.setAttribute('initial-variant-id', gvariant.id);
          }
      }else if(typeof discountedVariants != 'undefined' && typeof gvariant !== 'undefined' && discountedVariants.includes(`${gvariant.id}`)) {
        const initialFlagSlide = document.querySelector(`.product-single__photo.slick-current.slick-active`);
        if(initialFlagSlide) initialFlagSlide.classList.add('on-sale-flag');
      }
    },

    _initmainimageSlider: function () {
      var slidetoshow = 1,
        fade = true,
        centermode = false,
        loop = false;
      if (theme.productStrings.prStyle == "style2") {
        slidetoshow = 2;
        fade = false;
      } else if (theme.productStrings.prStyle == "style7") {
        slidetoshow = 3;
        centermode = true;
        loop = true;
        fade = false;
      }
      if($(".primgSlider.grid-pdp").length){
        $(".primgSlider.grid-pdp").slick({
          slidesToShow: slidetoshow,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          // rtl: theme.rtl,
          //  fade: true,
          centerMode: true,
          centerPadding: 0,
          dots:false,
          asNavFor: this.selectors.productThumbs,
          responsive: [{
            breakpoint: 767,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: 599,
            settings: {
              slidesToShow: 3,
              arrows: true,
              // dots: true,
              centerMode: true,
              asNavFor: '.slick-dots.grid-pdp-dots',
              // centerPadding:'30px',
              variableWidth: true,
            }
          }]
        });
      }
      if($('.slick-dots.grid-pdp-dots').length){
        $('.slick-dots.grid-pdp-dots').slick({
          verticalSwiping: true,
          vertical: false,
          slidesToShow: 12,
          slidesToScroll: 1,
          infinite: true,
          rtl: theme.rtl,
          asNavFor: '.primgSlider',
          focusOnSelect: true,
          arrows:true,
        });
      }
    
      if (!$(".primgSlider").hasClass('grid-pdp')) {
        $(".primgSlider").slick({
          slidesToShow: slidetoshow,
          slidesToScroll: 1,
          infinite: true,
          rtl: theme.rtl,
          fade: fade,
          centerMode: centermode,
          centerPadding: 0,
          asNavFor: this.selectors.productThumbs,
          responsive: [{
            breakpoint: 767,
            settings: {
              slidesToShow: 1
            }
          }]
        });
      }
      if (theme.productStrings.prStyle == "style4" || theme.productStrings.prStyle == "style5") {
        $(window).on('load resize', function () {
          if ($(window).width() > 767) {
            $(".primgSlider").slick('unslick');
          } else {
            $(".primgSlider").slick("refresh");
          }
        });
      }
    },

    _initThumbnailSlider: function () {
      var sliderpos = $(this.selectors.productThumbs).attr('data-slider'),
        verticle = true,
        thumbcount = 5,
        rtl = theme.rtl,
        infiniteScroll = false;

      if (sliderpos == 'bottom') {
        verticle = false;
        thumbcount = 6;
      }
      if ($(".primgSlider").hasClass('grid-pdp')) {
        verticle = false;
        thumbcount = 4;
        rtl = false;
        infiniteScroll = true;
      }
      $(this.selectors.productThumbs).slick({
        verticalSwiping: true,
        vertical: verticle,
        slidesToShow: thumbcount,
        slidesToScroll: 1,
        infinite: infiniteScroll,
        rtl: rtl,
        asNavFor: '.primgSlider',
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: thumbcount,
              vertical: false,
              swipe: true,
              verticalSwiping: false,
              draggable: false
            }
          }
        ]
      });
      
      /* Display desktop flag only on the first slick */
      const mobileBreakpoint = 1025;
      $('#PageContainer.product .primgSlider').on('beforeChange', function(){
        const deviceClass = $(window).width() < mobileBreakpoint ? 'mobile' : 'desktop';
        const pdpRibbonFlag = $(`#PageContainer.product .custom-flag.pdp-flag.${deviceClass}`);
        if(pdpRibbonFlag.length && pdpRibbonFlag.is('.active, .active-sale-flag')) {
          pdpRibbonFlag.addClass('activeFlag');
          pdpRibbonFlag.removeClass('active');
        }  
        
      });
      $('#PageContainer.product .primgSlider').on('afterChange', function(){
        const deviceClass = $(window).width() < mobileBreakpoint ? 'mobile' : 'desktop';
        const pdpRibbonFlag = $(`#PageContainer.product .custom-flag.pdp-flag.activeFlag.${deviceClass}`);
        const currentSlick = $('#PageContainer.product .product-single__photo.slick-slide.slick-current.slick-active');
        if(pdpRibbonFlag.length && (currentSlick.hasClass('initial-flag-position') && typeof gvariant != 'undefined' && gvariant.id == currentSlick.attr('initial-variant-id')) || currentSlick.hasClass('on-sale-flag')) {
          pdpRibbonFlag.addClass('active');
        }
      });
    },

    _updateAddToCart: function (evt) {
      var variant = evt.variant;
      gvariant = evt.variant;
      if(isTileTemplate() || isWallTemplate() || isCoolEdgeTemplate() || isDecorativeTemplate() || isBundleTemplate() || isDefaultTemplate() || isSpaceKitTemplate()){
        validateButton();
      }
      if (variant) {
        $(this.selectors.productPrices).removeClass('visibility-hidden').attr('aria-hidden', 'true');

        if (variant.unit_price != undefined) {
          $("[data-unit-price]").html(theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat));
          $("[data-unit-base]").html(variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit);
          $(".price__unit").removeClass('hide');
        } else {
          $(".price__unit").addClass('hide');
        }

        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          // $(".instock").removeClass("hide");
          // $(".outstock").addClass("hide");
          var quantity = $("#pvr-" + variant.id).text(),
            maxquantity = $("#quantity_message").data('qty');
          if (quantity < maxquantity && quantity != 0 && variant.inventory_management == "shopify") {
            $("#quantity_message").show().find(".items").text(quantity);
          } else {
            $("#quantity_message").hide();
          }
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          // $(".instock").addClass("hide");
          // $(".outstock").removeClass("hide");
          $("#quantity_message").hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.productPrices).addClass('visibility-hidden').attr('aria-hidden', 'false');
        // $(".instock").addClass("hide");
        // $(".outstock").removeClass("hide");
        $("#quantity_message").hide();
      }
    },

    _updateImages: function (evt) {
      var variant = evt.variant,
        sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize),
        zoomSizedImgUrl;
      this._setActiveThumbnail(sizedImgUrl);
      if (this.settings.zoomEnabled) {
        zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageZoomSize);
      }
      this._switchImage(sizedImgUrl, zoomSizedImgUrl);
    },

    _updatePrice: function (evt) {
      var variant = evt.variant;
      gvariant = evt.variant;
      var productMeta = Shopify.productMeta && Shopify.productMeta[variant.id];
      let priceWrapper = isDefaultTemplate() ? $('.default-template-price') : $(this.selectors.originalPrice);
      // Update the product price
      let variantPrice = variant.price;
      priceWrapper.html(theme.Currency.formatMoney(variantPrice, theme.moneyFormat));
      //Update Price and PriceUnits for sticky header on PDP.
      $(this.selectors.originalPriceSticky + ' strong').html(theme.Currency.formatMoney(variantPrice, theme.moneyFormat));
      $(this.selectors.priceUnitsSticky).html(productMeta.priceUnits);
      $(this.selectors.originalPriceStickyM + ' strong').html(theme.Currency.formatMoney(variantPrice, theme.moneyFormat));
      $(this.selectors.priceUnitsStickyM).html(productMeta.priceUnits);

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variantPrice) {
        $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).removeClass('hide');
        $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);
        $(this.selectors.saleLabel).removeClass('hide');
        var price1 = variant.compare_at_price - variantPrice,
          price2 = price1 * 100,
          salecount = price2 / variant.compare_at_price;
        $(this.selectors.discountBadge).find('.off').find('span').text(+salecount.toFixed());
        $(this.selectors.discountBadge).removeClass('hide');
        $(this.selectors.saveAmount).html(theme.Currency.formatMoney(price1, theme.moneyFormat));

      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.discountBadge).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
      }
    },

    _updateSKU: function (evt) {
      var variant = evt.variant;
      $(this.selectors.SKU).html(variant.sku);
    },


    /**
     * Triggered by `variantChange` event when a user selects different product options
     * and updates the product variant meta data
     *
     * @param {object} evt Product event payload
     */
    _updateVariantMeta: function (evt) {
      var variant = evt.variant;
      gvariant = evt.variant;
      if (!variant) {
        return;
      }
      var productMeta = Shopify.productMeta && Shopify.productMeta[variant.id];
      if (!productMeta) {
        return;
      }
      // Update product price units
      if (productMeta.priceUnits) {
        $(this.selectors.priceUnitsSelector).html(productMeta.priceUnits);
        if(isTileTemplate() || isWallTemplate() || isCoolEdgeTemplate() || isDecorativeTemplate() || isBundleTemplate() || isDefaultTemplate() || isSpaceKitTemplate()){
          validateButton();
        }
      }
      // Update product sqft coverage
      if (productMeta.sqftPerCarton){
        if(isTileTemplate() || isWallTemplate() || isDefaultTemplate() || isDecorativeTemplate() || isBundleTemplate() || isSpaceKitTemplate()){
          $(this.selectors.pdpTileSqftCoverageSelector).html(productMeta.sqftPerCarton);
        }
      }
      // Update product price per sqft
      if (productMeta.pricePerSqft){
        if(isTileTemplate() || isWallTemplate() || isDefaultTemplate() || isDecorativeTemplate() || isBundleTemplate()){
          let pricePerSqft = isBundleTemplate() && checkDateRange() && bundle_discount_price ? `$${variant.price_per_sqft}` : productMeta.pricePerSqft;
          $(this.selectors.pdpTilePricePerSqftSelector).html(pricePerSqft);
          
          //change design if price_per_unit or price_per_unit_ca is 0 temp
          /*
          let intSqft = parseInt(pricePerSqft.replace('$',''));
          if (intSqft != 0){
            $('#tilesAmountNormal span').first().removeClass('hide');
            $('#tilesAmountNormal .product-price__dualholder').removeClass('noborder');
            $('.oldcartonPrice span').first().removeClass('hide');
            $('.tilesPrice .leftPriceRate').removeClass('hide');
            $('.coverSqFtSide').addClass('product-price__dualholder');
            $('.coverSqFtSide').addClass('dualBorder');
          } else{
            $('#tilesAmountNormal span').first().addClass('hide');
            $('#tilesAmountNormal .product-price__dualholder').addClass('noborder');
            $('.oldcartonPrice span').first().addClass('hide');
            $('.tilesPrice .leftPriceRate').addClass('hide');
            $('.coverSqFtSide').removeClass('product-price__dualholder');
            $('.coverSqFtSide').removeClass('dualBorder');
          }
          */
        }
      }
      // Update special applications
      if (productMeta.specialApplications) {
        $(this.selectors.specialApplicationsSelector).html(productMeta.specialApplications);
      }

      // Update H2 label
      if (productMeta.subCategoryLabel) {
        $(this.selectors.h2LabelSelector).html(productMeta.subCategoryLabel);
      }

      if (productMeta.mfgProcess) {
        // $(this.selectors.shippingTextSelector).html(productMeta.mfgProcess);
      }

      if (productMeta.description_tag != '') {
        $(this.selectors.description_tag).html(productMeta.description_tag);
      } else {
        $(this.selectors.description_tag).html(variant.productDescription);
      }

      this._setCurrentProductMeta(variant.id);
      this._renderCharacteristics(variant.id);
      if(isTileTemplate() || isWallTemplate() || isCoolEdgeTemplate() || isDecorativeTemplate() || isBundleTemplate() || isGridTemplate() || isDefaultTemplate() || isSpaceKitTemplate()){
        this._renderCharacteristicsDetails(variant.id);
      }
    },
    _renderCharacteristicsDetails: renderCharacteristicsDetailsCommon,
    _renderCharacteristics: function (variantId) {
      var characteristicsSelector = $(this.selectors.characteristicsSelector);
      if (!characteristicsSelector.length) {
        return;
      }

      var productMeta = Shopify.productMeta && Shopify.productMeta[variantId];

      if (!productMeta || !productMeta.characteristics) {
        return;
      }
      // table header
      var tableHtml = [
        [
          '<div class="characteristics-table__row">',
          '<div class="characteristics-table__cell"></div>',
          '<div class="characteristics-table__cell characteristics-table__cell--quality characteristics-table__cell--head"><span class="head-label">Good</span></div>',
          '<div class="characteristics-table__cell characteristics-table__cell--quality characteristics-table__cell--head"><span class="head-label">Better</span></div>',
          '<div class="characteristics-table__cell characteristics-table__cell--quality characteristics-table__cell--head"><span class="head-label">Best</span></div>',
          '</div>'
        ].join('')
      ];
      // generate table body
      Object.keys(productMeta.characteristics).forEach(function (key) {
        var item = productMeta.characteristics[key];
        if (item.finalValue !== 'false') {
          var finalValue = item.finalValue;
          var iconUrl = item.iconUrl;
          var hasQuality = item.hasQuality;
          var qualityRowCls = hasQuality ? 'characteristics-table__row--quality' : '';
          var qualityCellCls = hasQuality ? 'characteristics-table__cell--quality' : '';
          
          tableHtml.push([
            '<div class="characteristics-table__row ' + qualityRowCls + '">',
            '<div class="characteristics-table__cell">',
            '<i class="ad ad-check-r"></i>',
            '<img width="30" src="' + iconUrl + '" alt="' + key + '">',
            '<span class="characteristics-text">' + key + '</span>',
            '</div>',
            qualityCellCls ? '<div class="characteristics-table__cell ' + qualityCellCls + ' ' + (finalValue === 'good' ? 'characteristics-table__cell--checked' : '') + '"></div>' : '',
            qualityCellCls ? '<div class="characteristics-table__cell ' + qualityCellCls + ' ' + (finalValue === 'better' ? 'characteristics-table__cell--checked' : '') + '"></div>' : '',
            qualityCellCls ? '<div class="characteristics-table__cell ' + qualityCellCls + ' ' + (finalValue === 'best' ? 'characteristics-table__cell--checked' : '') + '"></div>' : '',
            '</div>'
          ].join(''));
        }
      });
      
      characteristicsSelector.html(tableHtml.join(''));

     
    },

    /**
     * Set `currentProductMeta` instance variable with the current variant metafield data
     */
    _setCurrentProductMeta: function (variantId) {
      this.currentProductMeta = Shopify.productMeta && Shopify.productMeta[variantId] || {};
    },

    /**
     * Instantiates a product swatch modal(currently for Edge and Grid) and initializes an image slider.
     * Also attaches event listener for slider controls.
     *
     */
    _initSwatchModal: function () {
      var $slideshow = $(this.slideshow);
      var dots = $('.dot', this.selectors.modalSliderSelector);
      var prevBtn = $('.slide-control .slick-prev', this.selectors.modalSliderSelector);
      var nextBtn = $('.slide-control .slick-next', this.selectors.modalSliderSelector);

      // slide image by clicking dots
      dots.click(function (evt) {
        $slideshow.slick('slickGoTo', $(evt.currentTarget).index(), false);
      });
      // slide to previous one
      prevBtn.click(function () {
        $slideshow.slick('slickPrev');
        $(this).blur();
        
      });
      // slide to next one
      nextBtn.click(function () {
        $slideshow.slick('slickNext');
        $(this).blur();
      });

      // synchronize UI state
      $slideshow.on('init afterChange', function (_, slick) {
        var currentSlide = slick.currentSlide;
        var isLast = currentSlide === slick.slideCount - 1;
        prevBtn.prop('disabled', currentSlide === 0);
        nextBtn.prop('disabled', isLast);
        // update dots state
        dots.removeClass('active').eq(currentSlide).addClass('active');
        $('.modal-body').animate({scrollTop:0}, 'slow');
        // update image label
        var label = isLast ? 'What is an Edge Profile?':'What is a Grid?';
        var dir = isLast ? 'Previous' : 'Next';
        $('.slide-control .slide-title').text(label);
        $('.slide-control .slide-title-dir').text(dir);
      });

      // initialize slider
      setTimeout(function () {
        $slideshow.slick({
          accessibility: false,
          arrows: false,
          dots: false,
          autoplay: false,
          touchThreshold: 20,
          rtl: theme.rtl,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false
        });
      }, 200);
    },

    /**
     * Instantiates a tile estimator modal and add listener to open the modal.
     */
    _initQuantityEstimator: function () {
      var modal = new window.Modals(this.selectors.qtyEstimatorSelector.slice(1), 'product-tile-estimator');

      var ESTIMATION_TYPE = {
        DIMENSION: 'dimension',
        AREA: 'area'
      };
      var LIST_LABEL_TEMPLATE_PREFIX = '#estimation-input-list-label';
      var LIST_ITEM_TEMPLATE_PREFIX = '#estimation-input-list-item';

      var estimationForm = $('.estimation-input-list form');
      var listLabelContainer = $('.estimation-input-list-label-container');
      var resultContainer = $('.result-container');

      // Store input label templates per `ESTIMATION_TYPE` enum
      var listLabelTemplates = {};
      listLabelTemplates[ESTIMATION_TYPE.DIMENSION] = $([LIST_LABEL_TEMPLATE_PREFIX, ESTIMATION_TYPE.DIMENSION].join('-')).html();
      listLabelTemplates[ESTIMATION_TYPE.AREA] = $([LIST_LABEL_TEMPLATE_PREFIX, ESTIMATION_TYPE.AREA].join('-')).html();

      // Store input field templates per `ESTIMATION_TYPE` enum
      var listItemTemplates = {};
      listItemTemplates[ESTIMATION_TYPE.DIMENSION] = $([LIST_ITEM_TEMPLATE_PREFIX, ESTIMATION_TYPE.DIMENSION].join('-')).html();
      listItemTemplates[ESTIMATION_TYPE.AREA] = $([LIST_ITEM_TEMPLATE_PREFIX, ESTIMATION_TYPE.AREA].join('-')).html();

      // Set initial state
      var currentEstimationType = ESTIMATION_TYPE.AREA;
      var listItemContainer ="";
      if($('#ProductSection-product-template-grid').length){
        listItemContainer= $('#estimator-grid-type-'+ currentEstimationType +' .estimation-input-list-items');
      }else{
        listItemContainer = $('.estimation-input-list-items');
      }
      resetForm(currentEstimationType);

      // Set context same as instance
      var performEstimate = $.proxy(performEstimate, this);

      // Estimation Type Radio Group change handler
      $('input[name="estimation-type"]').on('click', function () {
        currentEstimationType = $(this).val();
        if($('#ProductSection-product-template-grid').length){
          listItemContainer= $('#estimator-grid-type-'+ currentEstimationType +' .estimation-input-list-items');
        }
        resetForm(currentEstimationType);
        _reMapInputs();
      });

      // `Add Area` button click handler
      $('.add-btn').on('click', function () {
        var itemTmpl = listItemTemplates[currentEstimationType];
        listItemContainer.append(itemTmpl);
        checkListItemCount();
        _reMapInputs();
      });

      // `Remove Area` button click handler
      if($('#ProductSection-product-template-grid').length){
        $('.estimation-input-list-items').on('click', '.remove-btn', function () {
          $(this).parent().parent().remove();
          checkListItemCount();
        });
        $('.estimation-input-list-items').on('keydown', 'input', function () {
          $(this).parent().removeClass('has-error');
        });
      }else{
        listItemContainer.on('click', '.remove-btn', function () {
          $(this).parent().parent().remove();
          checkListItemCount();
        });
      }
      
      resultContainer.on('click', '.update-quantity-btn', function () {
        $('input.qty').val(resultContainer.data('quantity'));
        modal.close();
      });

      estimationForm.submit(function (event) {
        event.preventDefault();
        calculateEstimation();
      });
      
      const inputField = document.querySelector('.js-auto-calculation-input');
      inputField?.addEventListener('input', handleCalculation);
      inputField?.addEventListener('click', handleRemove);
      
      function handleCalculation() {
        const dimensionInput = document.getElementById('estimation-type-dimension');
        let applyDefault = {"totalArea": 1, "quantity": 1};
        if(dimensionInput?.checked) {
          const inputLength = document.querySelector('.estimation-input-length');
          const inputWidth = document.querySelector('.estimation-input-width');
          if(validateInput(inputLength) && validateInput(inputWidth)) applyDefault = false;
        }else {
          const inputArea = document.querySelector('.estimation-input-area');
          if(validateInput(inputArea)) applyDefault = false;
        }
        calculateEstimation(applyDefault);
      }
      
      function handleRemove(e) {
        const element = e.target;
        if(element.classList.contains('remove-btn') || element.closest('.remove-btn')) handleCalculation();
      }
      
      function calculateEstimation(setDefault = false) {
        var result = !setDefault ? performEstimate() : setDefault;
        var resultContainerTmpl = $('#estimation-result-container').html();
        resultContainerTmpl = resultContainerTmpl.replace('{sqrt}', result.totalArea.toFixed(2));
        if (result.quantity) {
          $resultContainerTmpl = $(resultContainerTmpl);
          var quantityValue = $('.estimated-quantity-value', $resultContainerTmpl);
          var resultUnitSingular = quantityValue.data('resultUnitSingular');
          var resultUnitPlural = quantityValue.data('resultUnitPlural');
          var resultUnit = result.quantity > 1 ? resultUnitPlural : resultUnitSingular;
          quantityValue.text(result.quantity + ' ' + resultUnit);
          resultContainer.html($resultContainerTmpl.html()).data('quantity', result.quantity);
          
          var formattedTotalArea = result.totalArea.toFixed(2).toString();
          x = formattedTotalArea.toString();
          var pattern = /(-?\d+)(\d{3})/;
          while (pattern.test(formattedTotalArea))
            formattedTotalArea = formattedTotalArea.replace(pattern, "$1,$2");
          
          $('.qty-estimator-result-input').val(result.quantity);
          $('.qty-estimator-result-input').change();
          $('#qty-estimator-calculated-area').html(formattedTotalArea);
          $('.qty-estimator-results-txt-inner').css('display', 'inline-block');
        }
      }

      // open modal when the quantity estimator link is clicked
      $(this.selectors.qtyEstimatorLinkSelector).on('click', function () {
        currentEstimationType = ESTIMATION_TYPE.DIMENSION;
        resetForm(currentEstimationType);
        modal.open();
      });

      // Reset the input form with given estimation type
      function resetForm(estimationType) {
        $('input[name="estimation-type"][value=' + estimationType + ']').prop('checked', true);
        listLabelContainer.html(listLabelTemplates[estimationType]);
        listItemContainer.empty();
        listItemContainer.append(listItemTemplates[estimationType]);
        checkListItemCount();
        resultContainer.empty();
      }
      
       function _reMapInputs (){
        // Disable Mouse scrolling
        $('input[type=number]').on('mousewheel',function(e){ $(this).blur(); });
        // Disable keyboard scrolling
        $('input[type=number]').on('keydown',function(e) {
            var key = e.charCode || e.keyCode;
            // Disable Up and Down Arrows on Keyboard
            if(key == 38 || key == 40 ) {
          e.preventDefault();
            } else {
          return;
            }
        });
      }

      // House keeping `Remove Area` button
      function checkListItemCount() {
        var listItems = listItemContainer.children();
        var firstItem = listItems.first();
        var removeBtnContainer = $('.remove-btn-container', firstItem);
        // remove `Remove Area` button if there is only one item, otherwise have `Remove Area` button to all items
        if (listItems.length === 1) {
          removeBtnContainer.empty();
        } else if (removeBtnContainer.children().length === 0) {
          removeBtnContainer.html($('.remove-btn-container', listItemTemplates[currentEstimationType]).html());
        }
      }

      // Calculate to Total Area (sqft) and Estimated Quantity and return the result.
      function performEstimate() {          
        var AREA_BUFFER_RATIO = 1.02;
        var sqftPerCarton = Number(this.currentProductMeta.sqftPerCarton);
        var listItems = listItemContainer.children();
        var $totalAreaList;
        var totalArea;
        var quantity;

        if (currentEstimationType === ESTIMATION_TYPE.DIMENSION) {
          $totalAreaList = listItems.map(function () {
            var lengthEl = $('.estimation-input-length', this);
            var widthEl = $('.estimation-input-width', this);
            var length = lengthEl.val();
            var width = widthEl.val();
            // IE11 treatment
            // Number input in IE11 allows to type non-numeric value only when it's followed by numeric value
            // Converting the input value after stripping out non-numeric value should return number
            // Empty input is already checked by required form validation before submission
            length = Number(length.replace(/[^0-9.]/g, ''));
            width = Number(width.replace(/[^0-9.]/g, ''));
            lengthEl.val(length);
            widthEl.val(width);
            return length * width;
          });
        } else {
          $totalAreaList = listItems.map(function () {
            var areaEl = $('.estimation-input-area', this);
            var area = areaEl.val();
            area = Number(area.replace(/[^0-9.]/g, ''));
            areaEl.val(area);
            return area;
          });
        }
        totalArea = $totalAreaList
          .get()
          .reduce(function (acc, item) {
            acc += item;
            return acc;
          });

        // Additional material to cover any breaks or waste
        totalArea = totalArea * AREA_BUFFER_RATIO;

        estimatorGrid.calculateUpsell(totalArea);

        // totalArea = roundOffTo(totalArea);// round to next 100

        if (sqftPerCarton) {
          quantity = Math.ceil(totalArea / sqftPerCarton);
        }
        //Set default values to be calculated on variant change.
        totalArea = totalArea > 0 ? totalArea : 1;
        quantity = quantity > 0 ? quantity : 1;
        return {
          totalArea: totalArea,
          quantity: quantity
        };
      }
    },
    
    _initPatternLibrary: function() {
      /* Patterns slider and modal */
      const isCenter = $('#patternSlider .pattern-item').length > 1 ? true : false;
      $('#patternSlider').slick({
        centerMode: false,
        slidesToShow: 3,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: isCenter,
              centerPadding: '58px',
            }
          }
        ]
      });
      
      $('#patternSlider .pattern-item').on('mouseover', function() {
        if ($(window).width() >= 1025) {
          const $self = $(this);
          const alternative_image = $self.attr("alt-img");
          const img = $self.find('.pattern-img');
          img.attr('src', alternative_image);
        }

      });
      $('#patternSlider .pattern-item').on('mouseout', function() {
        if ($(window).width() >= 1025) {
          const $self = $(this);
          const regular_image = $self.attr("bg-img");
          const img = $self.find('.pattern-img');
          img.attr('src', regular_image); 
        };
   
      });
      
      $("#patternSlider .pattern-item").on("click", function() {
        const slider_position = $(this).attr("slide_position");
        const productPatterns = $('.js-pattern-modal-slider .pattern-item');
        productPatterns.each(function() {
          const variantItems = $(this).find('.variant-item');
          const buy_btn = $(this).closest(".pattern-item").find(".cart-btn .submit_button");
          const mobile_buy_btn = $(this).closest(".pattern-item").find(".mobile-footer .cart-btn-mobile .submit_button");
          patternsDisableBuy(variantItems, buy_btn, mobile_buy_btn);
        });
        $('.js-pattern-modal-slider').slick('slickGoTo', slider_position);
        JQ('#modal-patterns').modal('show');
        setTimeout(() => {
          $('.modal-content').removeClass('invisible');
          $('.js-pattern-modal-slider').removeClass('invisible');
          $('.js-pattern-modal-slider').slick('refresh');
          setPatternScrollToTop();
          insertActiveClassToDots();
        }, 500);
        
      });
      
      $('.js-pattern-modal-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        dots: true,
        dotsClass: 'slick-dots pattern-dots',
        appendDots: $('.dots-wrapper.dots'),
        prevArrow: $('.arrows-wrapper .left-arrow-wrapper .left-arrow'),
        nextArrow: $('.arrows-wrapper .right-arrow-wrapper .right-arrow'),
        initialSlide: 0,
      });
      $('.js-pattern-modal-slider').on('beforeChange', function(){
        setPatternScrollToTop();
      });
      
      function setPatternScrollToTop() {
        const pattern_item_content = $('.pattern-item .item-content');
        pattern_item_content.scrollTop(0);
      }
      /* Add Active Class to patterns dots after to refresh slick */
      function insertActiveClassToDots() {
        $("#modal-patterns .js-pattern-modal-slider .slick-slide").each(function( index ) {
          const dots_list = $(this).find(".dots-wrapper .slick-dots li");
          const active_dot = $(dots_list.get(index));
          active_dot.addClass('slick-active active');
        });
      }     
      //When Close Modal
      $("#modal-patterns").find(".btn--link").on("click", function() {
        setTimeout(() => {
          $('#modal-patterns .modal-content').addClass('invisible');
          $('.js-pattern-modal-slider').addClass('invisible');
          removeBundleAllBundlesKits();
      }, 250);
      });
      $("#modal-patterns").keyup(function(e){
        if(e.which==27) {
          setTimeout(() => {
            $('#modal-patterns .modal-content').addClass('invisible');
            $('.js-pattern-modal-slider').addClass('invisible');
            removeBundleAllBundlesKits();
        }, 250);
        }
      });
      
      window.addEventListener('click', function(e) {

        if (document.getElementById('content_modal') && document.getElementById('content_modal').contains(e.target)){} 
        else{
          setTimeout(() => {
            $('#modal-patterns .modal-content').addClass('invisible');
            if($('.js-pattern-modal-slider').length){
              $('.js-pattern-modal-slider').addClass('invisible');
              removeBundleAllBundlesKits();
            }
            }, 250);
        }
      })
 
      // Enable the zoom on the modal items
      _enableZoom($(this.selectors.patternModalImageWrap));
    },

    onUnload: function () {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom($el) {
    $($el).each(function () {
      var zoomUrl = $(this).data('zoom');
      $(this).zoom({
        url: zoomUrl
      });
    });
  }

  function _destroyZoom($el) {
    $($el).each(function () {
      $(this).trigger('zoom.destroy');
    });
  }
  return Product;
})();

function removeBundleAllBundlesKits (){
  //only for patterns
  $('.js-pattern-modal-slider').find('.pattern-item .add-bundles-installation').each(function (e){
    $(this).hasClass('addedIBundle')?$(this).trigger('click'):'';
    
  })
} 
//open live chat function to use for any trigger event such like onClick
function openLiveChat(){
  LiveChatWidget.call("maximize");
}
// Product quick view
theme.QuickView = (function () {
  $('body').on('click', '.quick-view', function (e) {
    $('.drift-frame-controller').hide(); //hide the bubble chat in quick-view
    $.ajax({
      beforeSend: function () {
        $('body').addClass("loading");
      },
      url: $(this).attr('data-src'),
      success: function (data) {
        $.magnificPopup.open({
          items: {
            src: '<div class="quick-view-popup mfp-with-anim" id="content_quickview" >' + data + '</div>',
            type: 'inline'
          },
          removalDelay: 500,
          callbacks: {
            beforeOpen: function () {
              $('.stickyHeader').addClass('popup');
              this.st.mainClass = 'mfp-zoom-in';
            },
            open: function () {
              $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
              $('input[type=checkbox]:not(.no-custom-input)').awesomeCheckboxInput();
              $('input[type=radio]:not(.no-custom-input)').awesomeRadioInput();
            },
            close: function () {
              $('.stickyHeader').removeClass('popup');
              $('#content_quickview').empty();
              $('.drift-frame-controller').show();
            }
          },
        });
      },
      complete: function () {
        $('body').removeClass("loading");
      }
    });
    e.preventDefault();
    e.stopPropagation();
  });
})();




theme.Quotes = (function () {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: true,
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    rtl: theme.rtl,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  function Quotes(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.quotes-wrapper';
    var slider = this.slider = '#Quotes-' + sectionId;
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: theme.rtl,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function () {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function () {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      $list.removeAttr('aria-live');
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });
  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $('.slideshow__video', slideshow).each(function () {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function () {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function (evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function () {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

// CATEGORY SLIDER
theme.collectionView = (function () {
  var FlagFilters = true;
  function collectionView(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id'),
      sliderSecond = $container.attr('data-section-timeout');

    ajaxfilter = (function (url) {
      var urlparam = getSearchParams(),
        urlparam = $.param(urlparam);

      if (urlparam) {
        var splite_url = url.split('?');
        url = splite_url.join('?');
        //url = splite_url[0];
      }

      $.ajax({
        type: 'GET',
        url: url,
        data: {},
        beforeSend: function () {
          $('body').addClass('loading hideOverly');
        },
        complete: function (data) {
          $('.productList .current-tags').html($(".productList .current-tags", data.responseText).html());
          $('.productList .grid-products').html($(".productList .grid-products", data.responseText).html());
          $('.productList .list-view-items').html($(".productList .list-view-items", data.responseText).html());
          $('.filters-toolbar__product-count').html($(".filters-toolbar__product-count", data.responseText).html());

          $('.sidebar_tags').html($(".sidebar_tags", data.responseText).html());
          check_filters();
          initTabs();

          $('.filter-list').each(function () {
            let $self = $(this);
            let listLeng = $self.find('li').length;

            if (listLeng <= 4) {
              $self.find('.collapse-tags').hide();
            }
          });

          $('.collapse-tags').on('click', function () {
            var self = $(this);
            var parent = self.parent();
            if (parent.hasClass('should-collapse')) {
              parent.removeClass('should-collapse');
              self.text('Show Fewer');
            } else {
              parent.addClass('should-collapse');
              self.text('Show All');
            }
          });

          $('.pagination').html($(".pagination", data.responseText).html());
          if (!$(".pagination", data.responseText).html()) {
            $('.pagination').hide();
          } else {
            $('.pagination').show();
          }
          $('.infinitpaginOuter').html($(".infinitpaginOuter", data.responseText).html());
          if (!$(".infinitpaginOuter", data.responseText).html()) {
            $('.infinitpagin').remove();
          }
          if (theme.mlcurrency) { currenciesChange("sapn.money"); }
          $('body').removeClass('loading hideOverly');
          loadMoreBtn();

          if ($(".spr-badge").length > 0) {
            $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
          }
          productGridView(sectionId);
          setTimeout(function () { productGridView(sectionId); }, 1000);

          history.pushState({ page: url }, url, url);
        }
      });
    });
    function getSearchParams(k) {
      var p = {};
      location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) { p[k] = v; });
      return k ? p[k] : p;
    }

    // Filter tabs

    function initTabs() {
      var tabs = this.tabs = '#' + sectionId + ' .tablink';

      if (FlagFilters) {
        $(document).on('click', tabs, function (e) {
          e.preventDefault();
          var tab = $(this).attr("href");
          if ($(this).parent().hasClass("active")) {
            $(this).parent().removeClass("active");
            $(tab).css("display", "none");
          } else {
            $(this).parent().addClass("active");
            $(tab).fadeIn();
          }

          if ($(window).width() < 767) {
            var tabposition = $(this).offset();
            $("html, body").animate({ scrollTop: tabposition.top }, 500);
          }
        });
        FlagFilters = false;
      }

      $('.product-tabs li:first-child').addClass("active");
      /* Show all the filter content on the first page load */
      $('.tab-container h3:not(#offices, #retail, #health, #education)').addClass("active");
      $('.tab-container h3:not(#offices, #retail, #health, #education) + .tab-content').show();

      $('.tab-container .tab-content').each(function (i, parent) {
        var checkbox_inputs = $(parent).find("input[type='checkbox']");
        if (checkbox_inputs.length > 0) {
          $(checkbox_inputs).each(function (index, child) {
            if ($(child).is(':checked')) {
              $(parent).prev().addClass('active');
              $(parent).show();
            }
          });
        }
      });
    }

    $(window).on('load delayed-resize', function (e, resizeEvent) {
      productGridView(sectionId);
    });

    infiniteScroll = function () {
      var action = 'scroll load delayed-resize';
      $(window).on(action, function () {
        var moreURL = $('.infinitpagin a').attr('href');
        if ($('.infinitpagin a.infinite').length) {
          var bottom = $('.infinitpagin').offset();
          var docTop = ($(document).scrollTop() + $(window).height() - 50);
          if (docTop > bottom.top) {
            $(window).off(action);
            loadMore(moreURL);
          }
        }
      });
    };
    loadMoreBtn = function () {
      $('.infinitpagin a.loadMore').click(function (e) {
        e.preventDefault();
        var moreURL = $(this).attr('href');
        loadMore(moreURL);
      });
    };

    loadMore = function (moreURL) {
      if (moreURL.length) {
        $.ajax({
          type: 'GET',
          dataType: 'html',
          url: moreURL,
          beforeSend: function () {
            if ($('.infinitpaginOuter').attr('data-type') == "button") {
              $('body').addClass('loading hideOverly');
            } else {
              $('.infinitpagin a').show();
            }
          },
          complete: function (data) {
            if ($('.productList .grid-products').length) {
              $('.productList .grid-products').append($(".productList .grid-products", data.responseText).html());
            } else {
              $('.productList .list-view-items').append($(".productList .list-view-items", data.responseText).html());
            }
            if ($(".infinitpagin", data.responseText).html()) {
              $('.infinitpagin').html($(".infinitpagin", data.responseText).html());
            } else {
              $('.infinitpagin').remove();
            }
            if (theme.mlcurrency) { currenciesChange("sapn.money"); }
            productGridView(sectionId);
            if ($(".spr-badge").length > 0) {
              $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }
            setTimeout(function () { productGridView(sectionId); }, 1000);
            if ($('.infinitpagin a.loadMore').length) {
              loadMoreBtn();
            } else {
              infiniteScroll();
            }
            $('body').removeClass('loading hideOverly');
          }
        });
      }
    };

    $(document).ready(function () {
      infiniteScroll();
      loadMoreBtn();
      initTabs();
      $("#collection-slideshow, #sideProdSlider").slick({
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 600,
        rtl: theme.rtl,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    });
  }
  return collectionView;
})();

// Product grid same height
function productGridView(sectionId) {
  var gridRows = [],
    tempRow = [];
    if($('.grid-version').length){
        $('.characteristics-icons').removeClass('char-icons');
    }
  productGridElements = $('#' + sectionId + ' .grid-products .grid__item');
  productGridElements.each(function (index) {
    if ($(this).css('clear') != 'none' && index != 0) {
      gridRows.push(tempRow);
      tempRow = [];
    }
    tempRow.push(this);

    if (productGridElements.length == index + 1) {
      gridRows.push(tempRow);
    }
  });

  $.each(gridRows, function () {
    var tallestBox = 0,
      tallestHeight = 0,
      tallestswatch = 0;
    $.each(this, function () {
      $(this).find('.details').css('height', '');
      /* $(this).find('.grid-view_image a.grid-view-item__link').css('height', ''); */
      $(this).find('.swatches').css('height', '');
      bxHeight = parseInt($(this).find('.details').outerHeight());
      elHeight = parseInt($(this).find('.grid-view_image').outerHeight());
      swHeight = parseInt($(this).find('.swatches').outerHeight());
      if (elHeight > tallestHeight) { tallestHeight = elHeight; }
      if (bxHeight > tallestBox) { tallestBox = bxHeight; }
      if (swHeight > tallestswatch) { tallestswatch = swHeight; }
    });
    $.each(this, function () {
      /* $(this).find('.grid-view_image > a.grid-view-item__link').css('height', tallestHeight); */
      $(this).find('.style3 .swatches').css('height', tallestswatch);
      $(this).find('.details').css('height', tallestBox);
    });
  });
  if($('.grid-version').length){
    setTimeout(function(){
      $('.characteristics-icons').addClass('char-icons');
    },200);
  }
}

theme.instagram = {};
theme.instagramSection = (function () {
  function instagramSection(container) {
    var $container = this.$container = $(container),
      sectionId = $container.attr('data-section-id'),
      imgfrom = $container.attr('data-from'),
      user = $container.attr('data-user'),
      tag = $container.attr('data-tag'),
      imagesize = $container.attr('data-image'),
      num_photos = $container.attr('data-count');
    if (imgfrom == "user") {
      $.instagramFeed({ 'username': user, 'container': "#instafeed" + sectionId, 'items': num_photos, 'styling': false, 'image_size': imagesize });
    } else {
      $.instagramFeed({ 'tag': tag, 'container': "#instafeed" + sectionId, 'items': num_photos, 'styling': false, 'image_size': imagesize });
    }
    $("#instafeed" + sectionId + ".insta-slick").slick();
  }
  return instagramSection;
})();

theme.carousel = (function () {
  function carousel(container) {
    var $container = this.$container = $(container),
      sectionId = $container.attr('data-section-id'),
      carousel = $($container).find('.carousel'),
      tabs = this.tabs = '#' + sectionId + ' .tablink',
      tabcontent = this.tabcontent = '#' + sectionId + ' .tab-content';

    $(document).on('click', tabs, function (e) {
      e.preventDefault();

      var tab = $(this).attr("href");
      if ($(this).parent().hasClass("active")) {
        $(this).parent().removeClass("active");
        $(tab).css("display", "none");
      } else {
        $(this).parent().addClass("active");
        $(tab).fadeIn();
      }

      if ($(window).width() < 767) {
        var tabposition = $(this).offset();
        $("html, body").animate({ scrollTop: tabposition.top }, 500);
      }
    });

    $('#' + sectionId).each(function () {
      $(this).find('.collection-tabs li:first-child').addClass("active");
      $(this).find('.tab-container .acor-ttl').addClass("active");
      $(this).find('.tab-container h3 + .tab-content').show();
      var firsttab = $(this).find('.collection-tabs li:first-child a').attr("href");
    });

    // Recenttly Viewed
    if (sectionId == "recently-viewed") {
      var recentcookie = "recentproducts",
        crproduct = $container.attr('data-pr');
      $.ajax({
        url: '/pages/recently-viewed-products/' + $.cookie(recentcookie) + '__pr=' + crproduct,
        dataType: 'html',
        type: 'GET',
        success: function (data) {
          if ($(data).find('.grid-view-item').length) {
            $('#productSlider-recently-viewed').html(data);
          }
        },
        error: function (data) {
          console.log('ajax error');
        },
        complete: function () {
          $(carousel).slick('refresh');
          productGridView(sectionId);
          setTimeout(function () { productGridView(sectionId); }, 1500);
          if (theme.mlcurrency) { currenciesChange("#productSlider-recently-viewed span.money"); }
        }
      });
    }

    $(carousel).slick();
    productGridView(sectionId);
    setTimeout(function () { productGridView(sectionId); }, 1500);
    $(window).on('delayed-resize', function (e, resizeEvent) {
      productGridView(sectionId);
    });
  }
  return carousel;
})();

theme.masonary = (function () {
  function masonary(container) {
    var $container = this.$container = $(container),
      sectionId = $container.attr('data-section-id'),
      masonary = this.masonary = $($container).find('.grid-masonary');

    loadMasonary(masonary);
    setTimeout(function () { loadMasonary(masonary); }, 1000);
    function loadMasonary(masonary) {
      $(masonary).masonry({
        columnWidth: '.grid-sizer-' + sectionId,
        itemSelector: '.ms-item',
        percentPosition: true
      });
    }
  }
  return masonary;
})();

/**
 * audioPlayer instantiates the singleton audio player(audio element)
 * and plays one audio file at a time when the play button is clicked.
 * Requires either `data-file-path` or `data-file-name` attribute, use `data-file-path` with full file path using
 * `file_url` liquid filter where possible for Shopify managed caching.
 * `data-file-name` is for when we can't access full file path but not optimal with the random cache busting param on every page load.
 *
 * @example
 * <div
 *   data-section-type="audio-player"
 *   data-file-name="my-audio.mp3"
 *   data-file-path="{{ 'my-audio.mp3' | file_url }}"
 * >
 *   <button class="play-btn">Play</button>
 * </div>
 */
theme.audioPlayer = (function () {
  var audioElement;
  var isPlaying = false;
  var isPaused = false;
  var currentSrc;
  function AudioPlayer(container) {
    var $container = this.$container = $(container);
    var fileUrl = $container.attr('data-file-path') || Shopify.constants.baseFileUrl + $container.attr('data-file-name') + '?v=' + Date.now();
    // creates singleton audio element
    if (!audioElement) {
      audioElement = document.createElement('audio');
      audioElement.addEventListener('play', function () {
        isPlaying = true;
        isPaused = false;
      });
      audioElement.addEventListener('pause', function () {
        isPaused = true;
      });
      audioElement.addEventListener('ended', function () {
        isPlaying = false;
      });
      audioElement.stop = function () {
        audioElement.pause();
        // swallows IE11 `InvalidStateError` error when setting `currentTime` before `loadedmetadata` is fired.
        try {
          audioElement.currentTime = 0;
        } catch (err) { }
        isPlaying = false;
      };
      $(document.body).append(audioElement);
    }
    // toggle play/pause when clicking the play button for the same file
    // otherwise set new file source and start playing.
    $container.find('.play-btn').on('click', function () {
      if (currentSrc !== fileUrl) {
        audioElement.stop();
        $(audioElement).attr('src', fileUrl);
        currentSrc = fileUrl;
      }
      if (isPlaying) {
        audioElement[isPaused ? 'play' : 'pause']();
      } else {
        audioElement.load();
        audioElement.play();
      }
    });
  }
  return AudioPlayer;
})();

/**
 * Collection Widget renders the products in a grid view dynamically using the same styling from collection page
 *
 * @example
 * <div
 *   class="page-width"
 *   data-section-type="collection-widget"
 *   data-collection-name="Popular Ceiling Tiles"
 *   data-collection-handle="popular-ceiling-tiles"
 *   data-title="My Popular Ceiling Tiles"
 *   data-num-products="4"
 *   data-shop-all-url="/collections/all/some-filter"
 * ></div>
 */
theme.collectionWidget = (function () {
  var DEFAULT_NUM_PRODUCTS = 4;
  function collectionWidget(container) {
    var $container = this.$container = $(container);
    var sectionType = $container.attr('data-section-type');
    // make `sectionId` unique so that multiple widgets can be included in a page 
    var sectionId = sectionType + '-' + Date.now();
    // collection name to fetch products from, this is a required field
    var collectionName = $container.attr('data-collection-name') || '';
    var collectionHandle = $container.attr('data-collection-handle') || '';
    // Title to be displayed above the widget, collection name will be used if not specified
    var title = $container.attr('data-title') || '';
    var numProducts = parseInt($container.attr('data-num-products'), 10) || DEFAULT_NUM_PRODUCTS;
    // generate collection handle from collection name by removing special characters and converting spaces to hyphens
    // https://shopify.dev/docs/themes/liquid/reference/basics/handle
    // https://github.com/Shopify/liquid/blob/63eb1aac69a31d97e343822b973b3a51941c8ac2/performance/shopify/shop_filter.rb#L100
    collectionHandle = collectionHandle || collectionName.trim().toLowerCase().replace(/"'\\\(\)\[\]/g, '').replace(/\W+/g, '-').replace(/^-+|-+$/g, '');
    // `Shop All` link url, defaults to All Collection page if not specified
    var shopAllUrl = $container.attr('data-shop-all-url') || '/collections/' + (collectionHandle || 'all');
    // width config matches with product grid view template
    var width = 100;
    var widths = [180, 360, 540, 720, 900];

    if (!collectionHandle) {
      setRendered();
      return;
    }

    // returns placeholder image if `url` is empty
    function getImageUrl(url) {
      return url || Shopify.constants.assets['no-image.gif'];
    }

    // returns img `srcset` value given the original image url
    function getSrcSet(imageUrl) {
      return widths.map(function (width) {
        return theme.Images.getSizedImageUrl(getImageUrl(imageUrl), width + 'x') + ' ' + width + 'w';
      }).join(', ');
    }

    // set the widget state as rendered to remove placeholder image
    function setRendered() {
      $container.addClass('rendered');
    }

    // callback function for loading widget template file
    function handleTemplateLoaded(data) {
      $.ajax({
        url: '/collections/' + collectionHandle + '/products.json',
        type: 'GET',
        template: $(data),
        success: function (data){
          // trim # of products per configuration
          data.products.length = numProducts;
          const products = data.products.map(async (product) => {
            const price = await getProductPricing(product.handle);
            const priceHTML = new DOMParser().parseFromString(price, "text/xml");
            const flagDates = priceHTML.querySelector('.product-widget__price').getAttribute('flag_dates');
            var imageUrl1 = getImageUrl(product.images[0] && product.images[0].src);
            var imageUrl2 = getImageUrl(product.images[1] && product.images[1].src);
            var imageSrc = theme.Images.getSizedImageUrl(imageUrl1, width + 'x');
            var srcSet1 = getSrcSet(imageUrl1);
            var srcSet2 = getSrcSet(imageUrl2);
            const hasDiscount = price.includes('has-discount') ? true : false;
            const flagStyles = handleShogunWidgetFlag(product.handle, flagDates, hasDiscount);
            return {
              title: product.title,
              url: '/products/' + product.handle,
              width: width,
              widths: JSON.stringify(widths),
              imageSrc: imageSrc,
              srcSet1: srcSet1,
              srcSet2: srcSet2,
              spacer: Shopify.constants.assets['spacer.png'],
              price: price, 
              discount: hasDiscount,
              flagStyles: flagStyles
            }
          })
   
          Promise.all(products).then((values) => {
            handleCollectionLoaded(this, values)
          })
        },
        error: function (data) {
          console.error('ajax error', data);
          setRendered();
        }
      });
    }
    
    async function getProductPricing(productHandle) {
      return fetch(`/products/${productHandle}?section_id=product-price-template`)
        .then(response => {
          if (response.status == 200) {
            return response.text();
          } else {
            throw new Error(response.status);
          }
        });
    }

    // callback function for loading collection
    function handleCollectionLoaded(_self, products) {
      function render(props) {
        // simple vanilla template variable substitution
        // template are split by variables, which alternates with template string and variables
        return function (tok, i) { return (i % 2) ? props[tok] || '' : tok; };
      }
      var $template = _self.template;
      // generate map to be used for substituting template variables
      // render products
      var gridTpl = $template.find('.grid');
      var gridItemTpl = $template.find('.grid__item');
      // split template with placeholder variable names as delimiter
      var itemTpl = gridItemTpl.html().split(/\$\{(.+?)\}/g);
      gridTpl.html(products.map(function (product) {
        const card = $(gridTpl.html()).html(itemTpl.map(render(product)).join(''));
        if(product.flagStyles && card) {
          const flag = card.get(0).querySelector('.custom-flag.shogun-widget-flag');
          addFlagStyles(flag, product.flagStyles);
        }
        if(product.discount) card.addClass("on-sale")
        return card;
      }));
      $container.append(gridTpl.fadeToggle({
        progress: function (_, progress) {
          // fade in actual collection item and hide placeholder when fading in 50% for smooth transition
          if (progress > 0.5) {
            setRendered();
            // render collection title
            var header = $template.find('.collection-widget__header');
            header.find('h2').html(title || collectionName);
            header.find('.collection-widget__btn').attr('href', shopAllUrl);
            $container.prepend(header);
          }
        }
      }));
      // grid view init to set height dynamically
      var images = $container.find('.grid-view-item__link img');
      var primaryImages = $container.find('.grid-view-item__link img:first-of-type');
      var loadedCnt = 0;
      // `productGridView` function checks the highest image height among products to set as all grid view height,
      // need to ensure the image is acually loaded before calling `productGridView`
      // otherwise image will fail to display.
      primaryImages.on('load', function (event) {
        loadedCnt += 1;
        if (loadedCnt === primaryImages.length) {
          productGridView(sectionId);
        }
      });
      // set image url to the `src` and `srcset` attribute now,
      // otherwise Shopify makes page request with the placeholder value somewhere which ends up 404
      images.each(function () {
        var srcSet = $(this).attr('data-srcset');
        var src = $(this).attr('data-src');
        if (srcSet) {
          $(this).attr('srcset', srcSet);
        }
        if (src) {
          $(this).attr('src', src);
        }
      });
    }

    // fetch template html
    $.ajax({
      url: Shopify.constants.assets[sectionType + '-template.html'],
      type: 'GET',
      success: function (data) {
        // Shopify falls back to return the page html when the request url is not found,
        // so need to verify the template is the expected one.
        if (!$(data).find('.collection-widget').length) {
          console.error('unexpected template loaded');
          setRendered();
          return;
        }
        handleTemplateLoaded(data);
      },
      error: function (data) {
        console.error('ajax error', data);
        setRendered();
      }
    });

    // update grid view height
    $(window).on('delayed-resize', function () {
      productGridView(sectionId);
    });

    $container
      .attr('id', sectionId)
      .attr('data-section-id', sectionId);
  }

  return collectionWidget;
})();

theme.ajaxCart = function () {
  drawerTimeout: null,
    quickshop(), gridAddToCart(), prodAddToCart(), wishlist(), updateWishlist(), freeship();

  $(".block-cart").click(() => {
    if (typeof drawerTimeout === "function")
      clearTimeout(drawerTimeout);
  });

  $(".continue-shopping, .modalOverly, .closeDrawer").click(function () {
    $(".modal").fadeOut(200);
    $("body").removeClass("loading showOverly");
    $("html").removeClass("boost-pfs-body-no-scroll-mini-cart");
  });

  function quickshop() {
    $(document).on('click touch', '.quickShop', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      var url = $(this).attr('href'),
        imgwrapper = $(this).parents('.grid-view-item').find(".grid-view_image"),
        wrapper = $(this).parents(".grid-view-item").find('.shopWrapper'),
        btnstatic = $(this).parents(".grid-view-item").find('.quickShop');

      $.ajax({
        url: url,
        dataType: 'html',
        type: 'GET',
        beforeSend: function () {
          $(imgwrapper).addClass('showLoading');
        },
        success: function (data) {
          $(".shopWrapper").removeClass('active').html("");
          $(".quickShop").removeClass('hide');
          $(wrapper).addClass('active').html(data);
          $(btnstatic).addClass('hide');
        },
        complete: function (data) {
          $(imgwrapper).removeClass('showLoading');
          if (theme.mlcurrency) { currenciesChange(".shopWrapper.active .product-single__price span.money"); }
          $(".closeShop").click(function (e) {
            $(this).parents(".shopWrapper").removeClass("active");
            $(this).parents(".grid-view-item").find('.quickShop').removeClass("hide");
          });
        }
      });
    });
  }
  function gridAddToCart() {
    $(document).on('click touch', '.add-to-cart', function (i) {
      i.preventDefault(); 
      i.stopImmediatePropagation();
      if (theme.ajax_cart) {
        var att = $(this).attr("id"),
          qty = $(this).attr("rel");
        addinToCart(att, qty);
      } else {
        $(this).next().submit();
      }
      return;
    });
  }
  
  function changeToAdded() {
    $('.tile-pdp-banner .icon-add-cart-mobile').show();
    $('.image-icon-cart-accordion').hide();
    $('.icon-add-cart').show();
    $('#accordion-add-items-cart').addClass('color-check');
    $('#add-to-cart-sticky-cta').addClass('color-check');
    $('#add-to-cart-sticky-cta-mobile').addClass('color-check');
    $('.add-added').html('<span>ADDED TO CART</span>').addClass('checked');
    if(isCoolEdgeTemplate()){
      $('#add-to-cart-sticky-cta .button-add-x-items-to-cart').text('ADDED TO CART');
    }
    if(isSpaceKitTemplate()){
      $('#add-to-cart-sticky-cta .button-add-x-items-to-cart').text('ADDED TO CART');
    }
    $('.product__variant-checkbox').prop('disabled',true);
    setTimeout(function () { 
      changeToReadyToBuy();
    },5000);
  }
  
  function changeToReadyToBuy(){
    $('.tile-pdp-banner .icon-add-cart-mobile').hide();
    $('.image-icon-cart-accordion').show();
    $('.icon-add-cart').hide();
    $('#accordion-add-items-cart').removeClass('color-check');
    $('#add-to-cart-sticky-cta').removeClass('color-check');
    $('#add-to-cart-sticky-cta-mobile').removeClass('color-check');
    
    $('#add-to-cart-sticky-cta .button-add-x-items-to-cart > span').addClass('add-added').removeClass('checked');
    if(isBundleTemplate()){
      $('#add-to-cart-sticky-cta .button-add-x-items-to-cart').text('ADD ITEMS TO CART');
      $('#accordion-add-items-cart  .button-add-x-items-to-cart > span').html('ADD ITEMS TO CART');
    } else {
      $('#add-to-cart-sticky-cta .button-add-x-items-to-cart > span').html('ADD <span id="to-cart-stycky"><span class="number-items" id="add-to-cart-sticky-cta-ni">1</span> ITEM<span id="s-items-sticky" style="display: none;">S</span></span> TO CART </span>');
      $('#accordion-add-items-cart  .button-add-x-items-to-cart > span').html('ADD 1 ITEM TO CART');
    }
    if(isCoolEdgeTemplate()){
      $('#add-to-cart-sticky-cta .button-add-x-items-to-cart').text('ADD TO CART');
    }
    if(isSpaceKitTemplate()){
      $('#add-to-cart-sticky-cta .button-add-x-items-to-cart').text('ADD TO CART');
    }
    $('.product__variant-checkbox').prop('disabled',false);
    validateButton();
  }
  
  function prodAddToCart() {
    $(document).on('click touch', '.product-form__cart-submit', function (i) {
      if (i.preventDefault(), "disabled" != $(this).attr("disabled"))
        if (theme.ajax_cart) {
          var att = $(this).closest("form").find("select[name=id]").val();
          att || (att = $(this).closest("form").find("input[name=id]").val());
          var qty = $(this).closest("form").find("input[name=quantity]").val();
          qty || (qty = 1);
          var props = {};
          $('[name*="properties"]').each(function () {
            var key = $(this).attr('name').split('[')[1].split(']')[0];
            var value = $(this).val();
            props[key] = value;
          });
          addinToCart(att, qty, props);
        } else {
          $(".productForm").submit();
        }
      return;
    });

  if(isTileTemplate() || isWallTemplate() || isCoolEdgeTemplate() || isDecorativeTemplate() || isBundleTemplate() || isSpaceKitTemplate()){
    $(document).on('click touch', '#accordion-add-items-cart, #add-to-cart-sticky-cta', function (i) {
      if (i.preventDefault(), "disabled" != $(this).attr("disabled")){
        if (theme.ajax_cart) {
          var att = $('#form-tile-pdp').find("select[name=id]").val();
          att || (att = $('#form-tile-pdp').find("input[name=id]").val());
          var qty = $('#quantity').val();
          qty || (qty = 1);
          var props = {};
          $('[name*="properties"]').each(function () {
             var key = $(this).attr('name').split('[')[1].split(']')[0];
            var value = $(this).val();
            props[key] = value;
          });
          addinToCart(att, qty, props);
        } else {
          $(".productForm").submit();
        }
        changeToAdded();
        return;
      }
    }); 
  }
  if( isDefaultTemplate() ){
    $(document).on('click touch', '#accordion-add-items-cart, #add-to-cart-sticky-cta', function (i) {
      if(enableInstallationVal==true){
        let miniCartList = $('.mini-products-list').html();
        let wordMatchPosition = miniCartList.search(productHandle);
        if(wordMatchPosition<0){
          enabledInstallationProductsCountJS=enabledInstallationProductsCountJS+1;
          }
          const InstallElementMinicart = $('.mini-products-list').find('.cmp-installation','#cart-drawer');
          InstallElementMinicart.show();
      }   
      if (i.preventDefault(), "disabled" != $(this).attr("disabled")){
        if (theme.ajax_cart) {
          var att = $('#form-tile-pdp').find("select[name=id]").val();
          att || (att = $('#form-tile-pdp').find("input[name=id]").val());
          var qty = $('#quantity').val();
          qty || (qty = 1);
          var props = {};
          $('[name*="properties"]').each(function () {
             var key = $(this).attr('name').split('[')[1].split(']')[0];
            var value = $(this).val();
            props[key] = value;
          });
          addinToCart(att, qty, props);
        } else {
          $(".productForm").submit();
        }
        changeToAdded();
        return;
      }
    }); 
  }
}
  function addinToCart(att, qty, props) {
    $('#CartCount').show();
    const discount = getDiscount(att, regular_dsc_input );
    const volume_discount = getVolumeDiscount(att, regular_volume_dsc_input );
    const volume_discount_msg = $('.volume_promotion_msg.vol-pdp .promotion-text');
    const modal_volume_discount_msg = $('.volume_promotion_msg.vol-add-to-cart-modal .promotion-text');
    const type = $('.product-cart__title').attr('data-type');
    const subtotal_msg = $('.pdp-modal-itm-txt');
    $('#modal-pdp-qty').html(qty);
    $('#modal-pdp-qtym').html(qty);
    if(volume_discount_msg.length > 0 ) {
      modal_volume_discount_msg.html(volume_discount_msg.html());
    }else {
      if(modal_volume_discount_msg.length > 0) {
        modal_volume_discount_msg.closest('.volume_promotion_msg').removeClass('d-flex');
      }
    }
    if($('#pdp-subtotal-modal').length > 0) {
      //Calculate Discount
      let totalPrice = gvariant.price * qty;
      let installationCost = 0;
      if(discount !== false && localStorage.getItem('applyDiscount') == "true" && gvariant.isWholesale !== true) {
        props['_discount'] = discount;
        totalPrice = totalPrice * (1 -  (discount / 100 ));
        totalPrice += installationCost;
        $('#pdp-subtotal-modal strong').html(theme.Currency.formatMoney(totalPrice, theme.moneyFormat));
        $('#pdp-subtotal-modalm strong').html(theme.Currency.formatMoney(totalPrice, theme.moneyFormat));
      }
      else{
        totalPrice += installationCost;
        $('#pdp-subtotal-modal strong').html(theme.Currency.formatMoney(totalPrice , theme.moneyFormat));
        $('#pdp-subtotal-modalm strong').html(theme.Currency.formatMoney(totalPrice, theme.moneyFormat));
      }
      /* validate if volume discount properties should be added to the line item*/
      if(volume_discount !== false && localStorage.getItem('applyDiscount') == "true" && gvariant.isWholesale !== true) {
        const quantity = getRequiredQuantity(regular_volume_dsc_input);
        props['_volumeDiscount'] = volume_discount;
        props['_volumeQuantity'] = quantity;
        props['_volumeMsg'] = volume_discount_msg.html();
      }
    }
    const is_ltl_only_arr = checkLtlOnly(att, is_ltl_input);
    if(is_ltl_only_arr.length > 0) props['_ltlOnly'] = is_ltl_only_arr[1] ? true : false;
    props = checkBulkDiscount(props, att, regular_bulk_dsc_input);
    subtotal_msg.html(`${type != 'spacekit' ? 'item' : 'kit'}${ (qty > 1) ? 's' : '' }`);
    
    if(isBundleTemplate()) {
      JQ('#added-to-cart').addClass('added-to-cart-bundle');
      let lblBundleSubtotal = `bundle${ (qty > 1) ? 's' : '' }`;
      subtotal_msg.html(lblBundleSubtotal);
      
      // Set priceunits for all variants in properties
      let priceUnitsV = []
      const priceUnitsDivs = $('.variant_price_units');
      $.each(priceUnitsDivs, function(index, element){
        let idV = $(element).attr('data-id');
        let priceU = $(element).attr('data-price-units');
        priceUnitsV.push([idV]+"-"+priceU);
      });
      props['_data-priceUnits'] = priceUnitsV;
    }
    if(isProductBundle){
      props['_isBundle'] = true;
    }
    if($('.body-accordion .option3 .product-form__item .header').text().includes('Pattern')){
      props['_isPattern'] = true;
    }
    
    const variantId = att;
    const CartJSItems = CartJS.cart.items;
    const itemIndex = CartJSItems.findIndex(({variant_id}) => {
      return variant_id == variantId;
    });
    const itemIndexToUpdate = itemIndex + 1;
    if(itemIndexToUpdate) {
      const {quantity} = CartJSItems[itemIndex];
      const newQty = parseInt(quantity,0) + parseInt(qty,0);
      CartJS.updateItem(itemIndexToUpdate, newQty, props, {
        "success": cartJsSuccessPDP,
        "error": cartJsErrorPDP
      });
    } else {
      CartJS.addItem(att, qty, props, {
        "success": cartJsSuccessPDP,
        "error": cartJsErrorPDP
      });
    }
  }
  
  

  function cartJsSuccessPDP (data, textStatus, jqXHR) {
    // Update installation value
    setTimeout(doNeedInstallationHelp, 350);

    JQ('#added-to-cart').on('show.bs.modal', function (event) {
      var modal = JQ(this);
      modal.find('.product-cart__img').attr('src', gvariant.featured_image.src);
      modal.find('.product-cart__variant').text(gvariant.title);
      modal.find('.nItem-modal').text('Item #: '+gvariant.sku);
    });

    JQ('#added-to-cart').modal('show');

    //Microsoft UET Add to cart tracking
    window.uetq = window.uetq || [];
    window.uetq.push('event', '', {"event_label":"Add to Cart","event_category":"Added Product"});

  }

  function cartJsErrorPDP (jqXHR, textStatus, errorThrown) {
      var errormsg = JSON.parse(jqXHR.responseText).description;
      $("body").removeClass("loading");
      $(".error-message").text(errormsg);
      $("body").addClass("showOverly");
      $("#errorDrawer").fadeIn(500);
      drawerTimeout = setTimeout(function () {
        $("body").removeClass("loading showOverly"), $("#errorDrawer").fadeOut(200);
      }, 6000);
  }

  function getDiscount(variant_id, dsc_input) {
    const dsc_input_val  = dsc_input.val();
    const apply_discounts = checkDateRange();
    if(dsc_input_val.length > 0 && apply_discounts) {
      const variants = dsc_input_val.split(',');
      const discount = variants[0];
      for (let variant in variants) {
        if(variant == 0) continue;
        if(variants[variant] == variant_id) return discount;
      }
    }
    return false;
  }
  function getVolumeDiscount(variant_id, dsc_input) {
    const dsc_input_val  = dsc_input.val();
    const apply_discounts = checkDateRange('enable_vol_dsc');
    if(dsc_input_val.length > 0 && apply_discounts) {
      const variants = dsc_input_val.split(',');
      for (let variant of variants) {
        const [varId, discount = 0] = variant.split(':');
        if(varId == variant_id) return discount;
      }
    }
    return false;
  }
  
  function getRequiredQuantity(dsc_input) {
    const dsc_input_val  = dsc_input.val();
    if(dsc_input_val.length > 0) {
      const variants = dsc_input_val.split(',');
      /* Position 0 contains required quantity */
      return variants[0];
    }
    return 0;
  }
  $(document).on('cart.requestComplete', function (event, cart) {
    if (theme.mlcurrency) { currenciesChange("#cart-drawer sapn.money"); }
    setTimeout(function () { freeship(); }, 3000);
  });
  function freeship() {
    var freeshipPrice = $(".freeShipMsg").attr('data-price'),
      cartTotal = CartJS.cart.total_price,
      remainfreeship = freeshipPrice - cartTotal;
    if (remainfreeship > 0) {
      $(".freeShipMsg .freeShip").html(theme.Currency.formatMoney(remainfreeship, theme.moneyFormat));
      $(".freeShipMsg").show(); $('.freeShipclaim').hide();
      if (theme.mlcurrency) { currenciesChange(".freeShipMsg .freeShip sapn.money"); }
    } else {
      $(".freeShipMsg").hide(); $('.freeShipclaim').show();
    }
  }
  function wishlist() {
    var cookieName = "wishlistList";
    $(document).on('click', '.addto-wishlist', function (e) {
      e.preventDefault();
      var id = $(this).attr('rel');
      if ($.cookie(cookieName) == null) {
        var str = id;
      } else {
        if ($.cookie(cookieName).indexOf(id) == -1) {
          var str = $.cookie(cookieName) + '__' + id;
        }
      }
      $.cookie(cookieName, str, { expires: 30, path: '/' });
      $(this).find(".ad").removeClass('ad-heart-l').addClass('ad-circle-notch-r ad-spin');
      setTimeout(function () {
        $('.wishlist[rel="' + id + '"]').removeClass('addto-wishlist').find('span').text(theme.wlAvailable);
        $('.wishlist[rel="' + id + '"] .ad').removeClass('ad-circle-notch-r ad-spin').addClass('ad-heart');
      }, 2000);
    });
  }
  function updateWishlist() {
    var cookieName = "wishlistList";
    try {
      if ($.cookie(cookieName) != null && $.cookie(cookieName) != '__' && $.cookie(cookieName) != '') {
        var str = String($.cookie(cookieName)).split("__");
        for (var i = 0; i < str.length; i++) {
          if (str[i] != '') {
            $('.wishlist[rel="' + str[i] + '"]').removeClass('addto-wishlist').find('span').text(theme.wlAvailable);
            $('.wishlist[rel="' + str[i] + '"] .ad').removeClass('ad-heart-l').addClass('ad-heart');
          }
        }
      }
    }
    catch (err) { }
  }
};
$(theme.ajaxCart);


$(document).ready(function () {
  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('wizard-section', theme.WizardSection);
  sections.register('compare-app-section', theme.CompareSection);
  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('product', theme.tilePDPNav);
  sections.register('collection-template', theme.Filters);
  sections.register('collection-template', theme.collectionView);
  sections.register('product-template', theme.Product);
  sections.register('product-template-grid', theme.Product);
  sections.register('product-template-grid', theme.gridPDPNav);
  sections.register('product-template-grid', theme.gridPDPCompatibleCeilings);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('carousel', theme.carousel);
  sections.register('quotes', theme.Quotes);
  sections.register('masonary', theme.masonary);
  sections.register('instagram', theme.instagramSection);
  sections.register('audio-player', theme.audioPlayer);
  sections.register('collection-widget', theme.collectionWidget);
  
  //We need to make all of the main images clickable so that once they are clicked, the image zooms in with the scrim behind it (same functionality as clicking on the blue zoom icon). 
  setTimeout(function(){
    if($(window).width()<600 || $(window).width()>1024){// for mobile and wider devices click is working okay
      $('.primgSlider .slick-slide img').on('click',function(){
        if(!$(this).parent().hasClass('video-span')){
          $('.btn.prlightbox').click();
        }
      });
    }else if($(window).width()<=1024){// touchstart for tablet  
      $('.primgSlider .slick-slide img').on('touchstart',function(){
        if(!$(this).parent().hasClass('video-span')){
          $('.btn.prlightbox').click();
        }
      });
    }
  },1000);

  
  $('.ad-question-cil').click(function () {
    
    setTimeout(() => {
      if(isTileTemplate() || isWallTemplate() || isDefaultTemplate() || isDecorativeTemplate() || isBundleTemplate()){
        $('#Slideshow-product-template-tile').slick('refresh');
        $('#Slideshow-product-template-tile').removeClass('invisible');
        
        
        $('#Slideshow-product-template-bundle').slick('refresh');
        $('#Slideshow-product-template-bundle').removeClass('invisible');
        
        $('#Slideshow-product-template-wall').slick('refresh');
        $('#Slideshow-product-template-wall').removeClass('invisible');

      }
    }, 500);
  });
  $('#pdp-tile-faq-modal-switch').click(function () {
    setTimeout(() => {
      $('#Slideshow-product-template-tile').slick('refresh');
      $('#Slideshow-product-template-tile').removeClass('invisible');
      
    }, 500);
    
  });
  $('.filter-list').each(function () {
    let $self = $(this);
    let listLeng = $self.find('li').length;

    if (listLeng <= 4) {
      $self.find('.collapse-tags').hide();
    }
  });

  $('.collapse-tags').on('click', function () {
    var self = $(this);
    var parent = self.parent();
    if (parent.hasClass('should-collapse')) {
      parent.removeClass('should-collapse');
      self.text('Show Fewer');
    } else {
      parent.addClass('should-collapse');
      self.text('Show All');
    }
  });

  var currentItmQty = $('#CartCount').html();
  if (currentItmQty > 0) {
    $('#CartCount').show();
  }
  
  $('.how-much-you-need').click(function () {
    $('.qty-estimator-toggle').show();
    $('.qty-estimator-toggle').addClass('active');
    $(this).hide();
  });
  
  $('.close-estimator').click(function () {
    $('.qty-estimator-toggle').hide();
    $('.qty-estimator-toggle').removeClass('active');
    $('.how-much-you-need').show();
  });
   
  $('.qty-estimator-result-input').change(function() {
    $('.qty-estimator-results-txt-inner').hide();
  });

  //Only for grid PDP check if null value and correct
  if($('.grid-product-page').length > 0){
    $('.qtyBtn').on("click",function(){
      newVal = parseInt($(this).siblings('input').val());
      //If we have no value then fix the input and deselect
      if( Number.isNaN(newVal) || newVal === 0 ){
        $(this).val(0);
        if (!(isTileTemplate () || isWallTemplate() || isCoolEdgeTemplate() || isDecorativeTemplate() || isBundleTemplate() || isDefaultTemplate() || isSpaceKitTemplate())){
          unselectVariantCard( $(this).data("id") );
        }
      }else {
        if (!(isTileTemplate () || isWallTemplate() || isCoolEdgeTemplate() || isDecorativeTemplate() || isBundleTemplate() || isDefaultTemplate() || isSpaceKitTemplate())){
          selectVariantCard( $(this).data("id") );
        }
      }
    });
  };
  
  //slick popular-component
  let calcSlide = $(window).width() / 278;
  var popularComponent = setInterval(loadPopularMobile, 500);
  
  
  function loadPopularMobile (){
    if($('.popular-component-mobile').length > 0){      
      $('.popular-component-mobile').slick({
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: false,
        speed: 600,
        rtl: theme.rtl,
        slidesToShow: calcSlide,
        slidesToScroll: 1,
        variableWidth: false
      });
      clearInterval(popularComponent);
    }
  }
});

var resizeTimer;
$(window).resize(function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    $(window).trigger('delayed-resize');
  }, 250);
});

theme.init = function () {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  // for lightbox in PDP if there is # in the href or hash it is causing issue run the below code handeling it in both the case 
  var loc = window.location.hash;
  loc = loc.split('#&gid=');
  if(loc.length>1){
    slate.a11y.pageLinkFocus($(loc[0]));
  }else{
    slate.a11y.pageLinkFocus($(window.location.hash));
  }

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"].cart__remove').on('click', function (evt) {
    evt.preventDefault();
  });
  $('a[href="#"].remove-from-minicart').on('click', function (evt) {
    evt.preventDefault();
  });

};
$(theme.init);

// Shogun lazyload background image fix for IE11 provided by Shogun
function loadBgImages() {
  var classNames = ['shogun-lazyload', 'shogun-lazyloading'];
  classNames.forEach(function (className) {
    var sections = document.getElementsByClassName(className);
    if (sections && sections.length) {
      for (var i = 0; i < sections.length; i++) {
        var section = sections[i];
        var dataBgSet = section.getAttribute('data-bgset');
        if (dataBgSet) {
          section.style.backgroundImage = 'url(' + dataBgSet + ')';
          section.classList.remove("shogun-lazyload");
          section.classList.remove("shogun-lazyloading");
          section.classList.add("shogun-lazyloaded");
        }
      }
    }
  });
}

function reloadShippingEstimates() {
  if (typeof ShippingCalcThru === 'function') {
    ShippingCalcThru();
  }
}

loadBgImages();

$('.js-qty-input').on('input', function() {  calculateQuantityPatternModal($(this)); });
$(".qtyBtn").off('click').on("click", function () {
  if($(this).hasClass("patternBtn")) {
    calculateQuantityPatternModal($(this));
    return;
  }
  const isCompatibleComponent = $(this).hasClass('js-compatible-grid');
  var qtyLimit = 0, newVal = 0;
  if($(this).parents('.qty-estimator-acc').length || $(this).parents('.quantity-accordion-wall').length || $(this).parents('.quantity-accordion-default').length) { // Tile and wall Template PDP
    qtyLimit = 1;
    newVal = 1;
  }
  
  var bundle = $(this).parent(".qtyField").attr('data-bundle');
  var qtyField = $(this).parent(".qtyField"),
    oldValue = $(qtyField).find(".qty").val(),
    is_plus = false ;
  if ($(this).is(".plus")) {
    newVal = parseInt(oldValue) + 1;
    is_plus=true;
  } else if (oldValue > qtyLimit) {
    newVal = parseInt(oldValue) - 1;
    is_plus=false;
  }
  if(isNaN(newVal)){
    newVal=1;
  }
  if($(this).parents('.product-template__container').length) {
    if (newVal <= 0) {
      $('.btn.banner-btn').attr('disabled', true);
      $('.btn.banner-btn-mobile').attr('disabled', true);
      $('#AddToCart-product-template-tile').attr('disabled', true);
    } else if (newVal > 0) {
      $('.btn.banner-btn').attr('disabled', false);
      $('.btn.banner-btn-mobile').attr('disabled', false);
      $('#AddToCart-product-template-tile').attr('disabled', false);
    }
  }
  
  $(qtyField).find(".qty").val(newVal);
  //compatible grid system for ceilling PDP Starts
  if($(this).parent().parent('.qty-form').length){
    const item = $(this).parent().parent();
    const dataPrice = ( item.attr('data-discount-price') && localStorage.getItem('applyDiscount') == "true") ?  item.attr('data-discount-price') : item.attr('data-price');
    var isModal = '.isSection';
    if($(this).parent().parent('.qty-form').hasClass("isModal")){
      isModal= '.isModal';
    }
    const discountActive = checkDateRange();
    const discountAplicableZipcode = localStorage.getItem('applyDiscount') == 'true';

    const $price_item =  ($(`${isModal}.total-gr-price-${bundle}.discount`).length > 0 && (discountActive && discountAplicableZipcode) ) ? $(`${isModal}.total-gr-price-${bundle}.discount`) : $(`${isModal}.total-gr-price-${bundle}:not(.discount)`);
    var oldTotal = $price_item.attr('total');
    var newTotal = Number(oldTotal);
    if(is_plus){
      newTotal = Number(oldTotal)+Number(dataPrice);
    }else if (oldValue > qtyLimit){
      newTotal = Number(oldTotal)-Number(dataPrice);
    }
    $(isModal+'.total-gr-price-'+bundle).attr('total', newTotal.toFixed(2));
    newTotal= newTotal/100;
    if(newTotal < 0) newTotal = 0;
    newTotal= newTotal.toFixed(2).toLocaleString('en-US', {minimumFractionDigits: 2});
    $price_item.text('$'+newTotal);
    //$(isModal+'.total-gr-price-'+bundle)
    $(qtyField).find(".qty").attr('old-qty',newVal);
  }
  
  $('.qty-estimator-results-txt-inner').hide();
  
  if ($('.' + bundle + ' .total-bundle').attr('total') <= 0) {
    $('.' + bundle + ' .add-grid-system').addClass('disabled');
  } else {
    $('.' + bundle + ' .add-grid-system').removeClass('disabled');
  }
  
  if ($('.tile-added-to-cart ' + '.' + bundle + ' .total-bundle').attr('total') <= 0) {
    $('.tile-added-to-cart ' + '.' + bundle + ' .add-grid-system').addClass('disabled');
  } else {
    $('.tile-added-to-cart ' + '.' + bundle + ' .add-grid-system').removeClass('disabled');
  }
  
  //compatible grid system for ceilling PDP Ends
  reloadShippingEstimates();

  // For Tile Template validate button and calculate subtotal
  if((isTileTemplate() || isWallTemplate() || isCoolEdgeTemplate() || isDecorativeTemplate() || isBundleTemplate() || isDefaultTemplate() || isSpaceKitTemplate()) && !isCompatibleComponent) {
    validateButton();
  }
});

$(document).ready(function () {
  "use strict";
  $(document).on('click', '.currencyOpt', function (i) {
    $('#CurrencySelector').val($(this).data('value'));
    $('#localization_form').submit();
  });
/* mobileViewSlickSlider function creates a non-infinite slick slider for use it on components from shogun on homepage
for mobile view such like: Large Selection of products, What Customer Says and Tips and inspiration make sure for your compoent to have 
the apropriated html structure to be able to work */
  function mobileViewSlickSlider(slickSliderContainer, slidesToShow, mobileSlickSlider) {
    slickSliderContainer.slick({
      infinite: false,
      slidesToShow: slidesToShow,
      variableWidth: false,
      arrows: false
    });
    var slickSlideListWidth = parseFloat($(mobileSlickSlider+' > .shg-box-content > .slick-list').width());
    slidesToShow = (slickSlideListWidth-16)/300;
    if (slickSlideListWidth>375 && slickSlideListWidth<=612){
      slickSliderContainer.slick('unslick');
      slickSliderContainer.slick({
        infinite: false,
        slidesToShow: slidesToShow,
        variableWidth: false,
        arrows: false
        }); 
      slickSliderContainer.slick('reinit');
    }
    if (slickSlideListWidth>612 ){
      slickSliderContainer.slick('unslick');
      slickSliderContainer.slick({
        infinite: false,
        slidesToShow: slidesToShow,
        variableWidth: false,
        arrows: false
        }); 
      slickSliderContainer.slick('reinit');
    }
  }
  //slick slider for "large selection of products" shogun component on homepage mobile view
  var slickSliderContainer=$('.mobileLargeSelectionSlickSlider').find('.shg-box-content').first();
  var slidesToShow = 1.207;
  var mobileSlickSlider = '.mobileLargeSelectionSlickSlider';
  var mobileFullComp = '.mobileLargeSelectionFullComp';

  mobileViewSlickSlider(slickSliderContainer, slidesToShow, mobileSlickSlider);
  mobileSlickSliderLargeSelectionStyling(slickSliderContainer, mobileFullComp, mobileSlickSlider);

function mobileSlickSliderLargeSelectionStyling(slickSliderContainer, mobileFullComp, mobileSlickSlider){
      $(mobileFullComp).css('margin-left', '16px');
      $(mobileSlickSlider+' .slick-slide').css({'width': '300px', 'padding': '0 16px 0 0'});
      var slickLargeSelNextElement = '<button type="button" style="position:relative; box-shadow: 1px 2px 10px 0 rgb(94 113 131 / 35%);bottom:24px;margin-left:16px;margin-right:16px;min-width: 40px;height: 40px; line-height: 40px;" data-role="none" class="slick-next slick-arrow rightArrowElement" aria-label="Next" role="button" style="display: block;" aria-disabled="false">Next</button>';
      var slickLargeSelPrevElement = '<button type="button" style="position:relative; box-shadow: 1px 2px 10px 0 rgb(94 113 131 / 35%);bottom:24px;margin-left:8px;min-width: 40px;height: 40px; line-height: 40px;" data-role="none" class="slick-prev slick-arrow leftArrowElement" aria-label="Previous" role="button" aria-disabled="true" style="display: block;">Previous</button>';
      $(mobileFullComp).find('.shg-box-vertical-align-wrapper').first().append(slickLargeSelPrevElement);
      $(mobileFullComp).find('.shg-box-vertical-align-wrapper').first().append(slickLargeSelNextElement);
      $(mobileFullComp).find('.shg-box-vertical-align-wrapper').first().css({'height': '85px'});
      $(mobileFullComp).find('.shg-box-vertical-align-wrapper .shg-c.shg-align-left').first().css({'margin-left':'unset'})

      $(mobileFullComp+' .slick-arrow.leftArrowElement').on('click', function(){
        $(mobileSlickSlider).find('.shg-box-content').first().slick('slickPrev');
      });
      $(mobileFullComp+' .slick-arrow.rightArrowElement').on('click', function(){
        $(mobileSlickSlider).find('.shg-box-content').first().slick('slickNext');
      });    
      window.addEventListener("load", (event) => {
        var elementheightValue = $(mobileSlickSlider).height();
          $(mobileSlickSlider+" .slick-slide").each(function () { 
              if( $(this).height()>elementheightValue){
                elementheightValue = $(this).height();
                }
        });
        $(mobileSlickSlider+' .slick-slide').height(elementheightValue);
        $(mobileSlickSlider+' .slick-slide > .shg-box.shg-c').css({'height':'inherit', 'flex-direction':'column'});
        $(mobileSlickSlider+' .slick-slide > .shg-box.shg-c > .shg-box-content').css({'height': 'inherit', 'display': 'flex', 'flex-direction': 'column', 'flex-wrap': 'wrap'});
        $(mobileSlickSlider+' .slick-slide > .shg-box.shg-c > .shg-box-content > .shg-box-vertical-align-wrapper').css({'flex-grow': '1'});
        $(mobileSlickSlider+' .slick-slide > .shg-box.shg-c > .shg-box-content > .shg-box-vertical-align-wrapper > .shg-box.shg-c').css({'padding-left':'0px', 'padding-right':'0px'});
        $(mobileSlickSlider+' .slick-slide > .shg-box.shg-c > .shg-box-content > .shg-box-vertical-align-wrapper .shg-box-content').css({'height': '100%', 'padding-left':'0px', 'padding-right':'0px'});
        $(mobileSlickSlider+' .slick-slide > .shg-box.shg-c > .shg-box-content > .shg-box-vertical-align-wrapper .shg-btn-wrapper').css({'position': 'absolute', 'bottom': '0%', 'left':'0', 'right':'0'});
        $(mobileSlickSlider+' .slick-slide > .shg-box.shg-c > .shg-box-content > .shg-box-vertical-align-wrapper .shg-btn-wrapper > a').css({'widht': '251.5px', 'height': '42px', 'margin-left': '16.2px', 'margin-right': '16.2px'});
        
        let numSlides = slickSliderContainer.slick('getSlick').slideCount;
        numSlides = numSlides-1;
        $(mobileFullComp+' .slick-prev').addClass('slick-disabled');
        $(mobileFullComp+' .slick-next').removeClass('slick-disabled');
  
       $(slickSliderContainer).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          if(currentSlide==0){
            $(mobileFullComp+' .slick-prev').removeClass('slick-disabled');
          }
          if(currentSlide==1 && nextSlide==0){
            $(mobileFullComp+' .slick-prev').addClass('slick-disabled');
            $(mobileFullComp+' .slick-next').removeClass('slick-disabled');
          }
          if(currentSlide==numSlides && nextSlide>0){
            $(mobileFullComp+' .slick-prev').removeClass('slick-disabled');
            $(mobileFullComp+' .slick-next').removeClass('slick-disabled');
            }
          if(nextSlide==numSlides){
            $(mobileFullComp+' .slick-next').addClass('slick-disabled');
          }
       });
      });
    }

  //slick slider for "what customer says" shogun component on homepage mobile view
  var slickSliderContainer=$('.mobileWhatCustomerSaySlickSlider').find('.shg-box-content').first();
  var slidesToShow = 1.207;
  var mobileSlickSlider = '.mobileWhatCustomerSaySlickSlider';
  var mobileFullComp = '.mobileWhatCustomerSaysFullComp';

  mobileViewSlickSlider(slickSliderContainer, slidesToShow, mobileSlickSlider);
  mobileSlickSliderWhatCustomerSayStyling(slickSliderContainer, mobileFullComp, mobileSlickSlider);
 
function mobileSlickSliderWhatCustomerSayStyling(slickSliderContainer, mobileFullComp, mobileSlickSlider){
    $(mobileFullComp).css('margin-left', '16px');
    $(mobileSlickSlider+' .slick-slide').css({'width': '284px', 'margin-right': '16px'});
    $(mobileSlickSlider+' .slick-slide').find('.shg-box.shg-c').first().css({'margin': '0px', 'height': 'inherit'});
    var slickCustomerSayNextElement = '<button type="button" style="position:relative; box-shadow: 1px 2px 10px 0 rgb(94 113 131 / 35%);bottom:24px;margin-left:16px;margin-right:16px;min-width: 40px;height: 40px; line-height: 40px;" data-role="none" class="slick-next slick-arrow rightArrowElement" aria-label="Next" role="button" style="display: block;" aria-disabled="false">Next</button>';
    var slickCustomerSayPrevElement = '<button type="button" style="position:relative; box-shadow: 1px 2px 10px 0 rgb(94 113 131 / 35%);bottom:24px;margin-left:8px;min-width: 40px;height: 40px; line-height: 40px;" data-role="none" class="slick-prev slick-arrow leftArrowElement" aria-label="Previous" role="button" aria-disabled="true" style="display: block;">Previous</button>';
    $(mobileFullComp).find('.shg-box-vertical-align-wrapper').first().append(slickCustomerSayPrevElement);
    $(mobileFullComp).find('.shg-box-vertical-align-wrapper').first().append(slickCustomerSayNextElement);
    $(mobileFullComp).find('.shg-box-vertical-align-wrapper').first().css({'height':'56px', 'margin-bottom':'7px'});
    $(mobileFullComp).find('.shg-box-vertical-align-wrapper .shg-c.shg-align-left').first().css({'margin-left':'unset'});

      $(mobileFullComp+' .slick-arrow.leftArrowElement').on('click', function(){
        $(mobileSlickSlider).find('.shg-box-content').first().slick('slickPrev');
      });
      $(mobileFullComp+' .slick-arrow.rightArrowElement').on('click', function(){
        $(mobileSlickSlider).find('.shg-box-content').first().slick('slickNext');
      });
    window.addEventListener("load", (event) => {
      var elementheightVal = $(mobileSlickSlider).height();
        $(mobileSlickSlider+" .slick-slide").each(function () { 
          if( $(this).height()>elementheightVal){ 
            elementheightVal = $(this).height();
          }
        });
        $(mobileSlickSlider+" .slick-slide").height(elementheightVal);
        $(mobileSlickSlider+' .slick-slide > .shg-box.shg-c').css('height', 'inherit');
        $(mobileSlickSlider+' .slick-slide > .shg-box.shg-c > .shg-box-content').css({'height': 'inherit'});
        $(mobileSlickSlider+' .slick-slide > .shg-box.shg-c > .shg-box-content > .shg-box-vertical-align-wrapper').css({'position': 'absolute', 'bottom': '0%'});
        
        let numSlides = slickSliderContainer.slick('getSlick').slideCount;
        numSlides = numSlides-1;
        $(mobileFullComp+' .slick-prev').addClass('slick-disabled');
        $(mobileFullComp+' .slick-next').removeClass('slick-disabled');
  
       $(slickSliderContainer).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          if(currentSlide==0){
            $(mobileFullComp+' .slick-prev').removeClass('slick-disabled');
          }
          if(currentSlide==1 && nextSlide==0){
            $(mobileFullComp+' .slick-prev').addClass('slick-disabled');
            $(mobileFullComp+' .slick-next').removeClass('slick-disabled');
          }
          if(currentSlide==numSlides && nextSlide>0){
            $(mobileFullComp+' .slick-prev').removeClass('slick-disabled');
            $(mobileFullComp+' .slick-next').removeClass('slick-disabled');
            }
          if(nextSlide==numSlides){
            $(mobileFullComp+' .slick-next').addClass('slick-disabled');
          }
       });
      });
    }
//slick slider for "tips and inspiration" shogun component on homepage mobile view    
  var slickSliderContainer=$('.mobileTipSlickSlider').find('.shg-box-content').first();
  var slidesToShow = 1.207;
  var mobileSlickSlider = '.mobileTipSlickSlider';
  var mobileFullComp = '.mobileTipsFullComp';

  mobileViewSlickSlider(slickSliderContainer, slidesToShow, mobileSlickSlider);
  mobileSlickSliderTipsaAndInspStyling(slickSliderContainer, mobileFullComp, mobileSlickSlider);

function mobileSlickSliderTipsaAndInspStyling(slickSliderContainer, mobileFullComp, mobileSlickSlider){
    $(mobileFullComp).css('padding-right', '0px');
    $(mobileFullComp+' > .page-width').css({'padding-left': '0px', 'padding-right': '0px'});
    $(mobileSlickSlider+' .slick-slide').css({'width': '284px', 'margin-right': '16px'});
    $(mobileSlickSlider+' .slick-slide').find('.shg-box.shg-c').first().css({'margin': '0px'});
    $(mobileSlickSlider+' .slick-slide').find('.shg-box-content > .shg-c').css({'margin-top': '0px', 'margin-bottom': '0px'});
    var slickTipsNextElement = '<button type="button" style="position:relative; box-shadow: 1px 2px 10px 0 rgb(94 113 131 / 35%);bottom:16px;margin-left:16px;margin-right: 16px;min-width: 40px;height: 40px; line-height: 40px;" data-role="none" class="slick-next slick-arrow rightArrowElement" aria-label="Next" role="button" style="display: block;" aria-disabled="false">Next</button>';
    var slickTipsPrevElement = '<button type="button" style="position:relative; box-shadow: 1px 2px 10px 0 rgb(94 113 131 / 35%);bottom:16px;margin-left:8px;min-width: 40px;height: 40px; line-height: 40px;" data-role="none" class="slick-prev slick-arrow leftArrowElement" aria-label="Previous" role="button" aria-disabled="true" style="display: block;">Previous</button>';
    $(mobileFullComp).find('.shg-box-vertical-align-wrapper').first().append(slickTipsPrevElement);
    $(mobileFullComp).find('.shg-box-vertical-align-wrapper').first().append(slickTipsNextElement);
    $(mobileFullComp).find('.shg-box-vertical-align-wrapper').first().css({'height': '56px', 'padding-bottom': '16px'});
    $(mobileFullComp).find('.shg-box-vertical-align-wrapper .shg-c.shg-align-left').first().css({'margin-left':'unset'});
      $(mobileFullComp+' .slick-arrow.leftArrowElement').on('click', function(){
        $(mobileSlickSlider).find('.shg-box-content').first().slick('slickPrev');
      });
      $(mobileFullComp+' .slick-arrow.rightArrowElement').on('click', function(){
        $(mobileSlickSlider).find('.shg-box-content').first().slick('slickNext');
      });

    window.addEventListener("load", (event) => {
      var elementheight = $(mobileSlickSlider).height();
          $(mobileSlickSlider+" .slick-slide").each(function () { 
              if( $(this).height()>elementheight){
                elementheight = $(this).height();
                }
        });
        $(mobileSlickSlider+" .slick-slide > .shg-box.shg-c > .shg-box-content > .shg-c").css('min-height', elementheight+'px');
        $(mobileSlickSlider+" .slick-slide .shg-box.shg-c.shg-box-linked").css('min-height', elementheight+'px'); 
      
        let numSlides = slickSliderContainer.slick('getSlick').slideCount;
        numSlides = numSlides-1;
        $(mobileFullComp+' .slick-prev').addClass('slick-disabled');
        $(mobileFullComp+' .slick-next').removeClass('slick-disabled');
  
       $(slickSliderContainer).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          if(currentSlide==0){
            $(mobileFullComp+' .slick-prev').removeClass('slick-disabled');
          }
          if(currentSlide==1 && nextSlide==0){
            $(mobileFullComp+' .slick-prev').addClass('slick-disabled');
            $(mobileFullComp+' .slick-next').removeClass('slick-disabled');
          }
          if(currentSlide==numSlides && nextSlide>0){
            $(mobileFullComp+' .slick-prev').removeClass('slick-disabled');
            $(mobileFullComp+' .slick-next').removeClass('slick-disabled');
            }
          if(nextSlide==numSlides){
            $(mobileFullComp+' .slick-next').addClass('slick-disabled');
          }
       });
      });  
    }
//end of slick slider mobile view for shogun components on homepage

  $(".saleTime, .heroSaleTime").each(function () {
    var $this = $(this),
      date = $(this).data('date'),
      countDownDate = new Date(date).getTime();

    var x = setInterval(function () {
      var now = new Date().getTime(),
        distance = countDownDate - now,
        days = Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (days > 99) {
        days = ("00" + days).substr(-3);
      } else {
        days = ("00" + days).substr(-2);
      }
      hours = ("00" + hours).substr(-2);
      minutes = ("00" + minutes).substr(-2);
      seconds = ("00" + seconds).substr(-2);

      $($this).find(".counter").html("<span class='days'>" + days + "<span>" + theme.days + "</span></span> <span class='hours'>" + hours + "<span>" + theme.hours + "</span></span> <span class='minutes'>" + minutes + "<span>" + theme.minuts + "</span></span> <span class='seconds'>" + seconds + "<span>" + theme.seconds + "</span>");

      if (distance < 0) {
        clearInterval(x); $($this).hide();
      }
    }, 1000);
  });

  // LOOKBOOK SHOP 
  $('.btn-shop').click(function () {
    $('.products .grid-lb, .grid-lookbook').removeClass('active');
    $(this).next().addClass('active');
    $(this).parents('.grid-lookbook').addClass('active');
  });
  $('.btn-shop-close').click(function () {
    $(this).parent().removeClass('active');
  });

  function addPromo() {
    $('.evm_fancybox-wrap').append(`<div id="lookbook-promo">
     <div class="container-info-lookbook">
       <p class="title-promo-lookbook">Love the look?</p> 
       <p class="paragraph-promo-lookbook"><a href="/pages/customer-support" class="link-product-lookbook">Get in touch</a> for product and installation help!</p> 
     </div>     
   </div>`);
  }

  //LOOKBOOK PROMO
  // Keep checking to see if lookbook grid has been inserted
  function startPromo() {
    var lookbookInterval = setInterval(function () {
      var $lookbookGrid = $('#EVMgrid');
      if ($lookbookGrid.length > 0) {
        // If the grid has items in it, show the gallery title
        $('#EVMgrid li').on('click', function () {
          setTimeout(() => {
            getHandlesInGallery();
            addPromo();
            checkLookbookGridNavs();
          }, 1000);
        });
        checkLookbookGridNavs();
        // Stop checking for lookbook grid
        clearInterval(lookbookInterval);
      }
    }, 100);
  }
  const checkLookbookGridNavs = () => {
    $('.evm_fancybox-nav').on('click', () => {
      setTimeout(() => {
        getHandlesInGallery();
        addPromo();
        startPromo();
      }, 1000);
    });
  };
  startPromo();


  // PROMOTION HEADER show-hide
  if ($.cookie('promotion') != 'true') {
    $(".notification-bar").show();
  }
  $(".close-announcement").click(function () {
    $(".notification-bar").slideUp();
    $.cookie('promotion', 'true', { expires: 1, path: '/' });
  });

  // SHOW HIDE PRODUCT Filters
  $('.btn-filter').click(function () {
    $(".filterbar").toggleClass("active");
  });
  $('.closeFilter').click(function () {
    $(".filterbar").removeClass("active");
  });
  $("body").click(function (event) {
    var $target = $(event.target);
    if (!$target.parents().is(".filterbar") && !$target.is(".filterbar") && !$target.is(".btn-filter")) {
      $(".filterbar").removeClass("active");
    }
  });

  // STICKY HEADER
  window.onscroll = function () { scrollFunction(); };
  function scrollFunction() {
    if($('#sticky-header-flag').length) {
      if ($(window).scrollTop() > $('#sticky-header-flag').position().top) {
        const currentScrollHorizontalPosition = $('.container-products.scrolling')?.scrollLeft();
        const stickyHeader =   $('#sticky-header-parent');
        stickyHeader.show();
        $('#sticky-header-bottom').show();
        if(stickyHeader.scrollLeft() !== currentScrollHorizontalPosition) stickyHeader.scrollLeft(currentScrollHorizontalPosition)
        
      } else {
        $('#sticky-header-parent').hide();
        $('#sticky-header-bottom').hide();
      }
    }
    if (theme.fixedHeader) {
      let divResult = $('.snize-ac-results');
      if ($(window).scrollTop() > 0) {
        $('body').addClass("sticky-header-open");
        if(divResult.is(":visible")) {
          $('#headerWrapper').addClass("stickyHeader").show();
        }else{
          $('#headerWrapper').addClass("stickyHeader animated fadeInDown");
          $('.sticky-header').addClass("stickyHeader animated fadeInDown sticky-header-scroll");
        }
        $('#header').css("min-height", $('#headerWrapper').height());
        divResult.css("top", $('#headerWrapper').height()-3);
      } else {
        $('body').removeClass("sticky-header-open");
        if(divResult.is(":visible")) {
          $('#headerWrapper').removeClass("stickyHeader");
        }else{
          $('#headerWrapper').removeClass("stickyHeader fadeInDown");
          $('.sticky-header').removeClass("stickyHeader animated fadeInDown sticky-header-scroll");
        }
        $('#header').css("min-height", '');
        divResult.css("top", 
          $('#sticky-banner').height()
          + $('.top-header-wrapper').height()
          + $('#headerWrapper').height()
          -4
        );
      }
    }

    /// sticky cart 
    if ($(window).scrollTop() > 600 && $(".stickyCart").length) {
      $("body.template-product").css('padding-bottom', '70px');
      $(".stickyCart").slideDown();
    } else {
      $("body.template-product").css('padding-bottom', '0');
      $(".stickyCart").slideUp();
    }

    // SITE SCROLLER
    if ($(window).scrollTop() > 200) {
      $("#site-scroll").fadeIn();
    } else {
      $("#site-scroll").fadeOut();
    }
  }

  $("#site-scroll").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  });

  // `Click to call` sticky button
  var CLICK_TO_CALL_COOKIE_NAME = 'click_to_call';
  var clickToCall = $('.click-to-call');
  var shouldShowClickToCall = !$.cookie(CLICK_TO_CALL_COOKIE_NAME);
  if (clickToCall.length && shouldShowClickToCall) {
    clickToCall.show();
    var siteFooter = $('.site-footer');
    var $window = $(window);
    var scrollHandler = function () {
      var windowTop = $window.scrollTop();
      var windowHeight = $window.height();
      var siteFooterTop = siteFooter.offset().top;
      clickToCall.toggleClass('sticky', windowTop + windowHeight > siteFooterTop);
    };
    $('.close-btn', clickToCall).on('click', function () {
      clickToCall.hide();
      $.cookie(CLICK_TO_CALL_COOKIE_NAME, 1, { expires: 365, path: '/' });
      $(window).off('scroll', scrollHandler);
    });
    $(window).scroll(scrollHandler);
  }

  //Footer links for mobiles
  $(".footer-links .h3").click(function () {
    if ($(window).width() < 750) {
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    }
  });
  
  //upsell module qty field input value change event
  $(".pdpCompatibleGridSystems .qty-form input").on("keyup",function(){
    var qtyLimit = 0, newVal = $(this).val(),
    oldqty=$(this).attr("old-qty");
    if(isNaN(newVal)){
      $(this).val(oldqty);
      return false;
    }
    var bundle = $(this).parent(".qtyField").attr('data-bundle');
    var diffqty = newVal-oldqty;
    
    $(this).attr('old-qty',newVal);
    //compatible grid system for ceilling PDP Starts
    if($(this).parent().parent('.qty-form').length){
      var dataPrice = $(this).parent().parent().attr('data-price');
      var isModal = '.isSection';
      if($(this).parent().parent('.qty-form').hasClass("isModal")){
        isModal= '.isModal';
      }
      var oldTotal = $(isModal+'.total-gr-price-'+bundle).attr('total');
      var newTotal = Number(oldTotal);
      newTotal = Number(oldTotal)+Number(dataPrice)*diffqty;
      $(isModal+'.total-gr-price-'+bundle).attr('total',newTotal);
      newTotal= newTotal/100;
      newTotal= newTotal.toLocaleString('en-US', {minimumFractionDigits: 2});
      $(isModal+'.total-gr-price-'+bundle).text('$'+newTotal);
    }
    
    if ($('.' + bundle + ' .total-bundle').attr('total') <= 0) {
      $('.' + bundle + ' .add-grid-system').addClass('disabled');
    } else {
      $('.' + bundle + ' .add-grid-system').removeClass('disabled');
    }
    
    if ($('.tile-added-to-cart ' + '.' + bundle + ' .total-bundle').attr('total') <= 0) {
      $('.tile-added-to-cart ' + '.' + bundle + ' .add-grid-system').addClass('disabled');
    } else {
      $('.tile-added-to-cart ' + '.' + bundle + ' .add-grid-system').removeClass('disabled');
    }
    //compatible grid system for ceilling PDP Ends
    reloadShippingEstimates();

    // For Tile Template validate button and calculate subtotal
    if(isTileTemplate() || isWallTemplate() || isCoolEdgeTemplate() || isDecorativeTemplate() || isBundleTemplate() || isDefaultTemplate() || isSpaceKitTemplate()){
      validateButton();
    }
  });
  
  $('.product-template__container #quantity').change(function() {
    var newValue = $(this).val();
    if (newValue <= 0 && !($(this).parents('.qty-estimator-acc').length || $(this).parents('.quantity-accordion-wall').length || $(this).parents('.quantity-accordion-default').length)) {
      $('.btn.banner-btn').attr('disabled', true);
      $('.btn.banner-btn-mobile').attr('disabled', true);
      $('#AddToCart-product-template-tile').attr('disabled', true);
      $(this).val(0);
    } else if (newValue > 0) {
      $('.btn.banner-btn').attr('disabled', false);
      $('.btn.banner-btn-mobile').attr('disabled', false);
      $('#AddToCart-product-template-tile').attr('disabled', false);
    } else if( newValue <= 0 && ($(this).parents('.qty-estimator-acc').length || $(this).parents('.quantity-accordion-wall').length || $(this).parents('.quantity-accordion-default').length)) {
      $(this).val(1);
    }
    
    // For Tile Template validate button and calculate subtotal
    if(isTileTemplate() || isWallTemplate() || isCoolEdgeTemplate() || isDecorativeTemplate() || isBundleTemplate() || isDefaultTemplate() || isSpaceKitTemplate()){
      validateButton();
    }
  });
  //compatible grid system add to cart for ceilling PDP Starts
  $(".add-grid-system").off("click").on("click", function () {
    // Logic for Wall Instalation Service
    if(isWallTemplate()) {
      installUserSelection(true);
      setInstallationServiceValue();
    }

    var isModal = '.isSection';
    if($(this).hasClass("isModal")){
      isModal= '.isModal';
    }
    const productsE = $(isModal+'.qty-form:visible');
    const products = [];
    productsE.each(function(){
      const quantity = $(this).find('.product-form__input').val();
      if(quantity > 0 ) {
        const props = {};
        const id = $(this).attr('data-id');
        const discount = getDiscountUpsell(id, upsell_dsc_input );
        if(discount !== false && localStorage.getItem('applyDiscount') == "true") props['_discount'] = discount;
        products.push({ id, quantity, props });
      }
    });
    var count = products.length;
    products.forEach(function(product, idx, products) {
        CartJS.addItem(product.id, product.quantity, product.props, {
          "success": function(data, textStatus, jqXHR) {
            // Show the cart only at the last iteration
            $("body").addClass("showOverly");
            $("body").addClass("loading");
            $('.add-grid-system').css({"background-color": "#1cacda", "color": "white" , "border": "none"});
            count --;
            if (idx === products.length - 1) {
              setTimeout(function() {
                $.magnificPopup.close();
                $("body").removeClass("loading");
                $('.add-grid-system').css({"background-color": "white", "color": "#5e7183" , "border": "solid 2px #5e7183"});
                $(".block-cart").addClass("active");
                JQ('#added-to-cart').modal('hide');
                calculateAlreadyInCart();
                if (count == 0){
                  $('#gridSystemSectionCart').hide();
                      // $('.pdpCompatibleGridSystems').hide();
                      if($('#shopify-section-cart-template').length) {
                        location.reload();
                      }   
                }
              },1000);
              $('.Check_cart_flyout').show();
            }
          },
          "error": function(jqXHR, textStatus, errorThrown){
            var errormsg = JSON.parse(jqXHR.responseText).description;
            $("body").removeClass("loading");
            $(".error-message").text(errormsg);
            $("body").addClass("showOverly");
            $("#errorDrawer").fadeIn(500);
            setTimeout(function(){
              $("body").removeClass("loading showOverly"), $("#errorDrawer").fadeOut(200);
            }, 6000);
          }
        });
    });
  });
  
  function getDiscountUpsell(variant_id, dsc_input) {
    const dsc_input_val  = dsc_input.val();
    const apply_discounts = checkDateRange();
    if(dsc_input_val.length > 0 && apply_discounts) {
      const variants = dsc_input_val.split(',');
      for (let variant of variants) {
        if(variant == '') continue;
        const [id, discount] = variant.split(':');
        if(id== variant_id) return discount;
      }
    }
    return false;
  }
  if($('.parent-grid-system-container').length){
    var leftPaddle = document.getElementsByClassName("left-scroll-button");
    var rightPaddle = document.getElementsByClassName("right-scroll-button");
    var scrollDuration=300;
    // scroll to left
    
    $(rightPaddle).on('click', function () {
      var scrollPX= 344;
      if($(this).hasClass('isModal')){
        scrollPX= 344*2;
      }
      $(this).addClass('d-none');
      $(leftPaddle).removeClass('d-none');
      $('.middle-wrapper .left').removeClass('right-activated');
      $('.middle-wrapper .left').addClass('left-activated');
      $('.parent-grid-system-container').animate({ scrollLeft: '+=' + scrollPX }, scrollDuration);
    });

    // scroll to right
    $(leftPaddle).on('click', function () {
      var scrollPX= 344;
      if($(this).hasClass('isModal')){
        scrollPX= 344*2;
      }
      $(this).addClass('d-none');
      $(rightPaddle).removeClass('d-none');
      $('.middle-wrapper .left').addClass('right-activated');
      $('.middle-wrapper .left').removeClass('left-activated');
      $('.parent-grid-system-container').animate({ scrollLeft: '-=' + scrollPX }, scrollDuration);
    });
  }
  //compatible grid system add to cart for ceilling PDP Ends
  $('#quantity').on('keydown, keyup', function () {
    if ($(this).val() < 0 || $(this).val().includes(`-`)) {
      $(this).val(0);
    }
  });

  $(document).on('click', '.grid-view-item .swatches li:not(.noImg)', function (e) {
    var newImage = $(this).attr('rel'),
      boxOuter = $(this).parents('.grid-view-item'),
      color = $(this),
      colorlist = $(this).parents('.swatches').children(".swatch");
    $(boxOuter).find('.grid-view_image').addClass("showLoading");
    $(boxOuter).find('.variantImg').attr({ src: newImage });
    $(boxOuter).find('.variantImg').load(function () {
      $(colorlist).removeClass("active");
      $(color).addClass("active");
      $(this).parents('.swatches').children(".swatch").addClass('active');
      $(boxOuter).find('.grid-view_image').removeClass("showLoading").addClass("showVariantImg");
    });
    return false;
  });
  $('.tile-or-wall.grid-view-item .swatches li:not(.noImg)').mouseenter(function (e) {
    var newImage = $(this).attr('rel'),
     boxOuter = $(this).parents('.grid-view-item');
    $(boxOuter).find('.grid-view_image').addClass("showLoading");
    $(boxOuter).find('.variantImg').attr({ src: newImage });
    $(boxOuter).find('.grid-view_image').removeClass("showLoading").addClass("showVariantImg");
  }).mouseleave(function (e) {
    var newImage = $(this).siblings('.active').attr('rel'),
     boxOuter = $(this).parents('.grid-view-item');
    $(boxOuter).find('.grid-view_image').addClass("showLoading");
    if(!newImage && $(this).hasClass('active')){
      newImage = $(this).attr('rel');
    }
    if(newImage){
      $(boxOuter).find('.variantImg').attr({ src: newImage });
      $(boxOuter).find('.grid-view_image').removeClass("showLoading").addClass("showVariantImg");
    }else{
      $(boxOuter).find('.grid-view_image').removeClass("showLoading").removeClass("showVariantImg");
    }
  });

  // Site Animation
  if (theme.animationMobile) {
    if ($(window).width() < 767) {
      $('.wow').removeClass('wow');
    }
  }
  if (theme.animation) {
    new WOW().init();
  }

  loadBgImages();
});

function setSelectElement(selectOne, selectTwo) {
  if (selectOne === 'Architect/Specifier/Designer') {
    $('.results-images-kanopi').hide();
    $('.results-kanopi').show();
    $('.results-kanopi-contractor').hide();
  } else if (selectOne != 'Architect/Specifier/Designer' && selectTwo === '10,000 sqft or less') {
    $('.results-images-kanopi').show();
    $('.results-kanopi').hide();
    $('.results-kanopi-contractor').hide();
  } else if (selectOne === 'General or Sub Contractor' && selectTwo === 'over 10,000 sqft') {
    $('.results-images-kanopi').hide();
    $('.results-kanopi').hide();
    $('.results-kanopi-contractor').show();
  } else {
    $('.results-images-kanopi').hide();
    $('.results-kanopi').show();
    $('.results-kanopi-contractor').hide();
  }
}

$(document).ready(function () {
  $('.results-kanopi').hide();
  $('.results-kanopi-contractor').hide();
  $('.btn-submit').on('click', function () {
    var selectOne = $('select.select-roles').val();
    var selectTwo = $('select.select-project').val();
    setSelectElement(selectOne, selectTwo);
    $('.container-component').hide();
  });
  $('.return-link').on('click', function () {
    $('.container-component').show();
    $('.results-images-kanopi').hide();
    $('.results-kanopi').hide();
    $('.results-kanopi-contractor').hide();
  });
  $('.icon-unselect:first-child').each(function () {
    $("#width_tmp_option").html($('option:selected', this).text());
    $(this).width($("#width_tmp_select").width());
  });
  var selectOption = $(".icon-unselect").val();
  $(".icon-unselect").on({
    "change": function () {
      $(this).blur();
      $("#width_tmp_option").html($('option:selected', this).text());
      $(this).width($("#width_tmp_select").width());
    },
    'focus': function () {
      $(this).parent().find('i').addClass('select-active');
    },
    "blur": function () {
      $(this).parent().find('i').removeClass('select-active');
    },
    "keyup": function (e) {
      if (e.keyCode == 27)
        $(this).parent().find('i').addClass('select-active');
    },
    "click": function () {
      if ($(this).val() === selectOption) {
        $(this).parent().find('i').removeClass('select-active');
      } else {
        selectOption = $(this).val();
      }
    }
  });
  var timeSelectShow = 2000;
  setTimeout(function () {
    var $dropDownElement = $('.dropdown-toggle');
    $dropDownElement.click(
      function () {
        $(this).toggleClass('select-active');
      });
    $('.selectpicker').change(
      function () {
        $dropDownElement.removeClass('select-active');
      });
    $dropDownElement.focusout(
      function () {
        $(this).removeClass('select-active');
      });
  }, timeSelectShow);
});



var openPhotoSwipe = function () {
  $(".stickyHeader").hide();
  $("body").css("overflow", "hidden");
  var pswpElement = document.querySelectorAll('.pswp')[0];
  var pswpClose = document.querySelector(".pswp .pswp__button--close");
  var pswpCloseModal = document.querySelector(".pswp .pswp__container");
  $('.main-content').css('z-index', '51');
  $('.main-content').css('position', 'initial');
  $('#headerWrapper').css('z-index', '1');
  pswpClose.addEventListener("click", function () { //close modal video with button
    $('.pswp').removeClass('pswp--open');
    var $frame = $('.pswp iframe');
    var vidsrc = $frame.attr('src');
    $frame.attr('src', '');
    $frame.attr('src', vidsrc);
    $('.main-content').css('z-index', '0');
    $('.main-content').css('position', 'relative');
    $(".pswp .pswpbutton--close").on('click', () => { 
      $(".pswp .pswpbutton--close").click(); 
    });
    $("body").css("overflow", "visible");
  });
  pswpCloseModal.addEventListener("click", function () { // close de modal video with click outside the box
    $('.pswp').removeClass('pswp--open');
    var $frame = $('.pswp iframe');
    var vidsrc = $frame.attr('src');
    $frame.attr('src', '');
    $frame.attr('src', vidsrc);
    $('.main-content').css('z-index', '0');
    $('.main-content').css('position', 'relative');
    $("body").css("overflow", "visible");
  });
  
  $(document).bind('keydown',function(e){
    if ( e.which == 27 ) {
      $("body").css("overflow", "visible");
      
    };
  });

  let video_url="";
  if ($(this).hasClass('lightbox-video-click')) {
    video_url = $(this).find('a').attr('href');
  } 
  var items = [
    {
      html: '<iframe src="' + video_url + '?&autoplay=1" style="" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" webkitallowfullscreen mozallowfullscreen class="product-iframe-video"></iframe>'
    },
  ];
  


  var options = {
    history: false,
    focus: false,
    showAnimationDuration: 0,
    hideAnimationDuration: 0,
    shareEl: 0,
    closeOnScroll: false,
    closeOnVerticalDrag: false,
    wheelToZoom: false,
    pinchToClose: false,
    tapToClose: 1,
    // disable zoom
    getDoubleTapZoom: function (item) {
      return item.initialZoomLevel;
    },
    zoomEl: false
  };

  var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();

  var timeLoadComponents = 1000;
  const $modal = $(".pswp");
  setTimeout(function () {
    var $pswpCloseModal = $('.pswp__button--close');
    var $frame = $('.pswp');
    var vidsrc = $frame.attr('src');
    $pswpCloseModal.on("change", function () {
      $frame.attr('src', '');
      $frame.attr('src', vidsrc);
      $('.main-content').css('z-index', '0');
      $('.main-content').css('position', 'relative');
    });
  }, timeLoadComponents);

  gallery.listen('close', function () {
    $("body").css("overflow", "visible");
    $('.product-iframe-video').remove();
    $(".stickyHeader").show();
    $('#headerWrapper').css('z-index', '15');
  });
};

document.querySelectorAll('.hover-promo').forEach(item => {
  item.onclick = openPhotoSwipe;
});

// Prevent links that open video lightbox to redirect
$('.hover-promo').on('click', function(e) { e.preventDefault(); } );

$('#is_stock_' + $('.product-template__container').attr('data-current-variant')).css('display', 'flex');

const $modal = $(".pswp");
if ($modal.length) {
  $modal.on("wheel mousewheel", function (e) {
    if ($modal.hasClass("pswp--open")) {
      var $frame = $('.pswp iframe');
      var vidsrc = $frame.attr('src');
      $frame.attr('src', '');
      $frame.attr('src', vidsrc);
    }
  });
}

$('#shipping_time_' + $('div[data-section-type="product"]').attr('data-current-variant')).css('display', 'block');

function showOverly(show, zindex=666, top=0) {
  $(".modalOverly").css("top", top+"px");
  if(show) {
    $('body').addClass("showOverly");
    $(".modalOverly").css("z-index", zindex + 1);
    if(typeof isQuickView === "function" && isQuickView()){
      $('.Check_cart_flyout').show();
    }
  } else {
    $('.Check_cart_flyout').hide();
    $('body').removeClass("showOverly");
    $(".modalOverly").css("z-index", "666");
    $("html").removeClass("boost-pfs-body-no-scroll-mini-cart");
  }
}

//light box implimentation starts
$(document).ready(function () {
  // Hover in child over desktop 1st level menu color and arrow
  $("#siteNav .style1").hover(function(){
      $(this).siblings('a').find('.ad')
        .addClass('ad-angle-up-l')
        .removeClass('ad-angle-down-l');
    }, function(){
      $(this).siblings('a').find('.ad')
        .addClass('ad-angle-down-l')
        .removeClass('ad-angle-up-l');
  });
  
  setTimeout(function () {
    $('.popup-vedio-pdp').magnificPopup({
      // disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,

      fixedContentPos: false
    });
    // $('.grid-pdp-thumbnails .video.slick-slide').click(function () {
    //   const dataSlide = $(this).attr('data-slide').toString();
    //   $('.grid-pdp [data-slide="' + dataSlide + '"] a').click();
    // });
  }, 1000);
  // moving image view button in mobile screens
  if ($(".primgSlider").length && $(".primgSlider").hasClass('grid-pdp')) {
    if(window.outerWidth < 600){
      const rightMargin =  ( outerWidth-286) / 2 + 19;
      $('.product-btn').css('right',rightMargin);
      $('.product-btn').css('bottom',$('.slick-dots').height()-4);
      $('.new-flag').css('left',rightMargin-13);
    }
    $(window).on('resize', function () {
      if(window.outerWidth < 600){
        const rightMargin =  ( outerWidth-286) / 2 + 19;
          $('.product-btn').css('right',rightMargin);
          $('.product-btn').css('bottom',$('.slick-dots').height()-4);
          $('.new-flag').css('left',rightMargin-13);
      }else{
        $('.product-btn').removeAttr('style');
        $('.new-flag').removeAttr('style');
      }
    });
  }

});
//light box implimentation ends
//Specification section in grid PDP
$('.specs-blocks .weight').each(function(){
  const weight = Number($(this).text());
  $(this).text(weight.toLocaleString('en-US', {minimumFractionDigits: 0})+" ");
});
//modal dismiss on edit main product from grid upsell
$('.grid-system-edit').click(function(){
  $('#added-to-cart [data-dismiss="modal"]').click();
});

//color label updates on main images in pdp
$('.color-label-data').each(function(){
  const media = $(this).attr('media-id');
  const label = $(this).attr('color-label');
  $('#'+media+' .color-label').text(label);
  $('#'+media+' .color-label').css('display','block');
});

// MegaMenu functionality
var menuList = $('#siteNav').find('li.megamenu');
var hideMenu = {
  visibility : "hidden",
  opacity: 0,
  WebkitTransition : 'all 0.3s ease-out',
    MozTransition    : 'all 0.3s ease-out',
    MsTransition     : 'all 0.3s ease-out',
    OTransition      : 'all 0.3s ease-out',
    transition       : 'all 0.3s ease-out'
}
var hide = {
  visibility : "hidden",
  opacity: 0,
  WebkitTransition : 'none',
  MozTransition    : 'none',
  MsTransition     : 'none',
  OTransition      : 'none',
  transition       : 'none'
};
var show = {
  visibility : "visible",
  opacity: 1
};
var timer;
var closeMenu;
var pathname = window.location.pathname;
    $('#siteNav').children('li').mouseenter(
      function (){
        var that = this;
        timer = setTimeout(function(){
          if (!$(that).hasClass("no-overlay"))
            showOverly(true, 1,100);
          else    
            showOverly(false);
          if (!$(this).hasClass("hovered")){
            menuList.removeClass('hovered');
            $(that).addClass('hovered');    
            $(menuList).each(function(index,item){
              if (!$(item).hasClass("hovered")){
                $(this).children('.megamenu').css(hide);
                // Only main level in desktop menu
                $(this).find('a.hover-style .ad')
                  .addClass('ad-angle-down-l')
                  .removeClass('ad-angle-up-l');
              } else {
                $(this).children('.megamenu').css(show);
                if(pathname = '/pages/compare-products'){
                compareStickyHeaderParentZindexOff();
                }
                // Only main level in desktop menu
                $(this).find('a.hover-style .ad')
                  .addClass('ad-angle-up-l')
                  .removeClass('ad-angle-down-l');
              }
            })
          }
        }, 500);
        }).mouseleave(function() {
            clearTimeout(timer);
        
        
      }
    );

    $('#siteNav').mouseleave(function () {
      closeMenu = setTimeout(function(){
        $('#siteNav').children('li').children('.megamenu').css(hideMenu);
        showOverly(false);
        if(pathname = '/pages/compare-products'){
          compareStickyHeaderParentZindexReset();
          }
      }, 400);
    }).mouseenter(function() {
      clearTimeout(closeMenu);
      });
  
    $('input[type=search]').on('search', function(){
      $("#siteNav").removeClass("disabledMenu");
    })
    function compareStickyHeaderParentZindexOff(){
      $('.megamenu.style1.mmfull', '#siteNav').each(function () {
        if($(this).parent().css('visibility') == "visible" ){
          $('#sticky-header-parent').css('z-index',"unset");
        }
    });   
    }
    function compareStickyHeaderParentZindexReset(){
        $('#sticky-header-parent').css('z-index',"51");  
    }
function isQuickView() {
  return $('#quickView').length > 0;
};
const initQuantityTotal = function () {
  quantityTotal = 0;
  const productVariant = document.querySelectorAll('.product__variant-checkbox');
  const checkBoxes = document.querySelectorAll('.product__variant-checkbox');
  for(var i = 0; i < productVariant.length; i++) {
    if(checkBoxes[i].checked) {
      quantity = document.getElementById('quantity-'+checkBoxes[i].getAttribute('data-id')).value;
      quantityInt = parseInt(quantity);
      quantityTotal = quantityTotal + quantityInt;
    } 
  }
  
  var baseItems = `${quantityTotal} item${ (quantityTotal > 1 ? 's' : '' ) }`;
  if(!isBundleTemplate()){
    $('.add-added').html(`ADD ${ baseItems } TO CART`);
  }
  $('#qv-subtotal-items').html(` (${ baseItems })`);
  
}
//on https://kanopibyarmstrong.com/pages/healthier-spaces update CTA to open in same page 
$(document).ready(function(){
  if(window.location.href.includes('/pages/healthier-spaces')){
    $('a.btn[target="_blank"]').attr('target','');
  }
});
const changeValueQuantity = function (element, valueToOperate) {
  if($('#estimator-result-text-blue').length>0){
    $('#estimator-result-text-blue').hide();
    $('#estimator-result-text-blue-add-2pc').hide();
  }
  let input = document.getElementById('quantity-'+element.getAttribute('data-id'));
  const inputValue = parseInt(input.value);
  if(isNaN(inputValue)) input.value = 1;
  quantityThisElement = parseInt(input.value);
  quantityTotalThisElement = quantityThisElement + parseInt(valueToOperate);
  
  if(quantityTotalThisElement === 0 && element.classList.contains('product-form__input')) {
   const variantCheckbox = document.getElementById('checkbox-'+element.getAttribute('data-id'));
   variantCheckbox?.click();
  }


  if (quantityTotalThisElement >= 0) {
    input.value = quantityTotalThisElement;
    try {
      updateElement(element,valueToOperate);
      initQuantityTotal();
      initPriceSubtotalGrid(free_shipping_price);
   } catch (e) {
      console.error(e);
   }
  }
}
const updateFreeShippingMsg = (priceTotal, free_shipping_price) => {
    loadingFreeShippingText = true;
    if(typeof priceTotal == 'undefined'){
     priceTotal = shippingPriceFree.total/100;
    }
    if(typeof free_shipping_price == 'undefined'){
     free_shipping_price = shippingPriceFree.freePrice;
    }
    const $shipping_msg = $(".instock-wp .stock-text .st-1 .free-shipping-msg.not-free-shipping");
    if(priceTotal > free_shipping_price && !$shipping_msg.hasClass('active') || priceTotal < free_shipping_price && $shipping_msg.hasClass('active')) {
      $shipping_msg.toggleClass('active');
    }
    const $shipping_msg_otherinfo_text = $(".option.free-message > .text").find("span");
    if(priceTotal!=0 && free_shipping_price!=0 && priceTotal >= free_shipping_price) {
      $shipping_msg_otherinfo_text.first().addClass('tw-hidden');
      $shipping_msg_otherinfo_text.last().removeClass('tw-hidden');  
      }else{
      $shipping_msg_otherinfo_text.first().removeClass('tw-hidden');
      $shipping_msg_otherinfo_text.last().addClass('tw-hidden');
      }
    loadingFreeShippingText = false;
  }
  //updated priceSubtotal and quantity Total 
const initPriceSubtotalGrid = function ( free_shipping_price ) {
    priceTotal = 0;
    priceTotalDiscounts = 0;
    const productVariant = document.querySelectorAll('.product__variant-checkbox');
    const checkBoxes = document.querySelectorAll('.product__variant-checkbox');
    for(var i = 0; i < productVariant.length; i++) {
      if(checkBoxes[i].checked) {
        price = document.getElementById('accordion-price-'+checkBoxes[i].getAttribute('data-id')).innerText;
        quantity = document.getElementById('quantity-'+checkBoxes[i].getAttribute('data-id')).value;
        quantityInt = parseInt(quantity);
        priceFloat = parseFloat(price.substr(1,price.length).replace(/,/g, ''));
        /*look for wholesale variant*/
        var variantWSG = checkBoxes[i].hasAttribute('iswholesale')?checkBoxes[i].getAttribute('iswholesale'):'false';
        if(variantWSG == 'false'){
        /*look for custom discount*/         
         const customDiscount = getDiscountmain(checkBoxes[i].getAttribute('color-s'));
         if(customDiscount>0){
           priceFloat = priceFloat - priceFloat*customDiscount/100
         }
        }
         priceTotal = priceTotal + (priceFloat * quantityInt);
        /*Look for discounts */
         priceDiscount = document.getElementById('discounted-price-'+checkBoxes[i].getAttribute('data-id')).innerText;
         if(priceDiscount != "") {
          priceDiscountFloat = parseFloat(priceDiscount.substr(1,priceDiscount.length).replace(/,/g, ''));
          priceTotalDiscounts = priceTotalDiscounts + (priceDiscountFloat * quantityInt);
         }else {
          priceTotalDiscounts = priceTotalDiscounts + (priceFloat * quantityInt);
         }
      } 
    }
    document.querySelector('#price-subtotal').innerText = '$'+Number(priceTotal).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").toLocaleString('en');
    if(typeof isQuickView === "function" && isQuickView()){
      if($("body").hasClass("not-surchage-area") && $('.dsc_btn.classic').val() ) priceTotal = priceTotalDiscounts;
      document.querySelector('#qv-subtotal-amount').innerText = '$'+Number(priceTotal).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").toLocaleString('en');
      
    } else {
      if(free_shipping_price) {
        updateFreeShippingMsg(priceTotal, free_shipping_price);
      }
      
      document.querySelector('#price-sticky').innerText = '$'+Number(priceTotal).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").toLocaleString('en');
      document.querySelector('#price-sticky-m').innerText = '$'+Number(priceTotal).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").toLocaleString('en');
      document.querySelector('#price-sticky-wholesale').innerText = '$'+Number(priceTotal).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").toLocaleString('en');
      document.querySelector('#price-sticky-m-wholesale').innerText = '$'+Number(priceTotal).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").toLocaleString('en');   
     
    }
    if(free_shipping_price) {
      updateFreeShippingMsg(priceTotal, free_shipping_price);
    }
    if(typeof klarnaUpdate === 'function') {
      klarnaUpdate(priceTotal*100);
    }
  }

function calculateQuantityPatternModal($el) {
  var qtyLimit = 0, newVal = 0;
  var qtyField = $el.closest(".qtyField"),
    oldValue = $(qtyField).find(".qty").val(),
    is_plus = false ;
  if ($el.is(".plus")) {
    newVal = parseInt(oldValue) + 1;
    is_plus=true;
  } else if($el.is(".js-qty-input")) {
    newVal = oldValue ? parseInt(oldValue) : 0;
  } else if (oldValue > qtyLimit) {
    newVal = parseInt(oldValue) - 1;
    is_plus=false;
  }
  if(isNaN(newVal)){
    newVal=1;
  }    
  $(qtyField).find(".qty").val(newVal);
  const variant_table = $(qtyField).closest('.variants-table');
  const pattern_item = $(qtyField).closest('.pattern-item');
  const is_soundscape_pattern = pattern_item.hasClass('soundscape-pattern-item');
  if(is_soundscape_pattern){
    const inputs = $(pattern_item).find('.product-form__input.qty');
    inputs.val(newVal);
  }
  const quantity_text = is_soundscape_pattern ? variant_table.find('.pattern-quantity') : variant_table.find('#qtyPatternModalB');
  const plural_text = is_soundscape_pattern ? variant_table.find('.pattern-plural') : variant_table.find('#sButtonPattern');
  const quantity_text_mobile = is_soundscape_pattern ? pattern_item.find('.mobile-footer.buy-section .pattern-quantity') : pattern_item.find('.mobile-footer .cart-btn-mobile #qtyPatternModalB');
  const plural_text_mobile = is_soundscape_pattern ? pattern_item.find('.mobile-footer.buy-section .pattern-plural') : pattern_item.find('.mobile-footer .cart-btn-mobile #sButtonPattern');
  quantity_text.html(newVal);
  quantity_text_mobile.html(newVal);
  const add_all_pattern_count = pattern_item.find('.add_all_pattern_count');
  let totalVqty = 0;
  variant_table.find('.product-form__input.qty').each(function(){
    totalVqty+=Number($(this).val());
  });
  add_all_pattern_count.html(totalVqty);
  if(newVal == 1) {
    is_soundscape_pattern ? plural_text.addClass('tw-hidden') : plural_text.hide();
    is_soundscape_pattern ? plural_text_mobile.addClass('tw-hidden') : plural_text_mobile.hide();
  } else {
    is_soundscape_pattern ? plural_text.removeClass('tw-hidden') : plural_text.show();
    is_soundscape_pattern ? plural_text_mobile.removeClass('tw-hidden') : plural_text_mobile.show();
  }
  if(is_soundscape_pattern) {
    const cart_btn = $('.js-pattern-modal-slider .pattern-item.slick-active .buy-button .submit_button');
    newVal > 0 ?  cart_btn.removeClass('disabled') : cart_btn.addClass('disabled');
    calculateSoundscapePatternSubtotal()
    
  }else {
    const productVariants = $('.js-pattern-modal-slider .pattern-item.slick-active .variant-item');
    const cart_btn = $('.js-pattern-modal-slider .pattern-item.slick-active .cart-btn .submit_button');
    const mobile_cart_btn = $('.js-pattern-modal-slider .pattern-item.slick-active .mobile-footer  .cart-btn-mobile .submit_button');
    patternsDisableBuy(productVariants, cart_btn, mobile_cart_btn);
  }
}


//Disable add to cart if all products are 0
function patternsDisableBuy($pattern_item, $cart_btn, $mobile_cart_btn) {
  if($cart_btn.hasClass('soundscape-btn')) return;
  let disable_cart_btn = true;
  $pattern_item.each(function(){
    const input_btn = $(this).find(".qtyField .product-form__input");
    if(input_btn.val() > 0) {
      disable_cart_btn = false;
      return false;
    }
  });
  if(disable_cart_btn) {
    $cart_btn.add($mobile_cart_btn).addClass("disabled");
  }else if($cart_btn.hasClass("disabled")){
    $cart_btn.add($mobile_cart_btn).removeClass("disabled");
  }
}

let productListModalPattern = "";
let patternTotalPrice = 0;
function addXitemsPattern () {
  const cart_btn = $('.js-pattern-modal-slider .pattern-item.slick-active .cart-btn .submit_button');
  if(cart_btn.hasClass("disabled")) {
    return false;
  }
  let productsToAdd = [];
  const patternItem = $('.js-pattern-modal-slider .pattern-item.slick-active');
  const isSoundsCapePattern = patternItem.hasClass('soundscape-pattern-item');
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const productVariants = $('.js-pattern-modal-slider .pattern-item.slick-active .variant-item');
  const wrapperClass = isMobile ? 'mobile-footer' : 'desktop-footer';
  const quantitySoundscapeInput = isSoundsCapePattern ? patternItem.find(`.${wrapperClass} .product-form__input.qty`)?.val() : 0;
  productVariants.each(function(){
    const $self = $(this);
    let quantity = 0;
    const id_variant = $self.find('.dropdown-patterns .drop-color').attr('data-variant');
    if(isSoundsCapePattern) {
      const patternQty = $self.find('.dropdown-patterns .drop-color').attr('pattern-qty');
      quantity = parseInt(patternQty) * quantitySoundscapeInput;
    }else {
      quantity = $self.find('.product-form__input.qty').val();
    }
    
    if(quantity > 0) {
      productsToAdd.push({id: id_variant, quantity: quantity});
    }
  });
  // add installation bundles kits section
  if(patternItem.find('.add-bundles-installation').hasClass('addedIBundle')){
    const kitId = patternItem.find('.bundle-kit-color-selected').attr("data-variant");
    const kitqty = patternItem.find('.bundle-kit-color-selected').attr("data-bundle-qty");
    productsToAdd.push({id: kitId, quantity: kitqty, isInstallationBundle: true});
  }

  JQ('#modal-patterns').modal('hide');
  // Add all the products to the cart
  addinToCartPattern(productsToAdd);
}

function calculateSoundscapePatternSubtotal() {
  let actualQty = $('.js-pattern-modal-slider .pattern-item.slick-active.soundscape-pattern-item').find('.qtyField .qty').val();
  let subtotal = 0;
  const patternTable = document.querySelector('.js-pattern-modal-slider .pattern-item.slick-active.soundscape-pattern-item');
  const selectedVariants = patternTable.querySelectorAll('.color__selected.drop-color');
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const qtyInput = isMobile ? patternTable.querySelector('.mobile-footer .product-form__input.qty') : patternTable.querySelector('.desktop-footer .product-form__input.qty');
  const subtotalElements = patternTable.querySelectorAll('.estimated-subtotal');
  selectedVariants.forEach(element => {
    const dropdownId = element.getAttribute('id');
    const variantId = element.getAttribute('data-variant');
    const dropdownSelectedElement = patternTable.querySelector(`div[id="dropdown-menu-${dropdownId}"] label[variant-id="${variantId}"] .swatchInput`);
    if($(element).hasClass('bundle-kit-color-selected')){
      const qtyKitPerPattern = $(element).attr('data-default-qty');
      const priceKit = $(element).attr('data-default-price');
      if (actualQty == 0){
        actualQty = 1;
        if($(patternTable).find('.add-bundles-installation').hasClass('addedIBundle')){
         $(patternTable).find('.add-bundles-installation').trigger('click'); 
        }
        $(patternTable).find('.add-bundles-installation').addClass('disable'); 
      }
      else {
        $(patternTable).find('.add-bundles-installation').removeClass('disable'); 
      }
      const newQty = qtyKitPerPattern * actualQty;
      const newPriceKits = newQty * priceKit;
      $(element).attr('data-bundle-qty',newQty);
      $(patternTable).find('.add-installation-accesories-container .content').text('Add ('+newQty+') Installation Bundles: '+Shopify.formatMoney(newPriceKits));
    }
    if(dropdownSelectedElement) {
      const variantPrice = dropdownSelectedElement.getAttribute('data-price-subunit');
      const patternQty = dropdownSelectedElement.getAttribute('pattern-qty');
      const variantTotal = parseInt(variantPrice) * parseInt(patternQty);
      subtotal += variantTotal;
    }
  });
  subtotal *=  qtyInput?.value;
  subtotalElements.forEach(subtotalElement => {
    subtotalElement.innerHTML = Shopify.formatMoney(subtotal);
  });
}
function addinToCartPattern(products) {
  showOverly(true);
  removeBundleAllBundlesKits();
  $("body").addClass('loading');
  let productsQuantity = 0;
  var count = 0;
  var newList='';
  products.forEach(function(product, idx, products) {
    newList = openCartModal(product.id, product.quantity, product.hasOwnProperty('isInstallationBundle'));
  })
  products = products.reverse();
  products.forEach(function(product, idx, products) {
    const discount = getDiscountPatterns(product.id, pattern_dsc_input );
    const props = {};
    if(discount !== false && localStorage.getItem('applyDiscount') == "true") props['_discount'] = discount;
    product.hasOwnProperty('isInstallationBundle') ? props['_isInstallationBundle'] = true : props['_isDecorativePattern'] = true;
    CartJS.addItem(product.id, product.quantity, props, {
      "success": function(data, textStatus, jqXHR) {
          productsQuantity += Number(product.quantity);
        // Show the cart only at the last iteration
        if (idx === products.length - 1 && newList !== false) {
          setTimeout(function() {
            showOverly(false);
            $("body").removeClass('loading');
            JQ('#added-to-cart').modal('show');
            $('#added-to-cart').addClass('patterns-cart');
            let totalPrice = '$' + patternTotalPrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").toLocaleString('en-US');
            $(".container-cart-modals .container-titles.data-wrapper").html(newList);
            $("#pdp-subtotal-modal").text(totalPrice);
            $("#pdp-subtotal-modalm").text(totalPrice);
            $("#modal-pdp-qty").html(productsQuantity);
            $("#modal-pdp-qtym").html(productsQuantity);
            $(".image-cart-modal.product-cart__img").attr("src", data.featured_image.url);
            productListModalPattern = "";
            patternTotalPrice = 0;
            if (productsQuantity > 1) {$(".pdp-modal-itm-txt").html("items");}
            else{$(".pdp-modal-itm-txt").html("item");}
          },1000);

          $('.stickyContainerIcon').show();
          setTimeout(function() {
            $('.stickyContainerIcon').hide(); 
            initQuantityTotal();
          }, 5000);
        }
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        var errormsg = JSON.parse(jqXHR.responseText).description;
        $("body").removeClass("loading");
        $(".error-message").text(errormsg);
        showOverly(true);
        $("#errorDrawer").fadeIn(500);
        drawerTimeout = setTimeout(function(){
          $("body").removeClass("loading");
          showOverly(false);
          $("#errorDrawer").fadeOut(200);
        }, 6000);
      }
    });
  });
}
function getDiscountPatterns(variant_id, dsc_input) {
  const dsc_input_val  = dsc_input.val();
  const apply_discounts = checkDateRange();
  if(dsc_input_val.length > 0 && apply_discounts) {
    const variants = dsc_input_val.split(',');
    for (let variant of variants) {
      if(variant == '') continue;
      const [id, discount] = variant.split(':');
      if(id== variant_id) return discount;
    }
  }
  return false;
}
function openCartModal (id, itemsQty, isInstallationBundle) {
  const card_item = $(`.js-pattern-modal-slider .pattern-item.slick-active .variant-item[variant-id=${id}]`);//get #item element
  if((card_item.length < 1 && !isInstallationBundle) || !id) {
    return productListModalPattern;  
  }
  let variantTitle = '';
  let nItem = '';
  let quantity = 0;
  let unitPrice = ['$', '0'];
  
  if(isInstallationBundle) {
    const dataInput = $(`.js-pattern-modal-slider .pattern-item.slick-active .dropdown-patterns .dropdown-menu-color input[data-variant="${id}"]`);
    if(dataInput.length) {
      variantTitle = 'Installation Bundle';
      nItem = dataInput.attr('data-bundle-sku');
      quantity = itemsQty ? itemsQty : 0;
      unitPrice = dataInput.attr("data-bundle-price")?.split("$")
    }
  }else {
    variantTitle = card_item.find(".data .title").text(); // product title
    nItem = card_item.find(".data .sku").attr("sku");//item
    quantity = itemsQty ? itemsQty : card_item.find('.product-form__input.qty').val(); //quantity
    unitPrice = card_item.attr("variant-price").split("$"); // get UnitPrice
  }
  const totalPrice = (Number(unitPrice[1].replace(/,/g, '')) * Number(quantity)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").toLocaleString('en');
  const itemList  = '<p id="item-'+id+'" class = "text-list">'+variantTitle+', <span class = "noItem">'+nItem+' (x'+quantity+'): </span><span class = "totalPrice">$'+ totalPrice +'</span></p>';
  patternTotalPrice = parseFloat(patternTotalPrice) +  parseFloat((Number(unitPrice[1].replace(/,/g, '')) * Number(quantity)).toFixed(2));
  productListModalPattern = productListModalPattern+itemList;
  return productListModalPattern;
}

if(isDecorativeTemplate() && $('#modal-patterns').length > 0) {
  const modal_content = $('#modal-patterns .pattern-item .item-content');
  let transform_style = false;
  let placement_style = false;
  modal_content.on('scroll', function() {
    const dropdown_color = $('.dropdown.dropdown-patterns.show');
    if(dropdown_color.length > 0) {
      const dropdown_items = dropdown_color.find('.dropdown-menu-color');
      if(transform_style == false) {
        transform_style = dropdown_items.css('transform');
        placement_style = dropdown_items.attr('x-placement');
      }else if(transform_style != false && dropdown_items.attr('x-placement') != placement_style) {
        transform_style = dropdown_items.css('transform');
        placement_style = dropdown_items.attr('x-placement');
      }else if(transform_style != false && dropdown_items.css('transform')!= transform_style && dropdown_items.attr('x-placement') == placement_style) {
        dropdown_color.trigger('click');
        transform_style = false;
        placement_style = false;
      }
    }
  });
}

//disable body scroll if pattern modal is open - just for Safari Mobile
if(isSafariMobile() && isDecorativeTemplate() && $('#modal-patterns').length > 0) {
  document.ontouchmove = function(e) {
    const $target = $(e.target);
    const modal_content = $("#modal-patterns #content_modal").get(0);
    if($('body').hasClass('modal-open') && !($target.hasClass('.modal-content') || $.contains( modal_content, $target.get(0) ))) {
      document.body.addEventListener('touchmove', preventDefault, { passive: false });
    }else {
      document.body.removeEventListener('touchmove', preventDefault);
    }
  }
}
/**
 * Check when cart flyout has class "active" visible
 */
var cartObserverClass = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if($(mutation.target).hasClass('active')) {
      flyOutValidations();
    }
  });
})

/**
 * For Sample Flyout Items we need to hide the Installation and 
 */
function flyOutValidations() {
  const totalItems = CartJS.cart.items.length;
  let totalSamples = 0;
  let totalBundles = 0;
  const divInstallation = $('.cmp-installation','#cart-drawer');
  const divCompatibleGrid = $('#gridSystemSectionCart','#cart-drawer');
  CartJS.cart.items.forEach(item => {
    if(item.sku.includes('SM') && item.product_title.includes('Sample')) {
      totalSamples++;
    }
    if(item.properties._isBundle){
      totalBundles++;
    }
  });

  divInstallation.show();
  if(totalItems == totalSamples || totalItems == 0 || totalBundles > 0) {
    divInstallation.attr('style','display: none !important')
  }
  divCompatibleGrid.show();
  if(totalSamples > 0) {
    divCompatibleGrid.hide();
  }
  setTimeout(() => {
    cartSampleDiscount()
  }, 100);
  setTimeout(() => {
    calculateAlreadyInCart();
  }, 1000);
}

$(()=>{
  // For GRID we load characteristics from product metafields
  if($('#detailSection').length) {
    renderCharacteristicsDetailsCommon(0);
  }
  if($('#cart-drawer').length){
    // Check when cart flyout has class "active" visible
    cartObserverClass.observe(document.getElementById('cart-drawer'), {
      attributes: true,
      attributeFilter: ['class']
    });
  }
})

//Cart Flyout custom Formatters 
rivets.formatters.compare = function(value,args){
  if(value != args){
    return true
  }
  else {
    return false  
  }  
}
//Format the given value to money
rivets.formatters.custom_money_format = function(value) {
  return theme.Currency.formatMoney(value * 100, theme.moneyFormat);
} 

//Cart flyout formatter for add the installation bundle price
rivets.formatters.calc_installation = function(value, installationCost) {
  if(!installationCost) return value;
  return value + (installationCost * 100);
}
//Cart flyout formatter for get the item color
rivets.formatters.get_color = function(item) {
  const defaultColor = 'White'
  if(!item) return defaultColor;
  const colorOption = item.options_with_values.find( option => option.name === 'Color');
  return colorOption ? colorOption.value :  defaultColor;
}

rivets.formatters.calc_installation_total = function(items, cart) {
  const installationCostArr = [];
  let subtotalPrice = 0;
  items.forEach(item => {
    const properties = item.properties;
    const installationCost = Object.entries(properties).find(item => item[0] === '_bundleInstallationService');
    const hasBulkProperties = Object.entries(properties).some(item => item[0] === '_bulkDiscountApplied' && typeof item[1] !== 'undefined' );
    subtotalPrice += hasBulkProperties ? item.original_line_price : item.final_line_price;
    if(installationCost && installationCost[1]) installationCostArr.push((installationCost[1] * 100));
  });
  if(installationCostArr.length === 0) return subtotalPrice;
  const installationCostTotal = installationCostArr.reduce((a, b) => a + b, 0);
  return subtotalPrice + installationCostTotal;
}

rivets.formatters.checkVendorLogo = function (items, cartIndexVal) {
  const armstrongLogo = $('.mini-products-list[armstrong-img-logo]')?.attr('armstrong-img-logo');
  const singleItems = $('.pdp-shipedy-by-container-cart-product.single-vendor-item');
  const InstallElement = $('.cartItemsId').find('.cmp-installation','#cart-drawer');
  let displayVendor = false;
  let vendor = '';
  let vendorHtmlWrapper = ``;
  let vendorHtml = ``;
  let isMixedVendor = false;
  if(items.length > 0) {
    vendor = items[0].vendor;
    displayVendor = true;
    items.forEach(item => {
      if(
        !['Cooledge','Spacekit'].includes(item.vendor) && 
        !item.sku.startsWith('SM')
      ){
        isMixedVendor = true;
      }
      if(vendor != item.vendor) {
        displayVendor = false;
      }
    });
  }

  if((isMixedVendor && cartIndexVal != false)) {
      InstallElement.show();
  } else {
      InstallElement.hide();
  }
  if(displayVendor) {
    vendorHtml =`<img class="vendor-flyout-logo" src="${armstrongLogo}" />`;
    if(vendor == 'Cooledge') {
      const cooledge_vendor = $('.mini-products-list[armstrong-cooledge-vendor]')?.attr('armstrong-cooledge-vendor');
      vendorHtml = cooledge_vendor;
    }
    if(vendor == 'Spacekit') {
      const spacekit_vendor = $('.mini-products-list[armstrong-spacekit-vendor]')?.attr('armstrong-spacekit-vendor');
      vendorHtml = spacekit_vendor;
    }
    vendorHtmlWrapper = `
    <div class="pdp-shipedy-by-container-cart" >
      <div class="pdp-shipedy-by-cart pdp-shipedy-by-flyout">
        <span> Product(s) sold and shipped by</span>
        <span>${vendorHtml}</span>
      </div>
    </div> 
    `;
  }
  singleItems.each(function() {
    const item = $(this);
    if(displayVendor) {
      item.addClass('d-none');
    }else {
      item.removeClass('d-none');
    }
  });
  
  return vendorHtmlWrapper;
}

const discountAplicableZipcode = localStorage.getItem('applyDiscount')=='true'

function displayInitialDiscount() {
  if(discountAplicableZipcode && $('.perAmountSqFtBlock.showDiscount').length>0 && typeof gvariant !== 'undefined' && getDiscountBase(gvariant.id, regular_dsc_input) !== false ) {
    $('.perAmountSqFtBlock.showDiscount').addClass('d-block');
    $('.product-price__units').addClass('d-none');
    $('.discounted_price.showDiscount').addClass('d-block');
    $('.product-price-quantities.no-showDiscount').addClass('isDiscount').addClass('text-right');
    $('.tile_pdp_price.no-showDiscount').addClass('d-none');
  }
}

setTimeout(function(){//adding time out for the options on the PDP to load and then setting up the variant options with discount
  let options =[];
  let variantId =0;
  const url = window.location.href;
  const hasVariantParameter = url.includes('?variant') ? true : false;
  if(Shopify.availableVariant) {
    options = Shopify.availableVariant?.options?.split(';');
    variantId = Shopify.availableVariant?.variantId
  }else{
    for (let key in Shopify.productMeta) { 
      const discount = getDiscountmain(key)
      let value;
      if(discount>0){
        options = Shopify.productMeta[key].optionsForDiscount.split(';');
        variantId = key
        break
      }
    }
  }
  if(variantId>0 && discountAplicableZipcode && !hasVariantParameter) {
    $("#"+options[0]).click(); 
    $("#"+options[1]).click();
    updateDiscountVariant = true;
    const swatch = $("li[data-value='"+options[2]+"'"); 
    const imgId = swatch.find('.swatch-color').attr('data-image-id');
    const img = $('.product-single__thumbnail .product-single__thumbnail-image[data-image-id="'+imgId+'"]')[0]	;
    setTimeout(function(){
     img?.click();
    },700);
    swatch.click();
  }
  updateDiscountVariant = false;
  
  const currentColorOnLoad = $(".tile-template__container li.swatch-item.current-color, .wall-template__container li.swatch-item.current-color").attr("data-value")
  if(currentColorOnLoad && !isSpaceKitTemplate()) {
    if($(".option3 .product-form__item .header .slVariant").length) {
      $(".option3 .product-form__item .header .slVariant").html(currentColorOnLoad);
    }else{
      // to work with default template
      if($(".option1 .product-form__item .header").length && $(".option1 .product-form__item .header").html().includes('Color')) {
        $(".option1 .product-form__item .header").html("Color: <span class='slVariant'>"+currentColorOnLoad+"</span>");
      } else {
        if ($(".option3 .product-form__item .header").html().includes('Pattern')){
          $(".option3 .product-form__item .header").html("Pattern: <span class='slVariant'>"+currentColorOnLoad+"</span>");
        }else {
          $(".option3 .product-form__item .header").html("Color: <span class='slVariant'>"+currentColorOnLoad+"</span>");
        }
      }
    }
  }
},500)

function getDiscountmain(variant_id) {
  const dsc_input_val  = regular_dsc_input?.val();
  if(dsc_input_val) {
    const discountAplicableZipcode = localStorage.getItem('applyDiscount')=='true'
    const dsc_start_date = $('body').attr('start_date');
    const dsc_end_date = $('body').attr('end_date');
    let apply_discounts = false;
    if(dsc_start_date.length > 0 && dsc_end_date.length > 0) {
      const now = new Date();
      const start_date = new Date(dsc_start_date * 1000);
      const end_date = new Date(dsc_end_date * 1000);
      if(now > start_date && now <= end_date) {
        apply_discounts = true;
      }
    }
    if(dsc_input_val.length > 0 && apply_discounts && discountAplicableZipcode ) {
      const variants = dsc_input_val.split(',');
      const discount = variants[0];
      for (let variant in variants) {
        if(variant == 0) continue;
        if(variants[variant] == variant_id) return discount;
      }
    }
  }
  return false;
}

const cartSampleDiscount=() => {
  $('.text-muted.this_is_sample').each(function(){
    if($(this).text()=="_sample: 1"){
      $(this).parents('li.grid').addClass('sample-line-item')
    }
  })
  $('.sample-line-item .product-price.cart_discount_flyout').each(function(){
    if($(this).text()=="$0.00"){
      $(this).text("FREE")
    }
  })
}

//Already in cart item calculation
function calculateAlreadyInCart(){
  // validate in /cart when CartJS.cart.items seems to not be loaded correctly
  if(typeof CartJS.cart.items =='undefined' && typeof CartJSItems != 'undefined'){
    CartJS.cart.items = CartJSItems;
  }
  $('.alreadyCart p').hide();
  const items = CartJS.cart.items;
  const discountActive = checkDateRange();
  const discountAplicableZipcode = localStorage.getItem('applyDiscount') == 'true';

  let totalUpsellQty = 0;
  items.forEach(i=>{
    const elem = $('.already-in-cart-'+i.variant_id);
    const qty = elem.closest('.product-info').find('.product-form__input.qty');
    var bundle = elem.closest(".product-info").find(".qtyField").attr('data-bundle');
    var isModal = '';
    let $price_item =  ($(`${isModal}.total-gr-price-${bundle}.discount`).length > 0 && (discountActive && discountAplicableZipcode) ) ? $(`${isModal}.total-gr-price-${bundle}.discount`) : $(`${isModal}.total-gr-price-${bundle}:not(.discount)`);
    if(elem.length>0){
      elem.show();
      totalUpsellQty+=i.quantity;
      elem.find('small').html(i.quantity);
      qty.val(1);
    }
  });
  if(totalUpsellQty>0){
    $('.already-in-cart-mobile').show();
    $('.already-in-cart-mobile').find('small').html(totalUpsellQty);
  }else{
    $('.already-in-cart-mobile').hide();
  }
}

setTimeout(() => {
  cartSampleDiscount()
  calculateAlreadyInCart()
}, 600);

function buildCharacteristicsIcons(data) {
  const productTags = Object.values(data.tags);
  // characteristicsImages is base for displaying the icons based on the configuration done in theme settings
  let html = '';
  html = '<div class="characteristics">';
  html += '<div class="characteristics-icons"><ul>';
  let count = 0;
  for (var i = 0; i < productTags.length; i++) {
    if (count == 6) {
      break;
    } else if (count < 6 && typeof characteristicsImages != 'undefined' && characteristicsImages[productTags[i]]) {
      html += '<li class="characteristic-item"><img class="tag-icon" src="' + characteristicsImages[productTags[i]] + '"/><span class="tooltip-label">' + productTags[i] + '</span></li>';
      count++;
    }
  }
  html += '</ul></div></div>';
  return html;
}

function buildProductColorSwatches(colorArr) {
  let colorHtml = `<ul class="custom-color-swatch-list">`;
  colorArr.forEach(color => {
    const colorClass = color.toLowerCase().replace(/ /g, '-');
    const borderClass =
    color.toLowerCase().includes('white') || color.toLowerCase().includes('standard')
      ? 'default-border'
      : 'border-none';
      colorHtml += `<li class="item-color compare-item swatch-item swatch-element swatchLbl color lazyloaded" aria-label="color:${color}"><span class="${borderClass} swatch-color swatchLbl swt${colorClass}"></span><span class="tooltip-label"><p class="color-title">${color}</p></span></li>`;
  });
  colorHtml += `</ul>`;
  return colorHtml;
}

//Wholesale Custom Configuration 
$( document ).ready(function() {
  if (Shopify.country == 'CA') {
    isWsgCustomer = false;
    $('.product-price__units').removeClass('hide');
  }
  
  if ( (typeof isWsgCustomer !== 'undefined' && isWsgCustomer) && (isTileTemplate() || isCoolEdgeTemplate() || isWallTemplate() || isDefaultTemplate() || isDecorativeTemplate() || isBundleTemplate() || isSpaceKitTemplate())) {
    $(".banner-product-label-price").addClass('banner-product-label-price_wholesale').removeClass('banner-product-label-price');
  }
  document.addEventListener('wsgAjax', event => {
    if(isWsgCustomer && isDecorativeTemplate()){
      isWsgCustomer = false;
      $("#price-sticky-wholesale").hide();
    }
    if ( isWsgCustomer && isGridTemplate()) {
        updateGridPDP();
        
    }else{
      $('.product-price__units').removeClass('hide');
    }
  });
});

function checkWholesaleChanged() { 
  if(isQuickView()) return; 
  $('.tile_pdp_price.product-price__price').on('DOMSubtreeModified', function(){
    let priceW = $(".tile_pdp_price.product-price__price").html();
    priceW = priceW.replace('$','').replace('.','').replace(',','');
    priceW = parseInt(priceW, 0);
    if(priceW > 0){
      updateWholesale(gvariant.id);
      validateButton();
    }
  });
}

function updateWholesale(selected_vId) {
  if ( isWsgCustomer && (isTileTemplate() || isCoolEdgeTemplate() || isWallTemplate() || isDefaultTemplate() || isDecorativeTemplate() || isBundleTemplate() || isSpaceKitTemplate())) {
    if(lastVariantSelected == selected_vId){
      return 0; 
    }
    lastVariantSelected = selected_vId;
    let metafields = Shopify.productMeta[selected_vId];
    var price_section = $(".product-price__price_wholesale");
    $(".accordion-text-footer").addClass('accordion-text-footer_wholesale').removeClass('accordion-text-footer');
    $('.accordion-text-footer_wholesale').css('display','block');
    
    const pid = $(".product-template__container").attr("data-pid");
    const wsgProduct = isWholesaleProduct(pid);
    gvariant.isWholesale = false;
    if(wsgProduct){
      if(wsgProduct.variants.length == 0){
        gvariant.isWholesale = true;
      } else {
        let wsVariant = wsgProduct.variants.find(v => v.variant_id == selected_vId);
        gvariant.isWholesale = wsVariant ? true: false;
      }
    }
    

    var priceW = $(".tile_pdp_price.product-price__price").html();
    var priceW = priceW.replace('$','').replace('.','').replace(',','');
    let sqftPerCarton = parseInt(metafields.sqftPerCarton, 0);
    let pricepersqft =  sqftPerCarton > 0 ? priceW/sqftPerCarton : 0;
    gvariant.price = priceW;
    let [regularPrice, label_sqft,discount, main_price_label] = productPriceArray.split(';');
    let mainPricePdp = '';
    let classNoborder = 'noborder';
    if(!isCoolEdgeTemplate() && !isSpaceKitTemplate()) {
      classNoborder = '';
      mainPricePdp += `
      <span class="price-per-sqft-wrapper">
        <span class="product-price__tilesqft">${ Shopify.formatMoney(pricepersqft) }</span> /${ label_sqft }
      </span>`;
    }
    mainPricePdp += `
    <span class="product-price__dualholder ${ classNoborder }">
      <span class="coverageinfo ${ isDefaultTemplate()?'hide':'' }">Covers <span class="coverageinfo__sqft">${ metafields.sqftPerCarton }</span> sq. ft.</span>
      <span>
          <span id="ProductPrice-product-template-tile" class="product-price__carton">${ Shopify.formatMoney(priceW) }</span> /${ main_price_label }
      </span>
    </span>`;

    if(isDefaultTemplate()) {
      $('.product-price__tilesqft').html(Shopify.formatMoney(pricepersqft));
      $('#ProductPrice-product-template').html(Shopify.formatMoney(priceW));
      let tplMain = $('#tilesAmountTPL').html();
      $(price_section).html(tplMain);
      if(pricepersqft == 0){
        $(price_section).find('.product-price__tilesqft').parent().remove();
      }
    } else {
      $(price_section).html(mainPricePdp);
    }
    if(gvariant.isWholesale){
      $('#price-sticky').addClass("hide");
      $('#tilesAmount').addClass("hide");
      price_section.removeClass('hide d-none');
    } else {
      const discountbyZipcode = localStorage.getItem('applyDiscount')=='true'
      if(discountbyZipcode && $('#tilesAmount').hasClass('showDiscount') && checkDateRange() ){ 
        $('#tilesAmount').removeClass('hide d-none');
        price_section.addClass('hide d-none');
        $('.perAmountSqFtBlock').css('opacity','1');
      }else{
        price_section.removeClass('hide d-none');
        $('#tilesAmount').addClass('hide d-none');
      }
    }
   
  } 
};

function updateGridPDP(){
  const dataProduct = wsgProdData;
  const pid = dataProduct.id
  var gridCards = $('.variant-accordion-card');
  $('.accordion-text-footer').addClass('accordion-text-footer-wholesale').removeClass('accordion-text-footer').show();
  $(gridCards).each(function (index,element){
    $(element).find('.product__variant-checkbox').attr('iswholesale','false');
    const vid = $(element).find('.product__variant-checkbox').attr('color-s');
    let containerDiscount = $(element).find('.discounted_price-'+vid);
    let flagDiscount = $(containerDiscount).hasClass('showDiscount');
    const vData = getVariantData(vid);

    const wsProduct = isWholesaleProduct(pid);
    $('#price-sticky-wholesale').removeClass('hide');
    $('#price-sticky-m-wholesale').removeClass('hide');
    if (wsProduct && wsProduct.variants.length > 0 ){
      if(flagDiscount){
        $(element).find('.discount-wrapper').addClass('hide');
        $(element).find('.wholesale-wrapper').removeClass('hide');
      }
      const wsVariant = getVariantWholesale(wsProduct,vid);
      if(wsVariant){
        let newPrice =0;
        if(wsVariant.discountType == 'fixed'){
          newPrice = wsVariant.amount;
        }
        if(wsVariant.discountType == 'percent'){
          newPrice = wsVariant.amount*vData.price;
        }
        
        $(element).find('.wholesale-wrapper > p > strong').html(Shopify.formatMoney(newPrice));
        //change price in pdp to calculate
        $(element).find('.discounted_price > p > strong').html(Shopify.formatMoney(newPrice));
        $(element).find('.product-price-quantities > p > strong').html(Shopify.formatMoney(newPrice));
        $(element).find('.product__variant-checkbox').attr('iswholesale',true);
        
      } else {
        $(element).find('.discount-wrapper').removeClass('hide');
        $(element).find('.wholesale-wrapper').addClass('hide');
      }
    }
    if (wsProduct){
      $('.perAmountSqFtBlock').addClass('hide'); //hide discounts to gridpdp if wholesale is active
      $('.product-price__units').removeClass('d-none');
      const firstVariantPriceWholesale = getVariantData(wsProduct.variants.length > 0 ? wsProduct.variants[0].variant_id : wsgCurrentVariant).price;
      const currentPrice = wsProduct.variants.length > 0 ? wsProduct.variants[0].discountType === "fixed" ? wsProduct.variants[0].amount : firstVariantPriceWholesale *  wsProduct.variants[0].amount : wsProduct.discountType === "fixed" ? wsProduct.amount : wsgProdData.variants[0].price * wsProduct.amount ;
      const firstVariantMetafields = Shopify.productMeta[wsProduct.variants.length > 0 ? wsProduct.variants[0].variant_id : wsgCurrentVariant];
      var pricePerSqft = currentPrice/parseInt(firstVariantMetafields.sqftPerCarton);
      $('.normal-price > strong').html(Shopify.formatMoney(pricePerSqft));
    } 
  })
  
  initPriceSubtotalGrid(free_shipping_price);
  $('.product-price__units').removeClass('hide');
}

function updateTileUpsell(){
    //Verificar si el producto esta en descuento
    var upsell_cards = $('.upsell-product-card');
    
    upsell_cards.each(function( index, element ) {
      const pid = $(element).attr('data-product-id');
      const starting_at = $(element).attr('starting-at') === 'true' ? "Starting at":"";
      if ($(element).find('.ribbon').hasClass('product_with_discount')){
        //validate if has wholesale
        if (isWholesaleProduct(pid)){
          const vsqft = $(element).attr('data-sqft');
          const wholesalePrice = $(element).find('.upsell-prices.normal_v').html().replace('$','').replace('.','').replace(',','');
          //calc data 
          const pricepersqft = wholesalePrice/vsqft;
          const html = '<div class="copy_compare_starting_at">'+starting_at+'</div><span class="price-sqft">'+Shopify.formatMoney(pricepersqft)+'</span><span class="sqft-label">/sq. ft.</span><span class="price">('+Shopify.formatMoney(wholesalePrice)+'/carton)</span>'
          setTimeout(() => {
            $(element).find('.upsell-prices-wholesale').html(html);
            $(element).find('.upsell-prices_discount').hide();
            $(element).find('.upsell-prices-wholesale').show();
            $(element).find('.ribbon-content.discount_v').hide();
            $(element).find('.ribbon-content.normal_v').show();
            $(element).find('.ribbon').removeClass('product_with_discount');
          }, 1000);
        }
      }else {
          if(typeof ($(element).find('.upsell-prices.normal_v').html()) !== 'undefined'){
            const vsqft = $(element).attr('data-sqft');
            const normalPrice = $(element).find('.upsell-prices.normal_v').html().replace('$','').replace('.','').replace(',','');
            //calc data 
            const pricepersqft = normalPrice/vsqft;
            const html = '<div class="copy_compare_starting_at">'+starting_at+'</div><span class="price-sqft">'+Shopify.formatMoney(pricepersqft)+'</span><span class="sqft-label">/sq. ft.</span><span class="price">('+Shopify.formatMoney(normalPrice)+'/carton)</span>'
            setTimeout(() => {
              $(element).find('.upsell-prices-wholesale').html(html);
              $(element).find('.upsell-prices-wholesale').show();
              $(element).find('.upsell-prices.normal_v').hide();
            }, 1000);
          }
      }
    })
    
    
}

function updateGridUpsell(){
  var productsGrid = $('.grid-system-container');
  
  productsGrid.each(function (index, element){
    $(element).each(function (i,el){
      
      const pid = $(el).find('.product-info').attr('data-product-id');
      const vid = $(el).find('.product-form__item--quantity').attr('data-id');
      dataWS = isWholesaleProduct(pid);
      if(dataWS){
        const wsVariant = getVariantWholesale(dataWS,vid); 
        if(wsVariant){
          if(wsVariant.discountType == 'fixed'){
            $(el).find('.regular-wrp').find('#slider-price-'+vid).html(Shopify.formatMoney(wsVariant.amount));
            $(el).find('.product-form__item--quantity').attr('data-price',wsVariant.amount);
            gridUpsellCard_hasDiscount(el)
          }
          if(wsVariant.discountType == 'percent'){
            const regularP = $(el).find('.item').attr('data-regular-price');
            let newPrice = (regularP*wsVariant.amount); 
            $(el).find('.regular-wrp').find('#slider-price-'+vid).html(Shopify.formatMoney(newPrice));
            $(el).find('.product-form__item--quantity').attr('data-price',newPrice);
            gridUpsellCard_hasDiscount(el)
          }
        }else{
            if(dataWS.variants.length == 0 && dataWS.amount !== 1){
              if(dataWS.discountType == 'fixed'){
                $(el).find('.regular-wrp').find('#slider-price-'+vid).html(Shopify.formatMoney(dataWS.amount));
                $(el).find('.product-form__item--quantity').attr('data-price',dataWS.amount);
                gridUpsellCard_hasDiscount(el);
              }
              if(dataWS.discountType == 'percent'){
                const regularP = $(el).find('.item').attr('data-regular-price');
                let newPrice = (regularP*dataWS.amount); 
                $(el).find('.regular-wrp').find('#slider-price-'+vid).html(Shopify.formatMoney(newPrice));
                $(el).find('.product-form__item--quantity').attr('data-price',newPrice);
                gridUpsellCard_hasDiscount(el);
              }
            }
        }
      }
    });
  });
  setTimeout(() => {
    CalculateNewTotal();
  }, 1000);
  
}

function gridUpsellCard_hasDiscount (element){
  if ($(element).find('.regular-wrp').hasClass('has-discount')){
    $(element).find('.regular-wrp').removeClass('has-discount');
    $(element).find('.promotion-wrp').addClass('hide');
    $(element).find('.product-form__item--quantity').removeAttr('data-discount-price');
  }
}

function isWholesaleProduct(productId){
  const result = wsgData.discounts?.filter( product => product.product_id == productId && wsgCustomerTags.includes(product.tags));
  if (typeof result === 'undefined' || typeof (result[0]) === 'undefined') {
    return false
  }else { return result[0] }
}

function getVariantWholesale (wsObject,variantId){
  if(typeof(wsObject.variants) !== 'undefined'){
    var dataV = wsObject.variants.filter( variant => variant.variant_id == variantId);
    if(typeof(dataV) !== 'undefined')
      return dataV[0];
  }else{
    return false
  }
}

function getVariantData(vid){
  const temp =  wsgProdData.variants.filter(variant => variant.id == vid);
  return temp[0];
}

function CalculateNewTotal(){
  const gridUpsellContainer = $('.parent-grid-system-container');
  gridUpsellContainer.each(function(index,element){
    var total = 0;
    const productsGrid = $(element).find('.grid-system-container');
    productsGrid.each(function(i,el){
      let itemPrice;
      let item = $(el).find(".product-form__item--quantity");
      let qty = $(el).find(".product-form__input.qty").val();
      if(item.attr('data-discount-price')){
        itemPrice = parseInt(item.attr('data-discount-price'));
      }else{
        itemPrice = parseInt(item.attr('data-price'));
      }
      total += parseInt(itemPrice * qty);
    });
    $(element).parent().parent().find('.total-bundle')
      .attr('total',total)
      .html(`<b>${ Shopify.formatMoney(total) }</b>`);
  })
}

//Save on localStorage if the current user is a wsg user.
document.addEventListener('wsgAjax', event => { 
  localStorage.setItem('isWsgCustomer', isWsgCustomer);
});

var galleryProductPriceUnits = [];
var galleryProductPriceArray = [];
var galleryProductTemplate = [];
var galleryProductLowestVariantId = [];

const getHandlesInGallery = () => {
  const galleryCards = $('.evm_shop_now_container a');
  let handles  = $.map(galleryCards, (i)=> $(i).attr('href').split('/').pop());
  handles = handles.filter(handle => handle !== '' && !Object.keys(galleryProductPriceArray).includes(handle));
  const uniqueHandles = [...new Set(handles)];
  const dataGet = {
    "view": "api-gallery",
    "product_handles": uniqueHandles.join(','),
    "cache": false,
    "type": Math.round(new Date().getTime()/1000),
    "country":Shopify.country+'-'+Shopify.locale
  };
  if(uniqueHandles.length > 0) {
    $.get( `/`,dataGet, function( data ) {
      $(data).appendTo('body');
      changeCardgallery(galleryCards);
    }); 
  }else{
    changeCardgallery(galleryCards);
  }
};

const changeCardgallery = (galleryCards) => {
  galleryCards.each((index,element)=>{
    const handle = $(element).attr('href').split('/').pop();
    const divPrice = $(element).closest('.evm_lookbook_detail').find('.evm_product_price');
    if(galleryProductPriceArray[handle]) {
      let [regularPrice, label_sqft,discount, main_price_label] = galleryProductPriceArray[handle].split(';');
      label_sqft = label_sqft.replaceAll('/','');
      if(parseInt(regularPrice.replace('$',''),0) > 0){
        const pricelabel = `<span>Starting at</span><br /><b>${regularPrice}</b> /${label_sqft}`;
        divPrice.html(pricelabel);
      }
    }
  });
};

const checkGallery = () => {
  $("#sidenav li.gallery").prev().addClass('no-margin-right');
  var lookbookInterval = setInterval(function () {
    var $lookbookGrid = $('div[id^="evm-lookbook-"]');
    
    if ($lookbookGrid.length > 0) { // If the grid has items in it, show the gallery title
        
        if ($lookbookGrid.children().length > 0) {
            $("#sidenav li.gallery").show();
            $("#sidenav li.gallery").prev().removeClass('no-margin-right');
            
            $(".prod-gallery.prod-gallery-slider").parent().removeClass('hidden');
            $(".prod-gallery.prod-gallery-slider h2").show();
            getHandlesInGallery();
            // Stop checking for lookbook grid
            clearInterval(lookbookInterval);

            var divIconPrev = document.createElement("div");
            divIconPrev.className = "div-prev";

            var divIconNext = document.createElement("div");
            divIconNext.className = "div-next";

            var lSAction = document.getElementsByClassName("lSAction");
            if(lSAction.length) {
              lSAction[0].prepend(divIconPrev);
              lSAction[0].append(divIconNext);
            }
        }
    }
  }, 500);
}

const updateBundleTable = () => {
  const quantity = $('#quantity').val();
  $('#bundle-description-qty').html(`Based on your selections, your bundle${ quantity > 1 ? 's' : '' } will include the following components:`);
  $('.bundle-calc-qty').each((index,element) => {
    const qty_col = $(element).attr('data-qty') * quantity;
    $(element).html(`${qty_col} carton${qty_col > 1 ? 's' : '' }`);
  });
}

$(() => {
  checkGallery();
})

$(document).on("click", '#flyout-cta #cartDWcheckout, .custom-add-to-cart-modal .product-cart__actions #cartDWcheckout, #cartCheckout', async function(e) {
  e.preventDefault();
  const suscribeInstallationId = $('#installationVarId').val()
  const data = await $.getJSON('/cart.js');
  const totalProductInstallation = data.items.reduce((acc, item) => {
    if(item.properties && item.properties._bundleInstall && item.properties._bundleInstallationService) {
      return acc + parseInt(item.properties._bundleInstallationService);
    }
    return acc + 0;
  }, 0);
  const payload = {
    updates: {
      [suscribeInstallationId]: totalProductInstallation
    }
  };
  $.post('/cart/update.js', payload, function(data) {
    localStorage.setItem('cart-before-checkout', JSON.stringify(data));
    location.href = '/checkout';
  }, "json");
});

$('.add-bundles-installation').on("click", async function(e) {
  if(!$(this).hasClass('disable')){
    $(this).toggleClass( "addedIBundle" );
    let format_id = "add-installation-kit-"+ $(this).data("id") ;
    $(this).parents().find("#"+format_id).slideToggle("slow");
  }
});


// Tax Exemp Modal
$('.tax-exemp-link').on("click", function(){ JQ('#modal-tax-exemption').modal('show');});

// Installation Expect Modal
$('.installation-what-expect-link').on("click", function(){JQ('#modal-installation-what-expect').modal('show');});

// Accostic Tool Modal
$('.listening-area-link').on("click", function(){JQ('#modal-listening-area').modal('show');});
JQ('#modal-listening-area').on('hidden.bs.modal', function () {
  const stopVideoEvent = document.querySelector('.event-stop-video');
  stopVideoEvent && stopVideoEvent.click();
});

// Installation Quotes Modal
$(document).on("click", '.installation-quotes', function(){JQ('#modal-installation-quote').modal('show');});
JQ('#modal-installation-quote').on('hidden.bs.modal', function () {
  $("#modal-installation-quote .modal-body .content").html('');
  var newScript = document.createElement("script");
  var inlineScript = document.createTextNode("hbspt.forms.create({portalId:'20049184', formId:'f4261447-7af0-46bf-b578-7d1948949f60', version:'V2_PRERELEASE', region: 'na1'});");
  newScript.appendChild(inlineScript); 
  var target = document.querySelector("#modal-installation-quote .modal-body .content");
  target.appendChild(newScript);
});

//Hubspot form listener
window.addEventListener('message', event => {
  if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {

    switch( form_id ){
      case "f4261447-7af0-46bf-b578-7d1948949f60":
        value = 'Installation Request';
        label = "Goal 5";
        break;
      case "cb9a45ec-35a4-4840-b49a-c75487484111":
        value = 'Installation Request_1';
        label = "Goal 5";
        break;
      case "8c34ba3b-83c7-4e8d-88b7-a5e2d05142ec":
        value = 'Installation Request _Ceiling Refresh';
        label = "Goal 5";
        break;
      case "96b22b35-ef04-47ff-9aa8-e3abea7794b9":
        value = 'Facility Management Group Form';
        label = "Goal 5";
        break;
      case "05238aa9-e400-4245-bf3f-30705333286d":
        value = 'Installation Request HTA';
        label = "Goal 5";
        break;
      
      default:
        sendEvent = false;
        break;
    }

      //If this form id is in the list, fire off the bing tracking event.
      if( sendEvent == true ){

        //Push event to bing
        window.uetq = window.uetq || [];
        window.uetq.push('event', 'Submit Lead Form', {"event_category":value});

        //Push event to GTM
        dataLayer.push({
          'event': 'hubspot-form-success',
          'category': 'Hubspot',
          'action': 'Form Submit',
          'label': label,
          'value': value,
          'hs-form-guid': event.data.id
        });

      }
  }
});

function validateInput(input) {
  const hasValue = (input && input.value)? true : false;
  if(!hasValue) input.classList.add('input--error');
  else input.classList.remove('input--error');
  return hasValue;
}
function kGetCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function kSetCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function kGetCookieArray(cname) {
  var cookie = kGetCookie(cname);
  return cookie ? JSON.parse(cookie) : [];
}

function kPushToCookieArray(cname, cvalue, exdays) {
  var cookieArray = kGetCookieArray(cname);
  cookieArray = cookieArray.slice(-4);
  if (cvalue !== '' && !cookieArray.includes(cvalue)) {
    cookieArray.push(cvalue);
    // showRecentProducts();
  }
  cookieArray = cookieArray.slice(-4);
  kSetCookie(cname, JSON.stringify(cookieArray), exdays);
}

function showRecentProducts(){
  pfs_section();
  if(/^\/(products|collections|cart|blogs)/.test(location.pathname) ||
    /en\-ca\/(products|collections|cart|blogs)/.test(location.pathname) ||
    /fr\-ca\/(products|collections|cart|blogs)/.test(location.pathname)) {
      if($('#recent-container').length) renderRecentlyViewedCards();
    jQ(window).resize(function () {
      setTimeout(() => {
        equalHeightViewed();  
      }, 200);
    });
  }
}
function pfs_section(){
  let productsViewed = kGetCookieArray('recentproducts');
  handles = productsViewed.map(element => {
    const [handle, productTitle, productId] = element.split('--');
    return handle;
  });
  
  request = new XMLHttpRequest();
  request.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      sections = JSON.parse(request.responseText);

      // Prepare initial temp node
      product_attributes = document.createElement('div');
      product_attributes.innerHTML = sections['boost-pfs-product-attributes'];

      // Extract script portion
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.text = product_attributes.getElementsByClassName('shopify-section')[0].innerHTML;

      // Inject JS in DOM
      document.body.appendChild(script);
    }
  }
  request.open('GET', `${location.protocol}//${location.host}${location.pathname}/?sections=boost-pfs-product-attributes&viewed_handles=${handles.join(',')}`, false);
  request.send();
}
$(document).ready(function(){
  showRecentProducts();
  if (window.location.hash.substr(1) === 'openchat') {
    LiveChatWidget.call("maximize");
  }
});

//Check if variant id has bulkDiscount
function hasBulkDiscount(variant_id, bulk_input) {
  const inputVal = bulk_input?.val();
  const variants = inputVal.split(',');
  return variants.some(variant => variant == variant_id);
}

//Add Bulk discount properties to line_item if needed
function checkBulkDiscount(properties, variant_id, bulk_input) {
  const inputVal = bulk_input?.val();
  if(
    properties.hasOwnProperty('_discount') || 
    properties.hasOwnProperty('_volumeDiscount') || 
    localStorage.getItem('applyDiscount') != "true" || 
    typeof bulkCategories === 'undefined' || 
    inputVal?.length === 0) {
      return properties;
  }
  const variants = inputVal.split(',');
  const bulkCategory = variants[0];
  const hasBulkDiscount = variants.some(variant => variant == variant_id);
  if(hasBulkDiscount) {
    const discounts = JSON.parse(bulkCategories)?.find(item => item.category === bulkCategory);
    if(discounts && Object.keys(discounts).length > 0) {
      const message = typeof discounts.message !== 'undefined' ? discounts.message : '';
      let values = [`${discounts.type}`, `${message}`];
      for (let discount of discounts.values) {
        const values_string = `${discount.quantity}:${discount.value}`;
        values.push(values_string);
      }
      properties['_bulkDiscount'] = discounts.category;
      properties['_bulkDiscountData'] = values;
    } 
  }
  return properties;
}

//check if variant is ltl only
function checkLtlOnly(variant_id, ltl_input) {
  const inputVal = ltl_input?.val();
  if(inputVal?.length === 0) return [];
  const variants = inputVal.split(',');
  const is_ltl_only = variants.some(variant => variant == variant_id);
  return [variants[0], is_ltl_only];
}

